// AUTO-GENERATED from the official 2025 GIS dataset
// (thanglequoc/vietnamese-provinces-database, MIT) — danh mục 34 tỉnh /
// 3321 phường-xã sau sáp nhập 01/07/2025. Catalog only (no polygons — those
// live in the Ward DB table, seeded by packages/db/seed-wards.ts).
// Regenerate: see scripts note in seed-wards.ts. Do not edit by hand.

// Official numeric province code as string ("79" = Hồ Chí Minh).
export type VnProvince2025 = { code: string; name: string; fullName: string };
// c = official ward code, n = full ward name ("Phường Gia Định"), p = province code.
export type VnWard2025 = { c: string; n: string; p: string };

export const VN_PROVINCES_2025: readonly VnProvince2025[] = [
  { code: "01", name: "Hà Nội", fullName: "Thành phố Hà Nội" },
  { code: "04", name: "Cao Bằng", fullName: "Tỉnh Cao Bằng" },
  { code: "08", name: "Tuyên Quang", fullName: "Tỉnh Tuyên Quang" },
  { code: "11", name: "Điện Biên", fullName: "Tỉnh Điện Biên" },
  { code: "12", name: "Lai Châu", fullName: "Tỉnh Lai Châu" },
  { code: "14", name: "Sơn La", fullName: "Tỉnh Sơn La" },
  { code: "15", name: "Lào Cai", fullName: "Tỉnh Lào Cai" },
  { code: "19", name: "Thái Nguyên", fullName: "Tỉnh Thái Nguyên" },
  { code: "20", name: "Lạng Sơn", fullName: "Tỉnh Lạng Sơn" },
  { code: "22", name: "Quảng Ninh", fullName: "Tỉnh Quảng Ninh" },
  { code: "24", name: "Bắc Ninh", fullName: "Tỉnh Bắc Ninh" },
  { code: "25", name: "Phú Thọ", fullName: "Tỉnh Phú Thọ" },
  { code: "31", name: "Hải Phòng", fullName: "Thành phố Hải Phòng" },
  { code: "33", name: "Hưng Yên", fullName: "Tỉnh Hưng Yên" },
  { code: "37", name: "Ninh Bình", fullName: "Tỉnh Ninh Bình" },
  { code: "38", name: "Thanh Hoá", fullName: "Tỉnh Thanh Hoá" },
  { code: "40", name: "Nghệ An", fullName: "Tỉnh Nghệ An" },
  { code: "42", name: "Hà Tĩnh", fullName: "Tỉnh Hà Tĩnh" },
  { code: "44", name: "Quảng Trị", fullName: "Tỉnh Quảng Trị" },
  { code: "46", name: "Huế", fullName: "Thành phố Huế" },
  { code: "48", name: "Đà Nẵng", fullName: "Thành phố Đà Nẵng" },
  { code: "51", name: "Quảng Ngãi", fullName: "Tỉnh Quảng Ngãi" },
  { code: "52", name: "Gia Lai", fullName: "Tỉnh Gia Lai" },
  { code: "56", name: "Khánh Hoà", fullName: "Tỉnh Khánh Hoà" },
  { code: "66", name: "Đắk Lắk", fullName: "Tỉnh Đắk Lắk" },
  { code: "68", name: "Lâm Đồng", fullName: "Tỉnh Lâm Đồng" },
  { code: "75", name: "Đồng Nai", fullName: "Thành phố Đồng Nai" },
  { code: "79", name: "Hồ Chí Minh", fullName: "Thành phố Hồ Chí Minh" },
  { code: "80", name: "Tây Ninh", fullName: "Tỉnh Tây Ninh" },
  { code: "82", name: "Đồng Tháp", fullName: "Tỉnh Đồng Tháp" },
  { code: "86", name: "Vĩnh Long", fullName: "Tỉnh Vĩnh Long" },
  { code: "91", name: "An Giang", fullName: "Tỉnh An Giang" },
  { code: "92", name: "Cần Thơ", fullName: "Thành phố Cần Thơ" },
  { code: "96", name: "Cà Mau", fullName: "Tỉnh Cà Mau" },
] as const;

export const VN_WARDS_2025: readonly VnWard2025[] = [
  { c: "00004", n: "Phường Ba Đình", p: "01" },
  { c: "00292", n: "Phường Bạch Mai", p: "01" },
  { c: "00118", n: "Phường Bồ Đề", p: "01" },
  { c: "00166", n: "Phường Cầu Giấy", p: "01" },
  { c: "10015", n: "Phường Chương Mỹ", p: "01" },
  { c: "00082", n: "Phường Cửa Nam", p: "01" },
  { c: "09886", n: "Phường Dương Nội", p: "01" },
  { c: "00637", n: "Phường Đại Mỗ", p: "01" },
  { c: "00316", n: "Phường Định Công", p: "01" },
  { c: "00235", n: "Phường Đống Đa", p: "01" },
  { c: "00602", n: "Phường Đông Ngạc", p: "01" },
  { c: "00025", n: "Phường Giảng Võ", p: "01" },
  { c: "09556", n: "Phường Hà Đông", p: "01" },
  { c: "00256", n: "Phường Hai Bà Trưng", p: "01" },
  { c: "00070", n: "Phường Hoàn Kiếm", p: "01" },
  { c: "00337", n: "Phường Hoàng Liệt", p: "01" },
  { c: "00331", n: "Phường Hoàng Mai", p: "01" },
  { c: "00097", n: "Phường Hồng Hà", p: "01" },
  { c: "00364", n: "Phường Khương Đình", p: "01" },
  { c: "09552", n: "Phường Kiến Hưng", p: "01" },
  { c: "00229", n: "Phường Kim Liên", p: "01" },
  { c: "00199", n: "Phường Láng", p: "01" },
  { c: "00328", n: "Phường Lĩnh Nam", p: "01" },
  { c: "00145", n: "Phường Long Biên", p: "01" },
  { c: "00160", n: "Phường Nghĩa Đô", p: "01" },
  { c: "00008", n: "Phường Ngọc Hà", p: "01" },
  { c: "00190", n: "Phường Ô Chợ Dừa", p: "01" },
  { c: "00619", n: "Phường Phú Diễn", p: "01" },
  { c: "09568", n: "Phường Phú Lương", p: "01" },
  { c: "00091", n: "Phường Phú Thượng", p: "01" },
  { c: "00136", n: "Phường Phúc Lợi", p: "01" },
  { c: "00352", n: "Phường Phương Liệt", p: "01" },
  { c: "09574", n: "Phường Sơn Tây", p: "01" },
  { c: "00103", n: "Phường Tây Hồ", p: "01" },
  { c: "00634", n: "Phường Tây Mỗ", p: "01" },
  { c: "00613", n: "Phường Tây Tựu", p: "01" },
  { c: "00643", n: "Phường Thanh Liệt", p: "01" },
  { c: "00367", n: "Phường Thanh Xuân", p: "01" },
  { c: "00598", n: "Phường Thượng Cát", p: "01" },
  { c: "09604", n: "Phường Tùng Thiện", p: "01" },
  { c: "00592", n: "Phường Từ Liêm", p: "01" },
  { c: "00322", n: "Phường Tương Mai", p: "01" },
  { c: "00226", n: "Phường Văn Miếu - Quốc Tử Giám", p: "01" },
  { c: "00127", n: "Phường Việt Hưng", p: "01" },
  { c: "00301", n: "Phường Vĩnh Hưng", p: "01" },
  { c: "00283", n: "Phường Vĩnh Tuy", p: "01" },
  { c: "00611", n: "Phường Xuân Đỉnh", p: "01" },
  { c: "00622", n: "Phường Xuân Phương", p: "01" },
  { c: "00175", n: "Phường Yên Hoà", p: "01" },
  { c: "09562", n: "Phường Yên Nghĩa", p: "01" },
  { c: "00340", n: "Phường Yên Sở", p: "01" },
  { c: "09877", n: "Xã An Khánh", p: "01" },
  { c: "09700", n: "Xã Ba Vì", p: "01" },
  { c: "00577", n: "Xã Bát Tràng", p: "01" },
  { c: "09676", n: "Xã Bất Bạt", p: "01" },
  { c: "10126", n: "Xã Bình Minh", p: "01" },
  { c: "10330", n: "Xã Chuyên Mỹ", p: "01" },
  { c: "10237", n: "Xã Chương Dương", p: "01" },
  { c: "09634", n: "Xã Cổ Đô", p: "01" },
  { c: "10180", n: "Xã Dân Hoà", p: "01" },
  { c: "09856", n: "Xã Dương Hoà", p: "01" },
  { c: "00430", n: "Xã Đa Phúc", p: "01" },
  { c: "00664", n: "Xã Đại Thanh", p: "01" },
  { c: "10342", n: "Xã Đại Xuyên", p: "01" },
  { c: "09784", n: "Xã Đan Phượng", p: "01" },
  { c: "09616", n: "Xã Đoài Phương", p: "01" },
  { c: "00454", n: "Xã Đông Anh", p: "01" },
  { c: "00565", n: "Xã Gia Lâm", p: "01" },
  { c: "09982", n: "Xã Hạ Bằng", p: "01" },
  { c: "09772", n: "Xã Hát Môn", p: "01" },
  { c: "09988", n: "Xã Hoà Lạc", p: "01" },
  { c: "10096", n: "Xã Hoà Phú", p: "01" },
  { c: "10417", n: "Xã Hoà Xá", p: "01" },
  { c: "09832", n: "Xã Hoài Đức", p: "01" },
  { c: "10465", n: "Xã Hồng Sơn", p: "01" },
  { c: "10210", n: "Xã Hồng Vân", p: "01" },
  { c: "09931", n: "Xã Hưng Đạo", p: "01" },
  { c: "10489", n: "Xã Hương Sơn", p: "01" },
  { c: "09910", n: "Xã Kiều Phú", p: "01" },
  { c: "00382", n: "Xã Kim Anh", p: "01" },
  { c: "09787", n: "Xã Liên Minh", p: "01" },
  { c: "09022", n: "Xã Mê Linh", p: "01" },
  { c: "09661", n: "Xã Minh Châu", p: "01" },
  { c: "10441", n: "Xã Mỹ Đức", p: "01" },
  { c: "00685", n: "Xã Nam Phù", p: "01" },
  { c: "00679", n: "Xã Ngọc Hồi", p: "01" },
  { c: "00433", n: "Xã Nội Bài", p: "01" },
  { c: "09817", n: "Xã Ô Diên", p: "01" },
  { c: "09952", n: "Xã Phú Cát", p: "01" },
  { c: "00541", n: "Xã Phù Đổng", p: "01" },
  { c: "10030", n: "Xã Phú Nghĩa", p: "01" },
  { c: "10273", n: "Xã Phú Xuyên", p: "01" },
  { c: "09739", n: "Xã Phúc Lộc", p: "01" },
  { c: "10459", n: "Xã Phúc Sơn", p: "01" },
  { c: "00466", n: "Xã Phúc Thịnh", p: "01" },
  { c: "09715", n: "Xã Phúc Thọ", p: "01" },
  { c: "10279", n: "Xã Phượng Dực", p: "01" },
  { c: "10072", n: "Xã Quảng Bị", p: "01" },
  { c: "08974", n: "Xã Quang Minh", p: "01" },
  { c: "09619", n: "Xã Quảng Oai", p: "01" },
  { c: "09895", n: "Xã Quốc Oai", p: "01" },
  { c: "00376", n: "Xã Sóc Sơn", p: "01" },
  { c: "09871", n: "Xã Sơn Đồng", p: "01" },
  { c: "09694", n: "Xã Suối Hai", p: "01" },
  { c: "10144", n: "Xã Tam Hưng", p: "01" },
  { c: "10003", n: "Xã Tây Phương", p: "01" },
  { c: "09955", n: "Xã Thạch Thất", p: "01" },
  { c: "10114", n: "Xã Thanh Oai", p: "01" },
  { c: "00640", n: "Xã Thanh Trì", p: "01" },
  { c: "00493", n: "Xã Thiên Lộc", p: "01" },
  { c: "00562", n: "Xã Thuận An", p: "01" },
  { c: "00475", n: "Xã Thư Lâm", p: "01" },
  { c: "10231", n: "Xã Thượng Phúc", p: "01" },
  { c: "10183", n: "Xã Thường Tín", p: "01" },
  { c: "08995", n: "Xã Tiến Thắng", p: "01" },
  { c: "10081", n: "Xã Trần Phú", p: "01" },
  { c: "00385", n: "Xã Trung Giã", p: "01" },
  { c: "10402", n: "Xã Ứng Hoà", p: "01" },
  { c: "10369", n: "Xã Ứng Thiên", p: "01" },
  { c: "10354", n: "Xã Vân Đình", p: "01" },
  { c: "09664", n: "Xã Vật Lại", p: "01" },
  { c: "00508", n: "Xã Vĩnh Thanh", p: "01" },
  { c: "10045", n: "Xã Xuân Mai", p: "01" },
  { c: "09706", n: "Xã Yên Bài", p: "01" },
  { c: "08980", n: "Xã Yên Lãng", p: "01" },
  { c: "04930", n: "Xã Yên Xuân", p: "01" },
  { c: "01279", n: "Phường Nùng Trí Cao", p: "04" },
  { c: "01288", n: "Phường Tân Giang", p: "04" },
  { c: "01273", n: "Phường Thục Phán", p: "04" },
  { c: "01708", n: "Xã Bạch Đằng", p: "04" },
  { c: "01321", n: "Xã Bảo Lạc", p: "04" },
  { c: "01290", n: "Xã Bảo Lâm", p: "04" },
  { c: "01636", n: "Xã Bế Văn Đàn", p: "04" },
  { c: "01738", n: "Xã Ca Thành", p: "04" },
  { c: "01789", n: "Xã Canh Tân", p: "04" },
  { c: "01366", n: "Xã Cần Yên", p: "04" },
  { c: "01327", n: "Xã Cô Ba", p: "04" },
  { c: "01324", n: "Xã Cốc Pàng", p: "04" },
  { c: "01501", n: "Xã Đàm Thuỷ", p: "04" },
  { c: "01489", n: "Xã Đình Phong", p: "04" },
  { c: "01525", n: "Xã Đoài Dương", p: "04" },
  { c: "01594", n: "Xã Độc Lập", p: "04" },
  { c: "01786", n: "Xã Đông Khê", p: "04" },
  { c: "01822", n: "Xã Đức Long", p: "04" },
  { c: "01558", n: "Xã Hạ Lang", p: "04" },
  { c: "01438", n: "Xã Hà Quảng", p: "04" },
  { c: "01618", n: "Xã Hạnh Phúc", p: "04" },
  { c: "01654", n: "Xã Hoà An", p: "04" },
  { c: "01354", n: "Xã Huy Giáp", p: "04" },
  { c: "01351", n: "Xã Hưng Đạo", p: "04" },
  { c: "01336", n: "Xã Khánh Xuân", p: "04" },
  { c: "01792", n: "Xã Kim Đồng", p: "04" },
  { c: "01393", n: "Xã Lũng Nặm", p: "04" },
  { c: "01294", n: "Xã Lý Bôn", p: "04" },
  { c: "01537", n: "Xã Lý Quốc", p: "04" },
  { c: "01795", n: "Xã Minh Khai", p: "04" },
  { c: "01747", n: "Xã Minh Tâm", p: "04" },
  { c: "01297", n: "Xã Nam Quang", p: "04" },
  { c: "01660", n: "Xã Nam Tuấn", p: "04" },
  { c: "01726", n: "Xã Nguyên Bình", p: "04" },
  { c: "01699", n: "Xã Nguyễn Huệ", p: "04" },
  { c: "01768", n: "Xã Phan Thanh", p: "04" },
  { c: "01648", n: "Xã Phục Hoà", p: "04" },
  { c: "01456", n: "Xã Quang Hán", p: "04" },
  { c: "01304", n: "Xã Quảng Lâm", p: "04" },
  { c: "01552", n: "Xã Quang Long", p: "04" },
  { c: "01465", n: "Xã Quang Trung", p: "04" },
  { c: "01576", n: "Xã Quảng Uyên", p: "04" },
  { c: "01360", n: "Xã Sơn Lộ", p: "04" },
  { c: "01774", n: "Xã Tam Kim", p: "04" },
  { c: "01807", n: "Xã Thạch An", p: "04" },
  { c: "01777", n: "Xã Thành Công", p: "04" },
  { c: "01387", n: "Xã Thanh Long", p: "04" },
  { c: "01363", n: "Xã Thông Nông", p: "04" },
  { c: "01729", n: "Xã Tĩnh Túc", p: "04" },
  { c: "01414", n: "Xã Tổng Cọt", p: "04" },
  { c: "01447", n: "Xã Trà Lĩnh", p: "04" },
  { c: "01477", n: "Xã Trùng Khánh", p: "04" },
  { c: "01392", n: "Xã Trường Hà", p: "04" },
  { c: "01561", n: "Xã Vinh Quý", p: "04" },
  { c: "01339", n: "Xã Xuân Trường", p: "04" },
  { c: "01318", n: "Xã Yên Thổ", p: "04" },
  { c: "02512", n: "Phường An Tường", p: "08" },
  { c: "02524", n: "Phường Bình Thuận", p: "08" },
  { c: "00694", n: "Phường Hà Giang 1", p: "08" },
  { c: "00691", n: "Phường Hà Giang 2", p: "08" },
  { c: "02215", n: "Phường Minh Xuân", p: "08" },
  { c: "02509", n: "Phường Mỹ Lâm", p: "08" },
  { c: "02212", n: "Phường Nông Tiến", p: "08" },
  { c: "00832", n: "Xã Bạch Đích", p: "08" },
  { c: "00976", n: "Xã Bạch Ngọc", p: "08" },
  { c: "02380", n: "Xã Bạch Xa", p: "08" },
  { c: "01024", n: "Xã Bản Máy", p: "08" },
  { c: "00991", n: "Xã Bắc Mê", p: "08" },
  { c: "01153", n: "Xã Bắc Quang", p: "08" },
  { c: "01180", n: "Xã Bằng Hành", p: "08" },
  { c: "01246", n: "Xã Bằng Lang", p: "08" },
  { c: "02296", n: "Xã Bình An", p: "08" },
  { c: "02548", n: "Xã Bình Ca", p: "08" },
  { c: "02404", n: "Xã Bình Xa", p: "08" },
  { c: "00883", n: "Xã Cán Tỷ", p: "08" },
  { c: "00952", n: "Xã Cao Bồ", p: "08" },
  { c: "02287", n: "Xã Chiêm Hoá", p: "08" },
  { c: "02245", n: "Xã Côn Lôn", p: "08" },
  { c: "00871", n: "Xã Du Già", p: "08" },
  { c: "01165", n: "Xã Đồng Tâm", p: "08" },
  { c: "02572", n: "Xã Đông Thọ", p: "08" },
  { c: "00721", n: "Xã Đồng Văn", p: "08" },
  { c: "01216", n: "Xã Đồng Yên", p: "08" },
  { c: "01012", n: "Xã Đường Hồng", p: "08" },
  { c: "00865", n: "Xã Đường Thượng", p: "08" },
  { c: "00985", n: "Xã Giáp Trung", p: "08" },
  { c: "02374", n: "Xã Hàm Yên", p: "08" },
  { c: "02353", n: "Xã Hoà An", p: "08" },
  { c: "01021", n: "Xã Hoàng Su Phì", p: "08" },
  { c: "01084", n: "Xã Hồ Thầu", p: "08" },
  { c: "02608", n: "Xã Hồng Sơn", p: "08" },
  { c: "02260", n: "Xã Hồng Thái", p: "08" },
  { c: "01201", n: "Xã Hùng An", p: "08" },
  { c: "02425", n: "Xã Hùng Đức", p: "08" },
  { c: "02455", n: "Xã Hùng Lợi", p: "08" },
  { c: "00802", n: "Xã Khâu Vai", p: "08" },
  { c: "01147", n: "Xã Khuôn Lùng", p: "08" },
  { c: "02332", n: "Xã Kiên Đài", p: "08" },
  { c: "02437", n: "Xã Kiến Thiết", p: "08" },
  { c: "02350", n: "Xã Kim Bình", p: "08" },
  { c: "00937", n: "Xã Lao Chải", p: "08" },
  { c: "02266", n: "Xã Lâm Bình", p: "08" },
  { c: "01192", n: "Xã Liên Hiệp", p: "08" },
  { c: "00970", n: "Xã Linh Hồ", p: "08" },
  { c: "00715", n: "Xã Lũng Cú", p: "08" },
  { c: "00763", n: "Xã Lũng Phìn", p: "08" },
  { c: "00901", n: "Xã Lùng Tám", p: "08" },
  { c: "02434", n: "Xã Lực Hành", p: "08" },
  { c: "00847", n: "Xã Mậu Duệ", p: "08" },
  { c: "00769", n: "Xã Mèo Vạc", p: "08" },
  { c: "00994", n: "Xã Minh Ngọc", p: "08" },
  { c: "02302", n: "Xã Minh Quang", p: "08" },
  { c: "00982", n: "Xã Minh Sơn", p: "08" },
  { c: "00919", n: "Xã Minh Tân", p: "08" },
  { c: "02554", n: "Xã Minh Thanh", p: "08" },
  { c: "02221", n: "Xã Nà Hang", p: "08" },
  { c: "01141", n: "Xã Nấm Dẩn", p: "08" },
  { c: "01075", n: "Xã Nậm Dịch", p: "08" },
  { c: "00889", n: "Xã Nghĩa Thuận", p: "08" },
  { c: "00700", n: "Xã Ngọc Đường", p: "08" },
  { c: "00859", n: "Xã Ngọc Long", p: "08" },
  { c: "02530", n: "Xã Nhữ Khê", p: "08" },
  { c: "00817", n: "Xã Niêm Sơn", p: "08" },
  { c: "01096", n: "Xã Pà Vầy Sủ", p: "08" },
  { c: "00745", n: "Xã Phố Bảng", p: "08" },
  { c: "00706", n: "Xã Phú Linh", p: "08" },
  { c: "02611", n: "Xã Phú Lương", p: "08" },
  { c: "02392", n: "Xã Phù Lưu", p: "08" },
  { c: "01057", n: "Xã Pờ Ly Ngài", p: "08" },
  { c: "00874", n: "Xã Quản Bạ", p: "08" },
  { c: "01237", n: "Xã Quang Bình", p: "08" },
  { c: "01144", n: "Xã Quảng Nguyên", p: "08" },
  { c: "00733", n: "Xã Sà Phìn", p: "08" },
  { c: "02536", n: "Xã Sơn Dương", p: "08" },
  { c: "02620", n: "Xã Sơn Thuỷ", p: "08" },
  { c: "00778", n: "Xã Sơn Vĩ", p: "08" },
  { c: "00787", n: "Xã Sủng Máng", p: "08" },
  { c: "00808", n: "Xã Tát Ngà", p: "08" },
  { c: "02320", n: "Xã Tân An", p: "08" },
  { c: "02470", n: "Xã Tân Long", p: "08" },
  { c: "02308", n: "Xã Tân Mỹ", p: "08" },
  { c: "01171", n: "Xã Tân Quang", p: "08" },
  { c: "02578", n: "Xã Tân Thanh", p: "08" },
  { c: "01051", n: "Xã Tân Tiến", p: "08" },
  { c: "02545", n: "Xã Tân Trào", p: "08" },
  { c: "01243", n: "Xã Tân Trịnh", p: "08" },
  { c: "02494", n: "Xã Thái Bình", p: "08" },
  { c: "02419", n: "Xã Thái Hoà", p: "08" },
  { c: "02407", n: "Xã Thái Sơn", p: "08" },
  { c: "01033", n: "Xã Thàng Tín", p: "08" },
  { c: "00928", n: "Xã Thanh Thuỷ", p: "08" },
  { c: "00829", n: "Xã Thắng Mố", p: "08" },
  { c: "01090", n: "Xã Thông Nguyên", p: "08" },
  { c: "00922", n: "Xã Thuận Hoà", p: "08" },
  { c: "02269", n: "Xã Thượng Lâm", p: "08" },
  { c: "02239", n: "Xã Thượng Nông", p: "08" },
  { c: "00958", n: "Xã Thượng Sơn", p: "08" },
  { c: "01225", n: "Xã Tiên Nguyên", p: "08" },
  { c: "01261", n: "Xã Tiên Yên", p: "08" },
  { c: "02359", n: "Xã Tri Phú", p: "08" },
  { c: "02305", n: "Xã Trung Hà", p: "08" },
  { c: "02458", n: "Xã Trung Sơn", p: "08" },
  { c: "01117", n: "Xã Trung Thịnh", p: "08" },
  { c: "02623", n: "Xã Trường Sinh", p: "08" },
  { c: "00925", n: "Xã Tùng Bá", p: "08" },
  { c: "00892", n: "Xã Tùng Vài", p: "08" },
  { c: "00913", n: "Xã Vị Xuyên", p: "08" },
  { c: "00967", n: "Xã Việt Lâm", p: "08" },
  { c: "01156", n: "Xã Vĩnh Tuy", p: "08" },
  { c: "01108", n: "Xã Xín Mần", p: "08" },
  { c: "01255", n: "Xã Xuân Giang", p: "08" },
  { c: "02449", n: "Xã Xuân Vân", p: "08" },
  { c: "01006", n: "Xã Yên Cường", p: "08" },
  { c: "02248", n: "Xã Yên Hoa", p: "08" },
  { c: "02317", n: "Xã Yên Lập", p: "08" },
  { c: "00820", n: "Xã Yên Minh", p: "08" },
  { c: "02365", n: "Xã Yên Nguyên", p: "08" },
  { c: "02398", n: "Xã Yên Phú", p: "08" },
  { c: "02473", n: "Xã Yên Sơn", p: "08" },
  { c: "01234", n: "Xã Yên Thành", p: "08" },
  { c: "03127", n: "Phường Điện Biên Phủ", p: "11" },
  { c: "03151", n: "Phường Mường Lay", p: "11" },
  { c: "03334", n: "Phường Mường Thanh", p: "11" },
  { c: "03301", n: "Xã Búng Lao", p: "11" },
  { c: "03175", n: "Xã Chà Tở", p: "11" },
  { c: "03283", n: "Xã Chiềng Sinh", p: "11" },
  { c: "03256", n: "Xã Mường Ảng", p: "11" },
  { c: "03166", n: "Xã Mường Chà", p: "11" },
  { c: "03313", n: "Xã Mường Lạn", p: "11" },
  { c: "03214", n: "Xã Mường Luân", p: "11" },
  { c: "03268", n: "Xã Mường Mùn", p: "11" },
  { c: "03368", n: "Xã Mường Nhà", p: "11" },
  { c: "03160", n: "Xã Mường Nhé", p: "11" },
  { c: "03325", n: "Xã Mường Phăng", p: "11" },
  { c: "03202", n: "Xã Mường Pồn", p: "11" },
  { c: "03163", n: "Xã Mường Toong", p: "11" },
  { c: "03181", n: "Xã Mường Tùng", p: "11" },
  { c: "03176", n: "Xã Nà Bủng", p: "11" },
  { c: "03169", n: "Xã Nà Hỳ", p: "11" },
  { c: "03172", n: "Xã Na Sang", p: "11" },
  { c: "03203", n: "Xã Na Son", p: "11" },
  { c: "03316", n: "Xã Nà Tấu", p: "11" },
  { c: "03162", n: "Xã Nậm Kè", p: "11" },
  { c: "03194", n: "Xã Nậm Nèn", p: "11" },
  { c: "03358", n: "Xã Núa Ngam", p: "11" },
  { c: "03193", n: "Xã Pa Ham", p: "11" },
  { c: "03382", n: "Xã Phình Giàng", p: "11" },
  { c: "03370", n: "Xã Pu Nhi", p: "11" },
  { c: "03260", n: "Xã Pú Nhung", p: "11" },
  { c: "03295", n: "Xã Quài Tở", p: "11" },
  { c: "03164", n: "Xã Quảng Lâm", p: "11" },
  { c: "03356", n: "Xã Sam Mứn", p: "11" },
  { c: "03244", n: "Xã Sáng Nhè", p: "11" },
  { c: "03199", n: "Xã Si Pa Phìn", p: "11" },
  { c: "03226", n: "Xã Sín Chải", p: "11" },
  { c: "03158", n: "Xã Sín Thầu", p: "11" },
  { c: "03241", n: "Xã Sính Phình", p: "11" },
  { c: "03352", n: "Xã Thanh An", p: "11" },
  { c: "03328", n: "Xã Thanh Nưa", p: "11" },
  { c: "03349", n: "Xã Thanh Yên", p: "11" },
  { c: "03385", n: "Xã Tìa Dình", p: "11" },
  { c: "03217", n: "Xã Tủa Chùa", p: "11" },
  { c: "03220", n: "Xã Tủa Thàng", p: "11" },
  { c: "03253", n: "Xã Tuần Giáo", p: "11" },
  { c: "03208", n: "Xã Xa Dung", p: "11" },
  { c: "03388", n: "Phường Đoàn Kết", p: "12" },
  { c: "03408", n: "Phường Tân Phong", p: "12" },
  { c: "03424", n: "Xã Bản Bo", p: "12" },
  { c: "03390", n: "Xã Bình Lư", p: "12" },
  { c: "03466", n: "Xã Bum Nưa", p: "12" },
  { c: "03433", n: "Xã Bum Tở", p: "12" },
  { c: "03571", n: "Xã Dào San", p: "12" },
  { c: "03508", n: "Xã Hồng Thu", p: "12" },
  { c: "03460", n: "Xã Hua Bum", p: "12" },
  { c: "03640", n: "Xã Khoen On", p: "12" },
  { c: "03583", n: "Xã Khổng Lào", p: "12" },
  { c: "03430", n: "Xã Khun Há", p: "12" },
  { c: "03487", n: "Xã Lê Lợi", p: "12" },
  { c: "03451", n: "Xã Mù Cả", p: "12" },
  { c: "03601", n: "Xã Mường Khoa", p: "12" },
  { c: "03637", n: "Xã Mường Kim", p: "12" },
  { c: "03472", n: "Xã Mường Mô", p: "12" },
  { c: "03445", n: "Xã Mường Tè", p: "12" },
  { c: "03618", n: "Xã Mường Than", p: "12" },
  { c: "03544", n: "Xã Nậm Cuổi", p: "12" },
  { c: "03434", n: "Xã Nậm Hàng", p: "12" },
  { c: "03538", n: "Xã Nậm Mạ", p: "12" },
  { c: "03613", n: "Xã Nậm Sỏ", p: "12" },
  { c: "03517", n: "Xã Nậm Tăm", p: "12" },
  { c: "03503", n: "Xã Pa Tần", p: "12" },
  { c: "03442", n: "Xã Pa Ủ", p: "12" },
  { c: "03616", n: "Xã Pắc Ta", p: "12" },
  { c: "03549", n: "Xã Phong Thổ", p: "12" },
  { c: "03532", n: "Xã Pu Sam Cáp", p: "12" },
  { c: "03562", n: "Xã Sì Lở Lầu", p: "12" },
  { c: "03478", n: "Xã Sìn Hồ", p: "12" },
  { c: "03394", n: "Xã Sin Suối Hồ", p: "12" },
  { c: "03405", n: "Xã Tả Lèng", p: "12" },
  { c: "03463", n: "Xã Tà Tổng", p: "12" },
  { c: "03598", n: "Xã Tân Uyên", p: "12" },
  { c: "03595", n: "Xã Than Uyên", p: "12" },
  { c: "03439", n: "Xã Thu Lũm", p: "12" },
  { c: "03529", n: "Xã Tủa Sín Chải", p: "12" },
  { c: "03664", n: "Phường Chiềng An", p: "14" },
  { c: "03670", n: "Phường Chiềng Cơi", p: "14" },
  { c: "03679", n: "Phường Chiềng Sinh", p: "14" },
  { c: "03980", n: "Phường Mộc Châu", p: "14" },
  { c: "03979", n: "Phường Mộc Sơn", p: "14" },
  { c: "03982", n: "Phường Thảo Nguyên", p: "14" },
  { c: "03646", n: "Phường Tô Hiệu", p: "14" },
  { c: "04033", n: "Phường Vân Sơn", p: "14" },
  { c: "03856", n: "Xã Bắc Yên", p: "14" },
  { c: "03724", n: "Xã Bình Thuận", p: "14" },
  { c: "04171", n: "Xã Bó Sinh", p: "14" },
  { c: "04078", n: "Xã Chiềng Hặc", p: "14" },
  { c: "03850", n: "Xã Chiềng Hoa", p: "14" },
  { c: "04204", n: "Xã Chiềng Khoong", p: "14" },
  { c: "04222", n: "Xã Chiềng Khương", p: "14" },
  { c: "03754", n: "Xã Chiềng La", p: "14" },
  { c: "03814", n: "Xã Chiềng Lao", p: "14" },
  { c: "04132", n: "Xã Chiềng Mai", p: "14" },
  { c: "04123", n: "Xã Chiềng Mung", p: "14" },
  { c: "03892", n: "Xã Chiềng Sại", p: "14" },
  { c: "04195", n: "Xã Chiềng Sơ", p: "14" },
  { c: "03985", n: "Xã Chiềng Sơn", p: "14" },
  { c: "04108", n: "Xã Chiềng Sung", p: "14" },
  { c: "03781", n: "Xã Co Mạ", p: "14" },
  { c: "04000", n: "Xã Đoàn Kết", p: "14" },
  { c: "03922", n: "Xã Gia Phù", p: "14" },
  { c: "04210", n: "Xã Huổi Một", p: "14" },
  { c: "03961", n: "Xã Kim Bon", p: "14" },
  { c: "03763", n: "Xã Long Hẹ", p: "14" },
  { c: "04096", n: "Xã Lóng Phiêng", p: "14" },
  { c: "04045", n: "Xã Lóng Sập", p: "14" },
  { c: "04105", n: "Xã Mai Sơn", p: "14" },
  { c: "03799", n: "Xã Muổi Nọi", p: "14" },
  { c: "03760", n: "Xã Mường Bám", p: "14" },
  { c: "03943", n: "Xã Mường Bang", p: "14" },
  { c: "03847", n: "Xã Mường Bú", p: "14" },
  { c: "04117", n: "Xã Mường Chanh", p: "14" },
  { c: "03688", n: "Xã Mường Chiên", p: "14" },
  { c: "03907", n: "Xã Mường Cơi", p: "14" },
  { c: "03727", n: "Xã Mường É", p: "14" },
  { c: "03694", n: "Xã Mường Giôn", p: "14" },
  { c: "04219", n: "Xã Mường Hung", p: "14" },
  { c: "03757", n: "Xã Mường Khiêng", p: "14" },
  { c: "03808", n: "Xã Mường La", p: "14" },
  { c: "04246", n: "Xã Mường Lạn", p: "14" },
  { c: "04183", n: "Xã Mường Lầm", p: "14" },
  { c: "04240", n: "Xã Mường Lèo", p: "14" },
  { c: "03712", n: "Xã Mường Sại", p: "14" },
  { c: "03784", n: "Xã Nậm Lầu", p: "14" },
  { c: "04186", n: "Xã Nậm Ty", p: "14" },
  { c: "03820", n: "Xã Ngọc Chiến", p: "14" },
  { c: "03871", n: "Xã Pắc Ngà", p: "14" },
  { c: "04144", n: "Xã Phiêng Cằm", p: "14" },
  { c: "04099", n: "Xã Phiêng Khoài", p: "14" },
  { c: "04159", n: "Xã Phiêng Pằn", p: "14" },
  { c: "03910", n: "Xã Phù Yên", p: "14" },
  { c: "04228", n: "Xã Púng Bánh", p: "14" },
  { c: "03703", n: "Xã Quỳnh Nhai", p: "14" },
  { c: "04006", n: "Xã Song Khủa", p: "14" },
  { c: "04168", n: "Xã Sông Mã", p: "14" },
  { c: "04231", n: "Xã Sốp Cộp", p: "14" },
  { c: "03901", n: "Xã Suối Tọ", p: "14" },
  { c: "04136", n: "Xã Tà Hộc", p: "14" },
  { c: "03880", n: "Xã Tạ Khoa", p: "14" },
  { c: "03868", n: "Xã Tà Xùa", p: "14" },
  { c: "03970", n: "Xã Tân Phong", p: "14" },
  { c: "03997", n: "Xã Tân Yên", p: "14" },
  { c: "03721", n: "Xã Thuận Châu", p: "14" },
  { c: "04018", n: "Xã Tô Múa", p: "14" },
  { c: "03958", n: "Xã Tường Hạ", p: "14" },
  { c: "04048", n: "Xã Vân Hồ", p: "14" },
  { c: "03862", n: "Xã Xím Vàng", p: "14" },
  { c: "04057", n: "Xã Xuân Nha", p: "14" },
  { c: "04075", n: "Xã Yên Châu", p: "14" },
  { c: "04087", n: "Xã Yên Sơn", p: "14" },
  { c: "04543", n: "Phường Âu Lâu", p: "15" },
  { c: "02671", n: "Phường Cam Đường", p: "15" },
  { c: "04681", n: "Phường Cầu Thia", p: "15" },
  { c: "02647", n: "Phường Lào Cai", p: "15" },
  { c: "04273", n: "Phường Nam Cường", p: "15" },
  { c: "04288", n: "Phường Nghĩa Lộ", p: "15" },
  { c: "03006", n: "Phường Sa Pa", p: "15" },
  { c: "04663", n: "Phường Trung Tâm", p: "15" },
  { c: "04279", n: "Phường Văn Phú", p: "15" },
  { c: "04252", n: "Phường Yên Bái", p: "15" },
  { c: "02686", n: "Xã A Mú Sung", p: "15" },
  { c: "03046", n: "Xã Bản Hồ", p: "15" },
  { c: "02788", n: "Xã Bản Lầu", p: "15" },
  { c: "02869", n: "Xã Bản Liền", p: "15" },
  { c: "02725", n: "Xã Bản Xèo", p: "15" },
  { c: "04750", n: "Xã Bảo Ái", p: "15" },
  { c: "02989", n: "Xã Bảo Hà", p: "15" },
  { c: "02890", n: "Xã Bảo Nhai", p: "15" },
  { c: "02905", n: "Xã Bảo Thắng", p: "15" },
  { c: "02947", n: "Xã Bảo Yên", p: "15" },
  { c: "02683", n: "Xã Bát Xát", p: "15" },
  { c: "02839", n: "Xã Bắc Hà", p: "15" },
  { c: "04726", n: "Xã Cảm Nhân", p: "15" },
  { c: "02782", n: "Xã Cao Sơn", p: "15" },
  { c: "04693", n: "Xã Cát Thịnh", p: "15" },
  { c: "04699", n: "Xã Chấn Thịnh", p: "15" },
  { c: "04387", n: "Xã Châu Quế", p: "15" },
  { c: "04489", n: "Xã Chế Tạo", p: "15" },
  { c: "03091", n: "Xã Chiềng Ken", p: "15" },
  { c: "02896", n: "Xã Cốc Lầu", p: "15" },
  { c: "02746", n: "Xã Cốc San", p: "15" },
  { c: "02707", n: "Xã Dền Sáng", p: "15" },
  { c: "03106", n: "Xã Dương Quỳ", p: "15" },
  { c: "04399", n: "Xã Đông Cuông", p: "15" },
  { c: "04636", n: "Xã Gia Hội", p: "15" },
  { c: "02923", n: "Xã Gia Phú", p: "15" },
  { c: "04585", n: "Xã Hạnh Phúc", p: "15" },
  { c: "02680", n: "Xã Hợp Thành", p: "15" },
  { c: "04576", n: "Xã Hưng Khánh", p: "15" },
  { c: "04342", n: "Xã Khánh Hoà", p: "15" },
  { c: "03103", n: "Xã Khánh Yên", p: "15" },
  { c: "04465", n: "Xã Khao Mang", p: "15" },
  { c: "04474", n: "Xã Lao Chải", p: "15" },
  { c: "04381", n: "Xã Lâm Giang", p: "15" },
  { c: "04309", n: "Xã Lâm Thượng", p: "15" },
  { c: "04660", n: "Xã Liên Sơn", p: "15" },
  { c: "04303", n: "Xã Lục Yên", p: "15" },
  { c: "02848", n: "Xã Lùng Phình", p: "15" },
  { c: "04537", n: "Xã Lương Thịnh", p: "15" },
  { c: "04375", n: "Xã Mậu A", p: "15" },
  { c: "03121", n: "Xã Minh Lương", p: "15" },
  { c: "04450", n: "Xã Mỏ Vàng", p: "15" },
  { c: "04456", n: "Xã Mù Cang Chải", p: "15" },
  { c: "03043", n: "Xã Mường Bo", p: "15" },
  { c: "02728", n: "Xã Mường Hum", p: "15" },
  { c: "02761", n: "Xã Mường Khương", p: "15" },
  { c: "04345", n: "Xã Mường Lai", p: "15" },
  { c: "03076", n: "Xã Nậm Chày", p: "15" },
  { c: "04462", n: "Xã Nậm Có", p: "15" },
  { c: "03085", n: "Xã Nậm Xé", p: "15" },
  { c: "02953", n: "Xã Nghĩa Đô", p: "15" },
  { c: "04711", n: "Xã Nghĩa Tâm", p: "15" },
  { c: "03004", n: "Xã Ngũ Chỉ Sơn", p: "15" },
  { c: "02752", n: "Xã Pha Long", p: "15" },
  { c: "04609", n: "Xã Phình Hồ", p: "15" },
  { c: "04402", n: "Xã Phong Dụ Hạ", p: "15" },
  { c: "04423", n: "Xã Phong Dụ Thượng", p: "15" },
  { c: "02902", n: "Xã Phong Hải", p: "15" },
  { c: "02998", n: "Xã Phúc Khánh", p: "15" },
  { c: "04363", n: "Xã Phúc Lợi", p: "15" },
  { c: "04492", n: "Xã Púng Luông", p: "15" },
  { c: "04531", n: "Xã Quy Mông", p: "15" },
  { c: "02809", n: "Xã Si Ma Cai", p: "15" },
  { c: "02824", n: "Xã Sín Chéng", p: "15" },
  { c: "04651", n: "Xã Sơn Lương", p: "15" },
  { c: "02842", n: "Xã Tả Củ Tỷ", p: "15" },
  { c: "03013", n: "Xã Tả Phìn", p: "15" },
  { c: "03037", n: "Xã Tả Van", p: "15" },
  { c: "04603", n: "Xã Tà Xi Láng", p: "15" },
  { c: "02908", n: "Xã Tằng Loỏng", p: "15" },
  { c: "04429", n: "Xã Tân Hợp", p: "15" },
  { c: "04336", n: "Xã Tân Lĩnh", p: "15" },
  { c: "04717", n: "Xã Thác Bà", p: "15" },
  { c: "04705", n: "Xã Thượng Bằng La", p: "15" },
  { c: "02968", n: "Xã Thượng Hà", p: "15" },
  { c: "04606", n: "Xã Trạm Tấu", p: "15" },
  { c: "04498", n: "Xã Trấn Yên", p: "15" },
  { c: "02695", n: "Xã Trịnh Tường", p: "15" },
  { c: "04630", n: "Xã Tú Lệ", p: "15" },
  { c: "03082", n: "Xã Văn Bàn", p: "15" },
  { c: "04672", n: "Xã Văn Chấn", p: "15" },
  { c: "04564", n: "Xã Việt Hồng", p: "15" },
  { c: "03061", n: "Xã Võ Lao", p: "15" },
  { c: "04441", n: "Xã Xuân Ái", p: "15" },
  { c: "02962", n: "Xã Xuân Hoà", p: "15" },
  { c: "02926", n: "Xã Xuân Quang", p: "15" },
  { c: "02701", n: "Xã Y Tý", p: "15" },
  { c: "04714", n: "Xã Yên Bình", p: "15" },
  { c: "04744", n: "Xã Yên Thành", p: "15" },
  { c: "05533", n: "Phường Bá Xuyên", p: "19" },
  { c: "05528", n: "Phường Bách Quang", p: "19" },
  { c: "01843", n: "Phường Bắc Kạn", p: "19" },
  { c: "01840", n: "Phường Đức Xuân", p: "19" },
  { c: "05467", n: "Phường Gia Sàng", p: "19" },
  { c: "05710", n: "Phường Linh Sơn", p: "19" },
  { c: "05443", n: "Phường Phan Đình Phùng", p: "19" },
  { c: "05860", n: "Phường Phổ Yên", p: "19" },
  { c: "05857", n: "Phường Phúc Thuận", p: "19" },
  { c: "05482", n: "Phường Quan Triều", p: "19" },
  { c: "05455", n: "Phường Quyết Thắng", p: "19" },
  { c: "05518", n: "Phường Sông Công", p: "19" },
  { c: "05500", n: "Phường Tích Lương", p: "19" },
  { c: "05899", n: "Phường Trung Thành", p: "19" },
  { c: "05890", n: "Phường Vạn Xuân", p: "19" },
  { c: "05809", n: "Xã An Khánh", p: "19" },
  { c: "01906", n: "Xã Ba Bể", p: "19" },
  { c: "02014", n: "Xã Bạch Thông", p: "19" },
  { c: "01864", n: "Xã Bằng Thành", p: "19" },
  { c: "01942", n: "Xã Bằng Vân", p: "19" },
  { c: "05605", n: "Xã Bình Thành", p: "19" },
  { c: "05587", n: "Xã Bình Yên", p: "19" },
  { c: "01879", n: "Xã Cao Minh", p: "19" },
  { c: "02008", n: "Xã Cẩm Giàng", p: "19" },
  { c: "02020", n: "Xã Chợ Đồn", p: "19" },
  { c: "02086", n: "Xã Chợ Mới", p: "19" },
  { c: "01912", n: "Xã Chợ Rã", p: "19" },
  { c: "02185", n: "Xã Côn Minh", p: "19" },
  { c: "02152", n: "Xã Cường Lợi", p: "19" },
  { c: "05755", n: "Xã Dân Tiến", p: "19" },
  { c: "05488", n: "Xã Đại Phúc", p: "19" },
  { c: "05830", n: "Xã Đại Từ", p: "19" },
  { c: "05941", n: "Xã Điềm Thuỵ", p: "19" },
  { c: "05569", n: "Xã Định Hoá", p: "19" },
  { c: "05692", n: "Xã Đồng Hỷ", p: "19" },
  { c: "01933", n: "Xã Đồng Phúc", p: "19" },
  { c: "05776", n: "Xã Đức Lương", p: "19" },
  { c: "01960", n: "Xã Hiệp Lực", p: "19" },
  { c: "05632", n: "Xã Hợp Thành", p: "19" },
  { c: "05953", n: "Xã Kha Sơn", p: "19" },
  { c: "05551", n: "Xã Kim Phượng", p: "19" },
  { c: "05818", n: "Xã La Bằng", p: "19" },
  { c: "05740", n: "Xã La Hiên", p: "19" },
  { c: "05542", n: "Xã Lam Vỹ", p: "19" },
  { c: "01936", n: "Xã Nà Phặc", p: "19" },
  { c: "02155", n: "Xã Na Rì", p: "19" },
  { c: "02026", n: "Xã Nam Cường", p: "19" },
  { c: "05707", n: "Xã Nam Hoà", p: "19" },
  { c: "01954", n: "Xã Ngân Sơn", p: "19" },
  { c: "02071", n: "Xã Nghĩa Tá", p: "19" },
  { c: "01882", n: "Xã Nghiên Loan", p: "19" },
  { c: "05722", n: "Xã Nghinh Tường", p: "19" },
  { c: "01849", n: "Xã Phong Quang", p: "19" },
  { c: "05908", n: "Xã Phú Bình", p: "19" },
  { c: "05602", n: "Xã Phú Đình", p: "19" },
  { c: "05788", n: "Xã Phú Lạc", p: "19" },
  { c: "05611", n: "Xã Phú Lương", p: "19" },
  { c: "05800", n: "Xã Phú Thịnh", p: "19" },
  { c: "01969", n: "Xã Phủ Thông", p: "19" },
  { c: "05773", n: "Xã Phú Xuyên", p: "19" },
  { c: "01894", n: "Xã Phúc Lộc", p: "19" },
  { c: "05563", n: "Xã Phượng Tiến", p: "19" },
  { c: "02038", n: "Xã Quảng Bạch", p: "19" },
  { c: "05674", n: "Xã Quang Sơn", p: "19" },
  { c: "05851", n: "Xã Quân Chu", p: "19" },
  { c: "05719", n: "Xã Sảng Mộc", p: "19" },
  { c: "05503", n: "Xã Tân Cương", p: "19" },
  { c: "05917", n: "Xã Tân Khánh", p: "19" },
  { c: "02104", n: "Xã Tân Kỳ", p: "19" },
  { c: "05923", n: "Xã Tân Thành", p: "19" },
  { c: "05881", n: "Xã Thành Công", p: "19" },
  { c: "02101", n: "Xã Thanh Mai", p: "19" },
  { c: "02107", n: "Xã Thanh Thịnh", p: "19" },
  { c: "05725", n: "Xã Thần Sa", p: "19" },
  { c: "01921", n: "Xã Thượng Minh", p: "19" },
  { c: "01957", n: "Xã Thượng Quan", p: "19" },
  { c: "05662", n: "Xã Trại Cau", p: "19" },
  { c: "05746", n: "Xã Tràng Xá", p: "19" },
  { c: "02176", n: "Xã Trần Phú", p: "19" },
  { c: "05581", n: "Xã Trung Hội", p: "19" },
  { c: "05845", n: "Xã Vạn Phú", p: "19" },
  { c: "05680", n: "Xã Văn Hán", p: "19" },
  { c: "02143", n: "Xã Văn Lang", p: "19" },
  { c: "05665", n: "Xã Văn Lăng", p: "19" },
  { c: "01981", n: "Xã Vĩnh Thông", p: "19" },
  { c: "05716", n: "Xã Võ Nhai", p: "19" },
  { c: "05641", n: "Xã Vô Tranh", p: "19" },
  { c: "02191", n: "Xã Xuân Dương", p: "19" },
  { c: "02116", n: "Xã Yên Bình", p: "19" },
  { c: "02083", n: "Xã Yên Phong", p: "19" },
  { c: "02044", n: "Xã Yên Thịnh", p: "19" },
  { c: "05620", n: "Xã Yên Trạch", p: "19" },
  { c: "05977", n: "Phường Đông Kinh", p: "20" },
  { c: "06187", n: "Phường Kỳ Lừa", p: "20" },
  { c: "05983", n: "Phường Lương Văn Tri", p: "20" },
  { c: "05986", n: "Phường Tam Thanh", p: "20" },
  { c: "06196", n: "Xã Ba Sơn", p: "20" },
  { c: "06325", n: "xã Bắc Sơn", p: "20" },
  { c: "06475", n: "Xã Bằng Mạc", p: "20" },
  { c: "06112", n: "Xã Bình Gia", p: "20" },
  { c: "06427", n: "Xã Cai Kinh", p: "20" },
  { c: "06211", n: "Xã Cao Lộc", p: "20" },
  { c: "06637", n: "Xã Châu Sơn", p: "20" },
  { c: "06463", n: "Xã Chi Lăng", p: "20" },
  { c: "06481", n: "Xã Chiến Thắng", p: "20" },
  { c: "06220", n: "Xã Công Sơn", p: "20" },
  { c: "06280", n: "Xã Điềm He", p: "20" },
  { c: "06613", n: "Xã Đình Lập", p: "20" },
  { c: "06001", n: "Xã Đoàn Kết", p: "20" },
  { c: "06184", n: "Xã Đồng Đăng", p: "20" },
  { c: "06073", n: "Xã Hoa Thám", p: "20" },
  { c: "06172", n: "Xã Hoàng Văn Thụ", p: "20" },
  { c: "06151", n: "Xã Hội Hoan", p: "20" },
  { c: "06079", n: "Xã Hồng Phong", p: "20" },
  { c: "06349", n: "Xã Hưng Vũ", p: "20" },
  { c: "06400", n: "Xã Hữu Liên", p: "20" },
  { c: "06385", n: "Xã Hữu Lũng", p: "20" },
  { c: "06037", n: "Xã Kháng Chiến", p: "20" },
  { c: "06286", n: "Xã Khánh Khê", p: "20" },
  { c: "06565", n: "Xã Khuất Xá", p: "20" },
  { c: "06625", n: "Xã Kiên Mộc", p: "20" },
  { c: "06529", n: "Xã Lộc Bình", p: "20" },
  { c: "06601", n: "Xã Lợi Bác", p: "20" },
  { c: "06541", n: "Xã Mẫu Sơn", p: "20" },
  { c: "06526", n: "Xã Na Dương", p: "20" },
  { c: "06124", n: "Xã Na Sầm", p: "20" },
  { c: "06496", n: "Xã Nhân Lý", p: "20" },
  { c: "06376", n: "Xã Nhất Hoà", p: "20" },
  { c: "06517", n: "Xã Quan Sơn", p: "20" },
  { c: "06004", n: "Xã Quốc Khánh", p: "20" },
  { c: "06058", n: "Xã Quốc Việt", p: "20" },
  { c: "06076", n: "Xã Quý Hoà", p: "20" },
  { c: "06316", n: "Xã Tân Đoàn", p: "20" },
  { c: "06445", n: "Xã Tân Thành", p: "20" },
  { c: "06019", n: "Xã Tân Tiến", p: "20" },
  { c: "06337", n: "Xã Tân Tri", p: "20" },
  { c: "06115", n: "Xã Tân Văn", p: "20" },
  { c: "06616", n: "Xã Thái Bình", p: "20" },
  { c: "06040", n: "Xã Thất Khê", p: "20" },
  { c: "06085", n: "Xã Thiện Hoà", p: "20" },
  { c: "06103", n: "Xã Thiện Long", p: "20" },
  { c: "06436", n: "Xã Thiện Tân", p: "20" },
  { c: "06091", n: "Xã Thiện Thuật", p: "20" },
  { c: "06577", n: "Xã Thống Nhất", p: "20" },
  { c: "06148", n: "Xã Thuỵ Hùng", p: "20" },
  { c: "06046", n: "Xã Tràng Định", p: "20" },
  { c: "06313", n: "Xã Tri Lễ", p: "20" },
  { c: "06457", n: "Xã Tuấn Sơn", p: "20" },
  { c: "06505", n: "Xã Vạn Linh", p: "20" },
  { c: "06154", n: "Xã Văn Lãng", p: "20" },
  { c: "06253", n: "Xã Văn Quan", p: "20" },
  { c: "06415", n: "Xã Vân Nham", p: "20" },
  { c: "06367", n: "Xã Vũ Lăng", p: "20" },
  { c: "06364", n: "Xã Vũ Lễ", p: "20" },
  { c: "06607", n: "Xã Xuân Dương", p: "20" },
  { c: "06391", n: "Xã Yên Bình", p: "20" },
  { c: "06298", n: "Xã Yên Phúc", p: "20" },
  { c: "07192", n: "Đặc khu Cô Tô", p: "22" },
  { c: "06994", n: "Đặc khu Vân Đồn", p: "22" },
  { c: "07090", n: "Phường An Sinh", p: "22" },
  { c: "06673", n: "Phường Bãi Cháy", p: "22" },
  { c: "07081", n: "Phường Bình Khê", p: "22" },
  { c: "06658", n: "Phường Cao Xanh", p: "22" },
  { c: "06793", n: "Phường Cẩm Phả", p: "22" },
  { c: "06781", n: "Phường Cửa Ông", p: "22" },
  { c: "07135", n: "Phường Đông Mai", p: "22" },
  { c: "07093", n: "Phường Đông Triều", p: "22" },
  { c: "07168", n: "Phường Hà An", p: "22" },
  { c: "06676", n: "Phường Hà Lầm", p: "22" },
  { c: "06688", n: "Phường Hạ Long", p: "22" },
  { c: "06652", n: "Phường Hà Tu", p: "22" },
  { c: "07147", n: "Phường Hiệp Hoà", p: "22" },
  { c: "07114", n: "Phường Hoàng Quế", p: "22" },
  { c: "07030", n: "Phường Hoành Bồ", p: "22" },
  { c: "06685", n: "Phường Hồng Gai", p: "22" },
  { c: "07180", n: "Phường Liên Hoà", p: "22" },
  { c: "07069", n: "Phường Mạo Khê", p: "22" },
  { c: "06712", n: "Phường Móng Cái 1", p: "22" },
  { c: "06709", n: "Phường Móng Cái 2", p: "22" },
  { c: "06736", n: "Phường Móng Cái 3", p: "22" },
  { c: "06760", n: "Phường Mông Dương", p: "22" },
  { c: "07183", n: "Phường Phong Cốc", p: "22" },
  { c: "06778", n: "Phường Quang Hanh", p: "22" },
  { c: "07132", n: "Phường Quảng Yên", p: "22" },
  { c: "06706", n: "Phường Tuần Châu", p: "22" },
  { c: "06811", n: "Phường Uông Bí", p: "22" },
  { c: "06820", n: "Phường Vàng Danh", p: "22" },
  { c: "06661", n: "Phường Việt Hưng", p: "22" },
  { c: "06832", n: "Phường Yên Tử", p: "22" },
  { c: "06978", n: "Xã Ba Chẽ", p: "22" },
  { c: "06838", n: "Xã Bình Liêu", p: "22" },
  { c: "06967", n: "Xã Cái Chiên", p: "22" },
  { c: "06895", n: "Xã Đầm Hà", p: "22" },
  { c: "06874", n: "Xã Điền Xá", p: "22" },
  { c: "06877", n: "Xã Đông Ngũ", p: "22" },
  { c: "06946", n: "Xã Đường Hoa", p: "22" },
  { c: "06799", n: "Xã Hải Hoà", p: "22" },
  { c: "06886", n: "Xã Hải Lạng", p: "22" },
  { c: "06733", n: "Xã Hải Ninh", p: "22" },
  { c: "06724", n: "Xã Hải Sơn", p: "22" },
  { c: "06841", n: "Xã Hoành Mô", p: "22" },
  { c: "06979", n: "Xã Kỳ Thượng", p: "22" },
  { c: "06856", n: "Xã Lục Hồn", p: "22" },
  { c: "06985", n: "Xã Lương Minh", p: "22" },
  { c: "06931", n: "Xã Quảng Đức", p: "22" },
  { c: "06922", n: "Xã Quảng Hà", p: "22" },
  { c: "07054", n: "Xã Quảng La", p: "22" },
  { c: "06913", n: "Xã Quảng Tân", p: "22" },
  { c: "07060", n: "Xã Thống Nhất", p: "22" },
  { c: "06862", n: "Xã Tiên Yên", p: "22" },
  { c: "06757", n: "Xã Vĩnh Thực", p: "22" },
  { c: "07210", n: "Phường Bắc Giang", p: "24" },
  { c: "09295", n: "Phường Bồng Lai", p: "24" },
  { c: "07738", n: "Phường Cảnh Thuỵ", p: "24" },
  { c: "07525", n: "Phường Chũ", p: "24" },
  { c: "07228", n: "Phường Đa Mai", p: "24" },
  { c: "09301", n: "Phường Đào Viên", p: "24" },
  { c: "09385", n: "Phường Đồng Nguyên", p: "24" },
  { c: "09325", n: "Phường Hạp Lĩnh", p: "24" },
  { c: "09187", n: "Phường Kinh Bắc", p: "24" },
  { c: "09409", n: "Phường Mão Điền", p: "24" },
  { c: "09286", n: "Phường Nam Sơn", p: "24" },
  { c: "07795", n: "Phường Nếnh", p: "24" },
  { c: "09253", n: "Phường Nhân Hoà", p: "24" },
  { c: "09445", n: "Phường Ninh Xá", p: "24" },
  { c: "09379", n: "Phường Phù Khê", p: "24" },
  { c: "09265", n: "Phường Phương Liễu", p: "24" },
  { c: "07612", n: "Phường Phượng Sơn", p: "24" },
  { c: "09247", n: "Phường Quế Võ", p: "24" },
  { c: "09433", n: "Phường Song Liễu", p: "24" },
  { c: "09370", n: "Phường Tam Sơn", p: "24" },
  { c: "07682", n: "Phường Tân An", p: "24" },
  { c: "07699", n: "Phường Tân Tiến", p: "24" },
  { c: "09400", n: "Phường Thuận Thành", p: "24" },
  { c: "07696", n: "Phường Tiền Phong", p: "24" },
  { c: "09430", n: "Phường Trạm Lộ", p: "24" },
  { c: "09427", n: "Phường Trí Quả", p: "24" },
  { c: "07774", n: "Phường Tự Lạn", p: "24" },
  { c: "09367", n: "Phường Từ Sơn", p: "24" },
  { c: "07798", n: "Phường Vân Hà", p: "24" },
  { c: "07777", n: "Phường Việt Yên", p: "24" },
  { c: "09190", n: "Phường Võ Cường", p: "24" },
  { c: "09169", n: "Phường Vũ Ninh", p: "24" },
  { c: "07681", n: "Phường Yên Dũng", p: "24" },
  { c: "07654", n: "Xã An Lạc", p: "24" },
  { c: "07462", n: "Xã Bảo Đài", p: "24" },
  { c: "07498", n: "Xã Bắc Lũng", p: "24" },
  { c: "07573", n: "Xã Biển Động", p: "24" },
  { c: "07537", n: "Xã Biên Sơn", p: "24" },
  { c: "07294", n: "Xã Bố Hạ", p: "24" },
  { c: "09466", n: "Xã Cao Đức", p: "24" },
  { c: "07519", n: "Xã Cẩm Lý", p: "24" },
  { c: "09313", n: "Xã Chi Lăng", p: "24" },
  { c: "07672", n: "Xã Dương Hưu", p: "24" },
  { c: "09340", n: "Xã Đại Đồng", p: "24" },
  { c: "09469", n: "Xã Đại Lai", p: "24" },
  { c: "07627", n: "Xã Đại Sơn", p: "24" },
  { c: "07594", n: "Xã Đèo Gia", p: "24" },
  { c: "09487", n: "Xã Đông Cứu", p: "24" },
  { c: "07282", n: "Xã Đồng Kỳ", p: "24" },
  { c: "07450", n: "Xã Đông Phú", p: "24" },
  { c: "07735", n: "Xã Đồng Việt", p: "24" },
  { c: "09454", n: "Xã Gia Bình", p: "24" },
  { c: "07840", n: "Xã Hiệp Hoà", p: "24" },
  { c: "07822", n: "Xã Hoàng Vân", p: "24" },
  { c: "07864", n: "Xã Hợp Thịnh", p: "24" },
  { c: "07399", n: "Xã Kép", p: "24" },
  { c: "07552", n: "Xã Kiên Lao", p: "24" },
  { c: "07375", n: "Xã Lạng Giang", p: "24" },
  { c: "09529", n: "Xã Lâm Thao", p: "24" },
  { c: "09334", n: "Xã Liên Bão", p: "24" },
  { c: "07444", n: "Xã Lục Nam", p: "24" },
  { c: "07582", n: "Xã Lục Ngạn", p: "24" },
  { c: "07492", n: "Xã Lục Sơn", p: "24" },
  { c: "09496", n: "Xã Lương Tài", p: "24" },
  { c: "07420", n: "Xã Mỹ Thái", p: "24" },
  { c: "07603", n: "Xã Nam Dương", p: "24" },
  { c: "07486", n: "Xã Nghĩa Phương", p: "24" },
  { c: "07351", n: "Xã Ngọc Thiện", p: "24" },
  { c: "07306", n: "Xã Nhã Nam", p: "24" },
  { c: "09475", n: "Xã Nhân Thắng", p: "24" },
  { c: "09349", n: "Xã Phật Tích", p: "24" },
  { c: "09292", n: "Xã Phù Lãng", p: "24" },
  { c: "07330", n: "Xã Phúc Hoà", p: "24" },
  { c: "07333", n: "Xã Quang Trung", p: "24" },
  { c: "07534", n: "Xã Sa Lý", p: "24" },
  { c: "07615", n: "Xã Sơn Động", p: "24" },
  { c: "07543", n: "Xã Sơn Hải", p: "24" },
  { c: "09208", n: "Xã Tam Đa", p: "24" },
  { c: "09202", n: "Xã Tam Giang", p: "24" },
  { c: "07264", n: "Xã Tam Tiến", p: "24" },
  { c: "09343", n: "Xã Tân Chi", p: "24" },
  { c: "07432", n: "Xã Tân Dĩnh", p: "24" },
  { c: "07531", n: "Xã Tân Sơn", p: "24" },
  { c: "07339", n: "Xã Tân Yên", p: "24" },
  { c: "07616", n: "Xã Tây Yên Tử", p: "24" },
  { c: "09319", n: "Xã Tiên Du", p: "24" },
  { c: "07381", n: "Xã Tiên Lục", p: "24" },
  { c: "09523", n: "Xã Trung Chính", p: "24" },
  { c: "09499", n: "Xã Trung Kênh", p: "24" },
  { c: "07489", n: "Xã Trường Sơn", p: "24" },
  { c: "07663", n: "Xã Tuấn Đạo", p: "24" },
  { c: "09238", n: "Xã Văn Môn", p: "24" },
  { c: "07621", n: "Xã Vân Sơn", p: "24" },
  { c: "07870", n: "Xã Xuân Cẩm", p: "24" },
  { c: "07246", n: "Xã Xuân Lương", p: "24" },
  { c: "07642", n: "Xã Yên Định", p: "24" },
  { c: "09193", n: "Xã Yên Phong", p: "24" },
  { c: "07288", n: "Xã Yên Thế", p: "24" },
  { c: "09205", n: "Xã Yên Trung", p: "24" },
  { c: "07948", n: "Phường Âu Cơ", p: "25" },
  { c: "04795", n: "Phường Hoà Bình", p: "25" },
  { c: "04894", n: "Phường Kỳ Sơn", p: "25" },
  { c: "07894", n: "Phường Nông Trang", p: "25" },
  { c: "07954", n: "Phường Phong Châu", p: "25" },
  { c: "07942", n: "Phường Phú Thọ", p: "25" },
  { c: "08740", n: "Phường Phúc Yên", p: "25" },
  { c: "04792", n: "Phường Tân Hoà", p: "25" },
  { c: "07909", n: "Phường Thanh Miếu", p: "25" },
  { c: "04828", n: "Phường Thống Nhất", p: "25" },
  { c: "07918", n: "Phường Vân Phú", p: "25" },
  { c: "07900", n: "Phường Việt Trì", p: "25" },
  { c: "08716", n: "Phường Vĩnh Phúc", p: "25" },
  { c: "08707", n: "Phường Vĩnh Yên", p: "25" },
  { c: "08746", n: "Phường Xuân Hoà", p: "25" },
  { c: "05425", n: "Xã An Bình", p: "25" },
  { c: "05395", n: "Xã An Nghĩa", p: "25" },
  { c: "08527", n: "Xã Bản Nguyên", p: "25" },
  { c: "05245", n: "Xã Bao La", p: "25" },
  { c: "07996", n: "Xã Bằng Luân", p: "25" },
  { c: "08935", n: "Xã Bình Nguyên", p: "25" },
  { c: "08275", n: "Xã Bình Phú", p: "25" },
  { c: "08944", n: "Xã Bình Tuyền", p: "25" },
  { c: "08950", n: "Xã Bình Xuyên", p: "25" },
  { c: "05047", n: "Xã Cao Dương", p: "25" },
  { c: "05089", n: "Xã Cao Phong", p: "25" },
  { c: "04876", n: "Xã Cao Sơn", p: "25" },
  { c: "08341", n: "Xã Cẩm Khê", p: "25" },
  { c: "08038", n: "Xã Chân Mộng", p: "25" },
  { c: "07999", n: "Xã Chí Đám", p: "25" },
  { c: "08218", n: "Xã Chí Tiên", p: "25" },
  { c: "08614", n: "Xã Cự Đồng", p: "25" },
  { c: "08254", n: "Xã Dân Chủ", p: "25" },
  { c: "05086", n: "Xã Dũng Tiến", p: "25" },
  { c: "04831", n: "Xã Đà Bắc", p: "25" },
  { c: "08923", n: "Xã Đại Đình", p: "25" },
  { c: "05347", n: "Xã Đại Đồng", p: "25" },
  { c: "08071", n: "Xã Đan Thượng", p: "25" },
  { c: "08914", n: "Xã Đạo Trù", p: "25" },
  { c: "08662", n: "Xã Đào Xá", p: "25" },
  { c: "07969", n: "Xã Đoan Hùng", p: "25" },
  { c: "08431", n: "Xã Đồng Lương", p: "25" },
  { c: "08209", n: "Xã Đông Thành", p: "25" },
  { c: "04846", n: "Xã Đức Nhàn", p: "25" },
  { c: "08053", n: "Xã Hạ Hoà", p: "25" },
  { c: "08782", n: "Xã Hải Lựu", p: "25" },
  { c: "08110", n: "Xã Hiền Lương", p: "25" },
  { c: "08443", n: "Xã Hiền Quan", p: "25" },
  { c: "08896", n: "Xã Hoàng An", p: "25" },
  { c: "08203", n: "Xã Hoàng Cương", p: "25" },
  { c: "08905", n: "Xã Hội Thịnh", p: "25" },
  { c: "05068", n: "Xã Hợp Kim", p: "25" },
  { c: "08770", n: "Xã Hợp Lý", p: "25" },
  { c: "08416", n: "Xã Hùng Việt", p: "25" },
  { c: "08632", n: "Xã Hương Cần", p: "25" },
  { c: "08515", n: "Xã Hy Cương", p: "25" },
  { c: "08635", n: "Xã Khả Cửu", p: "25" },
  { c: "04978", n: "Xã Kim Bôi", p: "25" },
  { c: "05362", n: "Xã Lạc Lương", p: "25" },
  { c: "05266", n: "Xã Lạc Sơn", p: "25" },
  { c: "05392", n: "Xã Lạc Thuỷ", p: "25" },
  { c: "08560", n: "Xã Lai Đồng", p: "25" },
  { c: "08494", n: "Xã Lâm Thao", p: "25" },
  { c: "08761", n: "Xã Lập Thạch", p: "25" },
  { c: "09064", n: "Xã Liên Châu", p: "25" },
  { c: "08812", n: "Xã Liên Hoà", p: "25" },
  { c: "08227", n: "Xã Liên Minh", p: "25" },
  { c: "04960", n: "Xã Liên Sơn", p: "25" },
  { c: "08620", n: "Xã Long Cốc", p: "25" },
  { c: "04924", n: "Xã Lương Sơn", p: "25" },
  { c: "05200", n: "Xã Mai Châu", p: "25" },
  { c: "05251", n: "Xã Mai Hạ", p: "25" },
  { c: "08593", n: "Xã Minh Đài", p: "25" },
  { c: "08338", n: "Xã Minh Hoà", p: "25" },
  { c: "05158", n: "Xã Mường Bi", p: "25" },
  { c: "05014", n: "Xã Mường Động", p: "25" },
  { c: "05134", n: "Xã Mường Hoa", p: "25" },
  { c: "05116", n: "Xã Mường Thàng", p: "25" },
  { c: "05287", n: "Xã Mường Vang", p: "25" },
  { c: "04990", n: "Xã Nật Sơn", p: "25" },
  { c: "05329", n: "Xã Ngọc Sơn", p: "25" },
  { c: "09052", n: "Xã Nguyệt Đức", p: "25" },
  { c: "05290", n: "Xã Nhân Nghĩa", p: "25" },
  { c: "05212", n: "Xã Pà Cò", p: "25" },
  { c: "08398", n: "Xã Phú Khê", p: "25" },
  { c: "08236", n: "Xã Phú Mỹ", p: "25" },
  { c: "08230", n: "Xã Phù Ninh", p: "25" },
  { c: "08521", n: "Xã Phùng Nguyên", p: "25" },
  { c: "08173", n: "Xã Quảng Yên", p: "25" },
  { c: "04873", n: "Xã Quy Đức", p: "25" },
  { c: "05323", n: "Xã Quyết Thắng", p: "25" },
  { c: "08848", n: "Xã Sông Lô", p: "25" },
  { c: "08866", n: "Xã Sơn Đông", p: "25" },
  { c: "08296", n: "Xã Sơn Lương", p: "25" },
  { c: "08869", n: "Xã Tam Dương", p: "25" },
  { c: "08872", n: "Xã Tam Dương Bắc", p: "25" },
  { c: "08911", n: "Xã Tam Đảo", p: "25" },
  { c: "09043", n: "Xã Tam Hồng", p: "25" },
  { c: "08434", n: "Xã Tam Nông", p: "25" },
  { c: "08824", n: "Xã Tam Sơn", p: "25" },
  { c: "05128", n: "Xã Tân Lạc", p: "25" },
  { c: "05206", n: "Xã Tân Mai", p: "25" },
  { c: "04849", n: "Xã Tân Pheo", p: "25" },
  { c: "08566", n: "Xã Tân Sơn", p: "25" },
  { c: "08023", n: "Xã Tây Cốc", p: "25" },
  { c: "09040", n: "Xã Tề Lỗ", p: "25" },
  { c: "08788", n: "Xã Thái Hoà", p: "25" },
  { c: "08152", n: "Xã Thanh Ba", p: "25" },
  { c: "08542", n: "Xã Thanh Sơn", p: "25" },
  { c: "08674", n: "Xã Thanh Thuỷ", p: "25" },
  { c: "04897", n: "Xã Thịnh Minh", p: "25" },
  { c: "08479", n: "Xã Thọ Văn", p: "25" },
  { c: "09112", n: "Xã Thổ Tang", p: "25" },
  { c: "08545", n: "Xã Thu Cúc", p: "25" },
  { c: "05092", n: "Xã Thung Nai", p: "25" },
  { c: "05293", n: "Xã Thượng Cốc", p: "25" },
  { c: "08323", n: "Xã Thượng Long", p: "25" },
  { c: "08842", n: "Xã Tiên Lữ", p: "25" },
  { c: "08344", n: "Xã Tiên Lương", p: "25" },
  { c: "04891", n: "Xã Tiền Phong", p: "25" },
  { c: "05191", n: "Xã Toàn Thắng", p: "25" },
  { c: "08245", n: "Xã Trạm Thản", p: "25" },
  { c: "08311", n: "Xã Trung Sơn", p: "25" },
  { c: "08686", n: "Xã Tu Vũ", p: "25" },
  { c: "08467", n: "Xã Vạn Xuân", p: "25" },
  { c: "08134", n: "Xã Văn Lang", p: "25" },
  { c: "08611", n: "Xã Văn Miếu", p: "25" },
  { c: "08377", n: "Xã Vân Bán", p: "25" },
  { c: "05152", n: "Xã Vân Sơn", p: "25" },
  { c: "09079", n: "Xã Vĩnh An", p: "25" },
  { c: "08143", n: "Xã Vĩnh Chân", p: "25" },
  { c: "09100", n: "Xã Vĩnh Hưng", p: "25" },
  { c: "09154", n: "Xã Vĩnh Phú", p: "25" },
  { c: "09106", n: "Xã Vĩnh Thành", p: "25" },
  { c: "09076", n: "Xã Vĩnh Tường", p: "25" },
  { c: "08584", n: "Xã Võ Miếu", p: "25" },
  { c: "08590", n: "Xã Xuân Đài", p: "25" },
  { c: "08971", n: "Xã Xuân Lãng", p: "25" },
  { c: "08500", n: "Xã Xuân Lũng", p: "25" },
  { c: "08305", n: "Xã Xuân Viên", p: "25" },
  { c: "08113", n: "Xã Yên Kỳ", p: "25" },
  { c: "09025", n: "Xã Yên Lạc", p: "25" },
  { c: "08773", n: "Xã Yên Lãng", p: "25" },
  { c: "08290", n: "Xã Yên Lập", p: "25" },
  { c: "05305", n: "Xã Yên Phú", p: "25" },
  { c: "08656", n: "Xã Yên Sơn", p: "25" },
  { c: "05353", n: "Xã Yên Thuỷ", p: "25" },
  { c: "05386", n: "Xã Yên Trị", p: "25" },
  { c: "11948", n: "Đặc khu Bạch Long Vĩ", p: "31" },
  { c: "11914", n: "Đặc khu Cát Hải", p: "31" },
  { c: "10660", n: "Phường Ái Quốc", p: "31" },
  { c: "11407", n: "Phường An Biên", p: "31" },
  { c: "11581", n: "Phường An Dương", p: "31" },
  { c: "11617", n: "Phường An Hải", p: "31" },
  { c: "11593", n: "Phường An Phong", p: "31" },
  { c: "11473", n: "Phường Bạch Đằng", p: "31" },
  { c: "10678", n: "Phường Bắc An Phụ", p: "31" },
  { c: "10546", n: "Phường Chí Linh", p: "31" },
  { c: "10549", n: "Phường Chu Văn An", p: "31" },
  { c: "11692", n: "Phường Dương Kinh", p: "31" },
  { c: "11455", n: "Phường Đồ Sơn", p: "31" },
  { c: "11411", n: "Phường Đông Hải", p: "31" },
  { c: "11359", n: "Phường Gia Viên", p: "31" },
  { c: "11413", n: "Phường Hải An", p: "31" },
  { c: "10525", n: "Phường Hải Dương", p: "31" },
  { c: "11533", n: "Phường Hoà Bình", p: "31" },
  { c: "11602", n: "Phường Hồng An", p: "31" },
  { c: "11311", n: "Phường Hồng Bàng", p: "31" },
  { c: "11689", n: "Phường Hưng Đạo", p: "31" },
  { c: "11443", n: "Phường Kiến An", p: "31" },
  { c: "10675", n: "Phường Kinh Môn", p: "31" },
  { c: "11383", n: "Phường Lê Chân", p: "31" },
  { c: "10603", n: "Phường Lê Đại Hành", p: "31" },
  { c: "11506", n: "Phường Lê Ích Mộc", p: "31" },
  { c: "10532", n: "Phường Lê Thanh Nghị", p: "31" },
  { c: "11488", n: "Phường Lưu Kiếm", p: "31" },
  { c: "11737", n: "Phường Nam Đồ Sơn", p: "31" },
  { c: "10837", n: "Phường Nam Đồng", p: "31" },
  { c: "11542", n: "Phường Nam Triệu", p: "31" },
  { c: "11329", n: "Phường Ngô Quyền", p: "31" },
  { c: "10744", n: "Phường Nguyễn Đại Năng", p: "31" },
  { c: "10552", n: "Phường Nguyễn Trãi", p: "31" },
  { c: "10714", n: "Phường Nhị Chiểu", p: "31" },
  { c: "10726", n: "Phường Phạm Sư Mạnh", p: "31" },
  { c: "11446", n: "Phường Phù Liễn", p: "31" },
  { c: "10537", n: "Phường Tân Hưng", p: "31" },
  { c: "11002", n: "Phường Thạch Khôi", p: "31" },
  { c: "10507", n: "Phường Thành Đông", p: "31" },
  { c: "11557", n: "Phường Thiên Hương", p: "31" },
  { c: "11560", n: "Phường Thuỷ Nguyên", p: "31" },
  { c: "10570", n: "Phường Trần Hưng Đạo", p: "31" },
  { c: "10729", n: "Phường Trần Liễu", p: "31" },
  { c: "10573", n: "Phường Trần Nhân Tông", p: "31" },
  { c: "10891", n: "Phường Tứ Minh", p: "31" },
  { c: "10543", n: "Phường Việt Hoà", p: "31" },
  { c: "11674", n: "Xã An Hưng", p: "31" },
  { c: "11668", n: "Xã An Khánh", p: "31" },
  { c: "11629", n: "Xã An Lão", p: "31" },
  { c: "10645", n: "Xã An Phú", p: "31" },
  { c: "11647", n: "Xã An Quang", p: "31" },
  { c: "10792", n: "Xã An Thành", p: "31" },
  { c: "11635", n: "Xã An Trường", p: "31" },
  { c: "11254", n: "Xã Bắc Thanh Miện", p: "31" },
  { c: "10966", n: "Xã Bình Giang", p: "31" },
  { c: "10888", n: "Xã Cẩm Giang", p: "31" },
  { c: "10903", n: "Xã Cẩm Giàng", p: "31" },
  { c: "11806", n: "Xã Chấn Hưng", p: "31" },
  { c: "11131", n: "Xã Chí Minh", p: "31" },
  { c: "11086", n: "Xã Đại Sơn", p: "31" },
  { c: "10972", n: "Xã Đường An", p: "31" },
  { c: "10999", n: "Xã Gia Lộc", p: "31" },
  { c: "11050", n: "Xã Gia Phúc", p: "31" },
  { c: "10816", n: "Xã Hà Bắc", p: "31" },
  { c: "10882", n: "Xã Hà Đông", p: "31" },
  { c: "10843", n: "Xã Hà Nam", p: "31" },
  { c: "10846", n: "Xã Hà Tây", p: "31" },
  { c: "11257", n: "Xã Hải Hưng", p: "31" },
  { c: "11218", n: "Xã Hồng Châu", p: "31" },
  { c: "10615", n: "Xã Hợp Tiến", p: "31" },
  { c: "11809", n: "Xã Hùng Thắng", p: "31" },
  { c: "10945", n: "Xã Kẻ Sặt", p: "31" },
  { c: "11224", n: "Xã Khúc Thừa Dụ", p: "31" },
  { c: "11749", n: "Xã Kiến Hải", p: "31" },
  { c: "11728", n: "Xã Kiến Hưng", p: "31" },
  { c: "11725", n: "Xã Kiến Minh", p: "31" },
  { c: "11680", n: "Xã Kiến Thuỵ", p: "31" },
  { c: "10804", n: "Xã Kim Thành", p: "31" },
  { c: "11140", n: "Xã Lạc Phượng", p: "31" },
  { c: "10756", n: "Xã Lai Khê", p: "31" },
  { c: "10930", n: "Xã Mao Điền", p: "31" },
  { c: "10705", n: "Xã Nam An Phụ", p: "31" },
  { c: "10606", n: "Xã Nam Sách", p: "31" },
  { c: "11284", n: "Xã Nam Thanh Miện", p: "31" },
  { c: "11713", n: "Xã Nghi Dương", p: "31" },
  { c: "11911", n: "Xã Nguyễn Bỉnh Khiêm", p: "31" },
  { c: "11146", n: "Xã Nguyên Giáp", p: "31" },
  { c: "11242", n: "Xã Nguyễn Lương Bằng", p: "31" },
  { c: "11203", n: "Xã Ninh Giang", p: "31" },
  { c: "10750", n: "Xã Phú Thái", p: "31" },
  { c: "11761", n: "Xã Quyết Thắng", p: "31" },
  { c: "11167", n: "Xã Tân An", p: "31" },
  { c: "11113", n: "Xã Tân Kỳ", p: "31" },
  { c: "11779", n: "Xã Tân Minh", p: "31" },
  { c: "10642", n: "Xã Thái Tân", p: "31" },
  { c: "10813", n: "Xã Thanh Hà", p: "31" },
  { c: "11239", n: "Xã Thanh Miện", p: "31" },
  { c: "10993", n: "Xã Thượng Hồng", p: "31" },
  { c: "11755", n: "Xã Tiên Lãng", p: "31" },
  { c: "11791", n: "Xã Tiên Minh", p: "31" },
  { c: "10633", n: "Xã Trần Phú", p: "31" },
  { c: "11065", n: "Xã Trường Tân", p: "31" },
  { c: "10909", n: "Xã Tuệ Tĩnh", p: "31" },
  { c: "11074", n: "Xã Tứ Kỳ", p: "31" },
  { c: "11503", n: "Xã Việt Khê", p: "31" },
  { c: "11887", n: "Xã Vĩnh Am", p: "31" },
  { c: "11824", n: "Xã Vĩnh Bảo", p: "31" },
  { c: "11875", n: "Xã Vĩnh Hải", p: "31" },
  { c: "11848", n: "Xã Vĩnh Hoà", p: "31" },
  { c: "11164", n: "Xã Vĩnh Lại", p: "31" },
  { c: "11836", n: "Xã Vĩnh Thịnh", p: "31" },
  { c: "11842", n: "Xã Vĩnh Thuận", p: "31" },
  { c: "11020", n: "Xã Yết Kiêu", p: "31" },
  { c: "12133", n: "Phường Đường Hào", p: "33" },
  { c: "11980", n: "Phường Hồng Châu", p: "33" },
  { c: "12103", n: "Phường Mỹ Hào", p: "33" },
  { c: "11953", n: "Phường Phố Hiến", p: "33" },
  { c: "11983", n: "Phường Sơn Nam", p: "33" },
  { c: "13225", n: "Phường Thái Bình", p: "33" },
  { c: "12127", n: "Phường Thượng Hồng", p: "33" },
  { c: "12817", n: "Phường Trà Lý", p: "33" },
  { c: "12452", n: "Phường Trần Hưng Đạo", p: "33" },
  { c: "12454", n: "Phường Trần Lãm", p: "33" },
  { c: "12466", n: "Phường Vũ Phúc", p: "33" },
  { c: "12499", n: "Xã A Sào", p: "33" },
  { c: "13021", n: "Xã Ái Quốc", p: "33" },
  { c: "12142", n: "Xã Ân Thi", p: "33" },
  { c: "12694", n: "Xã Bắc Đông Hưng", p: "33" },
  { c: "12745", n: "Xã Bắc Đông Quan", p: "33" },
  { c: "12916", n: "Xã Bắc Thái Ninh", p: "33" },
  { c: "12859", n: "Xã Bắc Thuỵ Anh", p: "33" },
  { c: "12700", n: "Xã Bắc Tiên Hưng", p: "33" },
  { c: "13186", n: "Xã Bình Định", p: "33" },
  { c: "13096", n: "Xã Bình Nguyên", p: "33" },
  { c: "13183", n: "Xã Bình Thanh", p: "33" },
  { c: "12247", n: "Xã Châu Ninh", p: "33" },
  { c: "12271", n: "Xã Chí Minh", p: "33" },
  { c: "12619", n: "Xã Diên Hà", p: "33" },
  { c: "11995", n: "Xã Đại Đồng", p: "33" },
  { c: "12406", n: "Xã Đoàn Đào", p: "33" },
  { c: "12526", n: "Xã Đồng Bằng", p: "33" },
  { c: "13003", n: "Xã Đồng Châu", p: "33" },
  { c: "12688", n: "Xã Đông Hưng", p: "33" },
  { c: "12793", n: "Xã Đông Quan", p: "33" },
  { c: "12943", n: "Xã Đông Thái Ninh", p: "33" },
  { c: "12862", n: "Xã Đông Thuỵ Anh", p: "33" },
  { c: "12988", n: "Xã Đông Tiền Hải", p: "33" },
  { c: "12736", n: "Xã Đông Tiên Hưng", p: "33" },
  { c: "12313", n: "Xã Đức Hợp", p: "33" },
  { c: "12322", n: "Xã Hiệp Cường", p: "33" },
  { c: "12070", n: "Xã Hoàn Long", p: "33" },
  { c: "12337", n: "Xã Hoàng Hoa Thám", p: "33" },
  { c: "12685", n: "Xã Hồng Minh", p: "33" },
  { c: "12196", n: "Xã Hồng Quang", p: "33" },
  { c: "13159", n: "Xã Hồng Vũ", p: "33" },
  { c: "12586", n: "Xã Hưng Hà", p: "33" },
  { c: "13066", n: "Xã Hưng Phú", p: "33" },
  { c: "12205", n: "Xã Khoái Châu", p: "33" },
  { c: "13075", n: "Xã Kiến Xương", p: "33" },
  { c: "11992", n: "Xã Lạc Đạo", p: "33" },
  { c: "13120", n: "Xã Lê Lợi", p: "33" },
  { c: "12676", n: "Xã Lê Quý Đôn", p: "33" },
  { c: "12613", n: "Xã Long Hưng", p: "33" },
  { c: "12280", n: "Xã Lương Bằng", p: "33" },
  { c: "12049", n: "Xã Mễ Sở", p: "33" },
  { c: "12511", n: "Xã Minh Thọ", p: "33" },
  { c: "13057", n: "Xã Nam Cường", p: "33" },
  { c: "12775", n: "Xã Nam Đông Hưng", p: "33" },
  { c: "12961", n: "Xã Nam Thái Ninh", p: "33" },
  { c: "12904", n: "Xã Nam Thuỵ Anh", p: "33" },
  { c: "13063", n: "Xã Nam Tiền Hải", p: "33" },
  { c: "12763", n: "Xã Nam Tiên Hưng", p: "33" },
  { c: "12286", n: "Xã Nghĩa Dân", p: "33" },
  { c: "12031", n: "Xã Nghĩa Trụ", p: "33" },
  { c: "12517", n: "Xã Ngọc Lâm", p: "33" },
  { c: "12532", n: "Xã Nguyễn Du", p: "33" },
  { c: "12184", n: "Xã Nguyễn Trãi", p: "33" },
  { c: "12064", n: "Xã Nguyễn Văn Linh", p: "33" },
  { c: "12595", n: "Xã Ngự Thiên", p: "33" },
  { c: "12004", n: "Xã Như Quỳnh", p: "33" },
  { c: "12148", n: "Xã Phạm Ngũ Lão", p: "33" },
  { c: "12523", n: "Xã Phụ Dực", p: "33" },
  { c: "12025", n: "Xã Phụng Công", p: "33" },
  { c: "12391", n: "Xã Quang Hưng", p: "33" },
  { c: "13132", n: "Xã Quang Lịch", p: "33" },
  { c: "12577", n: "Xã Quỳnh An", p: "33" },
  { c: "12472", n: "Xã Quỳnh Phụ", p: "33" },
  { c: "11977", n: "Xã Tân Hưng", p: "33" },
  { c: "13246", n: "Xã Tân Thuận", p: "33" },
  { c: "12583", n: "Xã Tân Tiến", p: "33" },
  { c: "12919", n: "Xã Tây Thái Ninh", p: "33" },
  { c: "12850", n: "Xã Tây Thuỵ Anh", p: "33" },
  { c: "13039", n: "Xã Tây Tiền Hải", p: "33" },
  { c: "12922", n: "Xã Thái Ninh", p: "33" },
  { c: "12826", n: "Xã Thái Thuỵ", p: "33" },
  { c: "12631", n: "Xã Thần Khê", p: "33" },
  { c: "12865", n: "Xã Thuỵ Anh", p: "33" },
  { c: "13222", n: "Xã Thư Trì", p: "33" },
  { c: "13264", n: "Xã Thư Vũ", p: "33" },
  { c: "12970", n: "Xã Tiền Hải", p: "33" },
  { c: "12361", n: "Xã Tiên Hoa", p: "33" },
  { c: "12754", n: "Xã Tiên Hưng", p: "33" },
  { c: "12634", n: "Xã Tiên La", p: "33" },
  { c: "12364", n: "Xã Tiên Lữ", p: "33" },
  { c: "12424", n: "Xã Tiên Tiến", p: "33" },
  { c: "12427", n: "Xã Tống Trân", p: "33" },
  { c: "13093", n: "Xã Trà Giang", p: "33" },
  { c: "12223", n: "Xã Triệu Việt Vương", p: "33" },
  { c: "13219", n: "Xã Vạn Xuân", p: "33" },
  { c: "12019", n: "Xã Văn Giang", p: "33" },
  { c: "12238", n: "Xã Việt Tiến", p: "33" },
  { c: "12091", n: "Xã Việt Yên", p: "33" },
  { c: "13141", n: "Xã Vũ Quý", p: "33" },
  { c: "13192", n: "Xã Vũ Thư", p: "33" },
  { c: "13279", n: "Xã Vũ Tiên", p: "33" },
  { c: "12166", n: "Xã Xuân Trúc", p: "33" },
  { c: "12073", n: "Xã Yên Mỹ", p: "33" },
  { c: "13318", n: "Phường Châu Sơn", p: "37" },
  { c: "13336", n: "Phường Duy Hà", p: "37" },
  { c: "13330", n: "Phường Duy Tân", p: "37" },
  { c: "13324", n: "Phường Duy Tiên", p: "37" },
  { c: "13693", n: "Phường Đông A", p: "37" },
  { c: "14566", n: "Phường Đông Hoa Lư", p: "37" },
  { c: "13348", n: "Phường Đồng Văn", p: "37" },
  { c: "13366", n: "Phường Hà Nam", p: "37" },
  { c: "14329", n: "Phường Hoa Lư", p: "37" },
  { c: "13984", n: "Phường Hồng Quang", p: "37" },
  { c: "13384", n: "Phường Kim Bảng", p: "37" },
  { c: "13402", n: "Phường Kim Thanh", p: "37" },
  { c: "13393", n: "Phường Lê Hồ", p: "37" },
  { c: "13444", n: "Phường Liêm Tuyền", p: "37" },
  { c: "13435", n: "Phường Lý Thường Kiệt", p: "37" },
  { c: "13708", n: "Phường Mỹ Lộc", p: "37" },
  { c: "13669", n: "Phường Nam Định", p: "37" },
  { c: "14359", n: "Phường Nam Hoa Lư", p: "37" },
  { c: "13396", n: "Phường Nguyễn Úy", p: "37" },
  { c: "13285", n: "Phường Phủ Lý", p: "37" },
  { c: "13291", n: "Phường Phù Vân", p: "37" },
  { c: "13420", n: "Phường Tam Chúc", p: "37" },
  { c: "14362", n: "Phường Tam Điệp", p: "37" },
  { c: "14533", n: "Phường Tây Hoa Lư", p: "37" },
  { c: "13699", n: "Phường Thành Nam", p: "37" },
  { c: "13684", n: "Phường Thiên Trường", p: "37" },
  { c: "13363", n: "Phường Tiên Sơn", p: "37" },
  { c: "14365", n: "Phường Trung Sơn", p: "37" },
  { c: "13777", n: "Phường Trường Thi", p: "37" },
  { c: "13972", n: "Phường Vị Khê", p: "37" },
  { c: "14371", n: "Phường Yên Sơn", p: "37" },
  { c: "14725", n: "Phường Yên Thắng", p: "37" },
  { c: "13579", n: "Xã Bắc Lý", p: "37" },
  { c: "13540", n: "Xã Bình An", p: "37" },
  { c: "13531", n: "Xã Bình Giang", p: "37" },
  { c: "13504", n: "Xã Bình Lục", p: "37" },
  { c: "14623", n: "Xã Bình Minh", p: "37" },
  { c: "13501", n: "Xã Bình Mỹ", p: "37" },
  { c: "13558", n: "Xã Bình Sơn", p: "37" },
  { c: "14056", n: "Xã Cát Thành", p: "37" },
  { c: "14653", n: "Xã Chất Bình", p: "37" },
  { c: "14026", n: "Xã Cổ Lễ", p: "37" },
  { c: "14404", n: "Xã Cúc Phương", p: "37" },
  { c: "14500", n: "Xã Đại Hoàng", p: "37" },
  { c: "14677", n: "Xã Định Hoá", p: "37" },
  { c: "14746", n: "Xã Đồng Thái", p: "37" },
  { c: "13900", n: "Xã Đồng Thịnh", p: "37" },
  { c: "14482", n: "Xã Gia Hưng", p: "37" },
  { c: "14389", n: "Xã Gia Lâm", p: "37" },
  { c: "14524", n: "Xã Gia Phong", p: "37" },
  { c: "14494", n: "Xã Gia Trấn", p: "37" },
  { c: "14401", n: "Xã Gia Tường", p: "37" },
  { c: "14488", n: "Xã Gia Vân", p: "37" },
  { c: "14464", n: "Xã Gia Viễn", p: "37" },
  { c: "14194", n: "Xã Giao Bình", p: "37" },
  { c: "14182", n: "Xã Giao Hoà", p: "37" },
  { c: "14179", n: "Xã Giao Hưng", p: "37" },
  { c: "14161", n: "Xã Giao Minh", p: "37" },
  { c: "14212", n: "Xã Giao Ninh", p: "37" },
  { c: "14203", n: "Xã Giao Phúc", p: "37" },
  { c: "14167", n: "Xã Giao Thuỷ", p: "37" },
  { c: "14281", n: "Xã Hải An", p: "37" },
  { c: "14236", n: "Xã Hải Anh", p: "37" },
  { c: "14215", n: "Xã Hải Hậu", p: "37" },
  { c: "14248", n: "Xã Hải Hưng", p: "37" },
  { c: "14287", n: "Xã Hải Quang", p: "37" },
  { c: "14221", n: "Xã Hải Thịnh", p: "37" },
  { c: "14218", n: "Xã Hải Tiến", p: "37" },
  { c: "14308", n: "Xã Hải Xuân", p: "37" },
  { c: "13753", n: "Xã Hiển Khánh", p: "37" },
  { c: "13927", n: "Xã Hồng Phong", p: "37" },
  { c: "14614", n: "Xã Khánh Hội", p: "37" },
  { c: "14611", n: "Xã Khánh Nhạc", p: "37" },
  { c: "14563", n: "Xã Khánh Thiện", p: "37" },
  { c: "14608", n: "Xã Khánh Trung", p: "37" },
  { c: "14698", n: "Xã Kim Đông", p: "37" },
  { c: "14638", n: "Xã Kim Sơn", p: "37" },
  { c: "14674", n: "Xã Lai Thành", p: "37" },
  { c: "13456", n: "Xã Liêm Hà", p: "37" },
  { c: "13786", n: "Xã Liên Minh", p: "37" },
  { c: "13573", n: "Xã Lý Nhân", p: "37" },
  { c: "13750", n: "Xã Minh Tân", p: "37" },
  { c: "14071", n: "Xã Minh Thái", p: "37" },
  { c: "14014", n: "Xã Nam Đồng", p: "37" },
  { c: "13987", n: "Xã Nam Hồng", p: "37" },
  { c: "13627", n: "Xã Nam Lý", p: "37" },
  { c: "14011", n: "Xã Nam Minh", p: "37" },
  { c: "14005", n: "Xã Nam Ninh", p: "37" },
  { c: "13966", n: "Xã Nam Trực", p: "37" },
  { c: "13591", n: "Xã Nam Xang", p: "37" },
  { c: "13891", n: "Xã Nghĩa Hưng", p: "37" },
  { c: "13957", n: "Xã Nghĩa Lâm", p: "37" },
  { c: "13918", n: "Xã Nghĩa Sơn", p: "37" },
  { c: "13609", n: "Xã Nhân Hà", p: "37" },
  { c: "14428", n: "Xã Nho Quan", p: "37" },
  { c: "14077", n: "Xã Ninh Cường", p: "37" },
  { c: "14038", n: "Xã Ninh Giang", p: "37" },
  { c: "14620", n: "Xã Phát Diệm", p: "37" },
  { c: "13822", n: "Xã Phong Doanh", p: "37" },
  { c: "14458", n: "Xã Phú Long", p: "37" },
  { c: "14407", n: "Xã Phú Sơn", p: "37" },
  { c: "14062", n: "Xã Quang Hưng", p: "37" },
  { c: "14647", n: "Xã Quang Thiện", p: "37" },
  { c: "13939", n: "Xã Quỹ Nhất", p: "37" },
  { c: "14452", n: "Xã Quỳnh Lưu", p: "37" },
  { c: "13894", n: "Xã Rạng Đông", p: "37" },
  { c: "13807", n: "Xã Tân Minh", p: "37" },
  { c: "13474", n: "Xã Tân Thanh", p: "37" },
  { c: "13483", n: "Xã Thanh Bình", p: "37" },
  { c: "13489", n: "Xã Thanh Lâm", p: "37" },
  { c: "13495", n: "Xã Thanh Liêm", p: "37" },
  { c: "14434", n: "Xã Thanh Sơn", p: "37" },
  { c: "13594", n: "Xã Trần Thương", p: "37" },
  { c: "14053", n: "Xã Trực Ninh", p: "37" },
  { c: "13864", n: "Xã Vạn Thắng", p: "37" },
  { c: "13597", n: "Xã Vĩnh Trụ", p: "37" },
  { c: "13741", n: "Xã Vụ Bản", p: "37" },
  { c: "13834", n: "Xã Vũ Dương", p: "37" },
  { c: "14104", n: "Xã Xuân Giang", p: "37" },
  { c: "14095", n: "Xã Xuân Hồng", p: "37" },
  { c: "14122", n: "Xã Xuân Hưng", p: "37" },
  { c: "14089", n: "Xã Xuân Trường", p: "37" },
  { c: "13795", n: "Xã Ý Yên", p: "37" },
  { c: "13870", n: "Xã Yên Cường", p: "37" },
  { c: "13879", n: "Xã Yên Đồng", p: "37" },
  { c: "14560", n: "Xã Yên Khánh", p: "37" },
  { c: "14743", n: "Xã Yên Mạc", p: "37" },
  { c: "14701", n: "Xã Yên Mô", p: "37" },
  { c: "14728", n: "Xã Yên Từ", p: "37" },
  { c: "14812", n: "Phường Bỉm Sơn", p: "38" },
  { c: "16609", n: "Phường Đào Duy Từ", p: "38" },
  { c: "16417", n: "Phường Đông Quang", p: "38" },
  { c: "16378", n: "Phường Đông Sơn", p: "38" },
  { c: "15853", n: "Phường Đông Tiến", p: "38" },
  { c: "14797", n: "Phường Hạc Thành", p: "38" },
  { c: "16645", n: "Phường Hải Bình", p: "38" },
  { c: "16597", n: "Phường Hải Lĩnh", p: "38" },
  { c: "14758", n: "Phường Hàm Rồng", p: "38" },
  { c: "16516", n: "Phường Nam Sầm Sơn", p: "38" },
  { c: "16654", n: "Phường Nghi Sơn", p: "38" },
  { c: "16576", n: "Phường Ngọc Sơn", p: "38" },
  { c: "15925", n: "Phường Nguyệt Viên", p: "38" },
  { c: "16522", n: "Phường Quảng Phú", p: "38" },
  { c: "14818", n: "Phường Quang Trung", p: "38" },
  { c: "16531", n: "Phường Sầm Sơn", p: "38" },
  { c: "16594", n: "Phường Tân Dân", p: "38" },
  { c: "16561", n: "Phường Tĩnh Gia", p: "38" },
  { c: "16624", n: "Phường Trúc Lâm", p: "38" },
  { c: "15766", n: "Xã An Nông", p: "38" },
  { c: "16171", n: "Xã Ba Đình", p: "38" },
  { c: "14923", n: "Xã Bá Thước", p: "38" },
  { c: "15607", n: "Xã Bát Mọt", p: "38" },
  { c: "15382", n: "Xã Biện Thượng", p: "38" },
  { c: "16591", n: "Xã Các Sơn", p: "38" },
  { c: "15178", n: "Xã Cẩm Tân", p: "38" },
  { c: "15142", n: "Xã Cẩm Thạch", p: "38" },
  { c: "15127", n: "Xã Cẩm Thuỷ", p: "38" },
  { c: "15148", n: "Xã Cẩm Tú", p: "38" },
  { c: "15163", n: "Xã Cẩm Vân", p: "38" },
  { c: "14959", n: "Xã Cổ Lũng", p: "38" },
  { c: "16369", n: "Xã Công Chính", p: "38" },
  { c: "14950", n: "Xã Điền Lư", p: "38" },
  { c: "14932", n: "Xã Điền Quang", p: "38" },
  { c: "15448", n: "Xã Định Hoà", p: "38" },
  { c: "15457", n: "Xã Định Tân", p: "38" },
  { c: "15058", n: "Xã Đồng Lương", p: "38" },
  { c: "16033", n: "Xã Đông Thành", p: "38" },
  { c: "15724", n: "Xã Đồng Tiến", p: "38" },
  { c: "15043", n: "Xã Giao An", p: "38" },
  { c: "15274", n: "Xã Hà Long", p: "38" },
  { c: "15271", n: "Xã Hà Trung", p: "38" },
  { c: "16012", n: "Xã Hậu Lộc", p: "38" },
  { c: "14896", n: "Xã Hiền Kiệt", p: "38" },
  { c: "16072", n: "Xã Hoa Lộc", p: "38" },
  { c: "16186", n: "Xã Hoá Quỳ", p: "38" },
  { c: "15286", n: "Xã Hoạt Giang", p: "38" },
  { c: "15976", n: "Xã Hoằng Châu", p: "38" },
  { c: "15880", n: "Xã Hoằng Giang", p: "38" },
  { c: "15865", n: "Xã Hoằng Hoá", p: "38" },
  { c: "15961", n: "Xã Hoằng Lộc", p: "38" },
  { c: "15889", n: "Xã Hoằng Phú", p: "38" },
  { c: "15910", n: "Xã Hoằng Sơn", p: "38" },
  { c: "16000", n: "Xã Hoằng Thanh", p: "38" },
  { c: "15991", n: "Xã Hoằng Tiến", p: "38" },
  { c: "16138", n: "Xã Hồ Vương", p: "38" },
  { c: "14869", n: "Xã Hồi Xuân", p: "38" },
  { c: "15682", n: "Xã Hợp Tiến", p: "38" },
  { c: "15112", n: "Xã Kiên Thọ", p: "38" },
  { c: "15187", n: "Xã Kim Tân", p: "38" },
  { c: "15544", n: "Xã Lam Sơn", p: "38" },
  { c: "15055", n: "Xã Linh Sơn", p: "38" },
  { c: "15298", n: "Xã Lĩnh Toại", p: "38" },
  { c: "15634", n: "Xã Luận Thành", p: "38" },
  { c: "15628", n: "Xã Lương Sơn", p: "38" },
  { c: "16438", n: "Xã Lưu Vệ", p: "38" },
  { c: "16249", n: "Xã Mậu Lâm", p: "38" },
  { c: "15124", n: "Xã Minh Sơn", p: "38" },
  { c: "14866", n: "Xã Mường Chanh", p: "38" },
  { c: "14845", n: "Xã Mường Lát", p: "38" },
  { c: "14854", n: "Xã Mường Lý", p: "38" },
  { c: "15025", n: "Xã Mường Mìn", p: "38" },
  { c: "15013", n: "Xã Na Mèo", p: "38" },
  { c: "14902", n: "Xã Nam Xuân", p: "38" },
  { c: "16144", n: "Xã Nga An", p: "38" },
  { c: "16093", n: "Xã Nga Sơn", p: "38" },
  { c: "16114", n: "Xã Nga Thắng", p: "38" },
  { c: "15061", n: "Xã Ngọc Lặc", p: "38" },
  { c: "15091", n: "Xã Ngọc Liên", p: "38" },
  { c: "15250", n: "Xã Ngọc Trạo", p: "38" },
  { c: "15106", n: "Xã Nguyệt Ấn", p: "38" },
  { c: "14864", n: "Xã Nhi Sơn", p: "38" },
  { c: "16228", n: "Xã Như Thanh", p: "38" },
  { c: "16174", n: "Xã Như Xuân", p: "38" },
  { c: "16279", n: "Xã Nông Cống", p: "38" },
  { c: "14878", n: "Xã Phú Lệ", p: "38" },
  { c: "14890", n: "Xã Phú Xuân", p: "38" },
  { c: "14956", n: "Xã Pù Luông", p: "38" },
  { c: "14863", n: "Xã Pù Nhi", p: "38" },
  { c: "15016", n: "Xã Quan Sơn", p: "38" },
  { c: "16543", n: "Xã Quảng Bình", p: "38" },
  { c: "14860", n: "Xã Quang Chiểu", p: "38" },
  { c: "16489", n: "Xã Quảng Chính", p: "38" },
  { c: "16498", n: "Xã Quảng Ngọc", p: "38" },
  { c: "16540", n: "Xã Quảng Ninh", p: "38" },
  { c: "16480", n: "Xã Quảng Yên", p: "38" },
  { c: "15412", n: "Xã Quý Lộc", p: "38" },
  { c: "14953", n: "Xã Quý Lương", p: "38" },
  { c: "15553", n: "Xã Sao Vàng", p: "38" },
  { c: "15022", n: "Xã Sơn Điện", p: "38" },
  { c: "15010", n: "Xã Sơn Thuỷ", p: "38" },
  { c: "14848", n: "Xã Tam Chung", p: "38" },
  { c: "15019", n: "Xã Tam Lư", p: "38" },
  { c: "15007", n: "Xã Tam Thanh", p: "38" },
  { c: "15715", n: "Xã Tân Ninh", p: "38" },
  { c: "15661", n: "Xã Tân Thành", p: "38" },
  { c: "16108", n: "Xã Tân Tiến", p: "38" },
  { c: "15361", n: "Xã Tây Đô", p: "38" },
  { c: "15211", n: "Xã Thạch Bình", p: "38" },
  { c: "15085", n: "Xã Thạch Lập", p: "38" },
  { c: "15199", n: "Xã Thạch Quảng", p: "38" },
  { c: "16273", n: "Xã Thanh Kỳ", p: "38" },
  { c: "16213", n: "Xã Thanh Phong", p: "38" },
  { c: "16222", n: "Xã Thanh Quân", p: "38" },
  { c: "15229", n: "Xã Thành Vinh", p: "38" },
  { c: "16342", n: "Xã Thăng Bình", p: "38" },
  { c: "15643", n: "Xã Thắng Lộc", p: "38" },
  { c: "16309", n: "Xã Thắng Lợi", p: "38" },
  { c: "14908", n: "Xã Thiên Phủ", p: "38" },
  { c: "14980", n: "Xã Thiết Ống", p: "38" },
  { c: "15772", n: "Xã Thiệu Hoá", p: "38" },
  { c: "15796", n: "Xã Thiệu Quang", p: "38" },
  { c: "15778", n: "Xã Thiệu Tiến", p: "38" },
  { c: "15820", n: "Xã Thiệu Toán", p: "38" },
  { c: "15835", n: "Xã Thiệu Trung", p: "38" },
  { c: "15667", n: "Xã Thọ Bình", p: "38" },
  { c: "15568", n: "Xã Thọ Lập", p: "38" },
  { c: "15505", n: "Xã Thọ Long", p: "38" },
  { c: "15754", n: "Xã Thọ Ngọc", p: "38" },
  { c: "15763", n: "Xã Thọ Phú", p: "38" },
  { c: "15499", n: "Xã Thọ Xuân", p: "38" },
  { c: "16225", n: "Xã Thượng Ninh", p: "38" },
  { c: "15646", n: "Xã Thường Xuân", p: "38" },
  { c: "16549", n: "Xã Tiên Trang", p: "38" },
  { c: "15316", n: "Xã Tống Sơn", p: "38" },
  { c: "16021", n: "Xã Triệu Lộc", p: "38" },
  { c: "15664", n: "Xã Triệu Sơn", p: "38" },
  { c: "16297", n: "Xã Trung Chính", p: "38" },
  { c: "15001", n: "Xã Trung Hạ", p: "38" },
  { c: "14857", n: "Xã Trung Lý", p: "38" },
  { c: "14875", n: "Xã Trung Sơn", p: "38" },
  { c: "14872", n: "Xã Trung Thành", p: "38" },
  { c: "16636", n: "Xã Trường Lâm", p: "38" },
  { c: "16348", n: "Xã Trường Văn", p: "38" },
  { c: "16363", n: "Xã Tượng Lĩnh", p: "38" },
  { c: "16078", n: "Xã Vạn Lộc", p: "38" },
  { c: "15622", n: "Xã Vạn Xuân", p: "38" },
  { c: "14974", n: "Xã Văn Nho", p: "38" },
  { c: "15049", n: "Xã Văn Phú", p: "38" },
  { c: "15190", n: "Xã Vân Du", p: "38" },
  { c: "15349", n: "Xã Vĩnh Lộc", p: "38" },
  { c: "16177", n: "Xã Xuân Bình", p: "38" },
  { c: "15658", n: "Xã Xuân Chinh", p: "38" },
  { c: "16234", n: "Xã Xuân Du", p: "38" },
  { c: "15520", n: "Xã Xuân Hoà", p: "38" },
  { c: "15592", n: "Xã Xuân Lập", p: "38" },
  { c: "16258", n: "Xã Xuân Thái", p: "38" },
  { c: "15574", n: "Xã Xuân Tín", p: "38" },
  { c: "15469", n: "Xã Yên Định", p: "38" },
  { c: "15031", n: "Xã Yên Khương", p: "38" },
  { c: "15610", n: "Xã Yên Nhân", p: "38" },
  { c: "15442", n: "Xã Yên Ninh", p: "38" },
  { c: "15409", n: "Xã Yên Phú", p: "38" },
  { c: "15034", n: "Xã Yên Thắng", p: "38" },
  { c: "16264", n: "Xã Yên Thọ", p: "38" },
  { c: "15421", n: "Xã Yên Trường", p: "38" },
  { c: "16732", n: "Phường Cửa Lò", p: "40" },
  { c: "17110", n: "Phường Hoàng Mai", p: "40" },
  { c: "17125", n: "Phường Quỳnh Mai", p: "40" },
  { c: "17128", n: "Phường Tân Mai", p: "40" },
  { c: "17011", n: "Phường Tây Hiếu", p: "40" },
  { c: "16939", n: "Phường Thái Hoà", p: "40" },
  { c: "16681", n: "Phường Thành Vinh", p: "40" },
  { c: "16690", n: "Phường Trường Vinh", p: "40" },
  { c: "17920", n: "Phường Vinh Hưng", p: "40" },
  { c: "16708", n: "Phường Vinh Lộc", p: "40" },
  { c: "16702", n: "Phường Vinh Phú", p: "40" },
  { c: "17479", n: "Xã An Châu", p: "40" },
  { c: "17329", n: "Xã Anh Sơn", p: "40" },
  { c: "17365", n: "Xã Anh Sơn Đông", p: "40" },
  { c: "17707", n: "Xã Bạch Hà", p: "40" },
  { c: "17623", n: "Xã Bạch Ngọc", p: "40" },
  { c: "16819", n: "Xã Bắc Lý", p: "40" },
  { c: "17818", n: "Xã Bích Hào", p: "40" },
  { c: "17230", n: "Xã Bình Chuẩn", p: "40" },
  { c: "17515", n: "Xã Bình Minh", p: "40" },
  { c: "17242", n: "Xã Cam Phục", p: "40" },
  { c: "17728", n: "Xã Cát Ngạn", p: "40" },
  { c: "16804", n: "Xã Châu Bình", p: "40" },
  { c: "17044", n: "Xã Châu Hồng", p: "40" },
  { c: "17248", n: "Xã Châu Khê", p: "40" },
  { c: "17056", n: "Xã Châu Lộc", p: "40" },
  { c: "16792", n: "Xã Châu Tiến", p: "40" },
  { c: "16855", n: "Xã Chiêu Lưu", p: "40" },
  { c: "17254", n: "Xã Con Cuông", p: "40" },
  { c: "17464", n: "Xã Diễn Châu", p: "40" },
  { c: "17713", n: "Xã Đại Đồng", p: "40" },
  { c: "17944", n: "Xã Đại Huệ", p: "40" },
  { c: "17662", n: "Xã Đô Lương", p: "40" },
  { c: "17017", n: "Xã Đông Hiếu", p: "40" },
  { c: "17878", n: "Xã Đông Lộc", p: "40" },
  { c: "17530", n: "Xã Đông Thành", p: "40" },
  { c: "17416", n: "Xã Đức Châu", p: "40" },
  { c: "17524", n: "Xã Giai Lạc", p: "40" },
  { c: "17278", n: "Xã Giai Xuân", p: "40" },
  { c: "17419", n: "Xã Hải Châu", p: "40" },
  { c: "17833", n: "Xã Hải Lộc", p: "40" },
  { c: "17722", n: "Xã Hạnh Lâm", p: "40" },
  { c: "17770", n: "Xã Hoa Quân", p: "40" },
  { c: "17605", n: "Xã Hợp Minh", p: "40" },
  { c: "16801", n: "Xã Hùng Chân", p: "40" },
  { c: "17395", n: "Xã Hùng Châu", p: "40" },
  { c: "16828", n: "Xã Huồi Tụ", p: "40" },
  { c: "18001", n: "Xã Hưng Nguyên", p: "40" },
  { c: "18028", n: "Xã Hưng Nguyên Nam", p: "40" },
  { c: "16885", n: "Xã Hữu Khuông", p: "40" },
  { c: "16849", n: "Xã Hữu Kiệm", p: "40" },
  { c: "16822", n: "Xã Keng Đu", p: "40" },
  { c: "17791", n: "Xã Kim Bảng", p: "40" },
  { c: "17971", n: "Xã Kim Liên", p: "40" },
  { c: "18040", n: "Xã Lam Thành", p: "40" },
  { c: "16906", n: "Xã Lượng Minh", p: "40" },
  { c: "17641", n: "Xã Lương Sơn", p: "40" },
  { c: "17239", n: "Xã Mậu Thạch", p: "40" },
  { c: "17476", n: "Xã Minh Châu", p: "40" },
  { c: "17071", n: "Xã Minh Hợp", p: "40" },
  { c: "17263", n: "Xã Môn Sơn", p: "40" },
  { c: "17089", n: "Xã Mường Chọng", p: "40" },
  { c: "17077", n: "Xã Mường Ham", p: "40" },
  { c: "16831", n: "Xã Mường Lống", p: "40" },
  { c: "16774", n: "Xã Mường Quàng", p: "40" },
  { c: "16858", n: "Xã Mường Típ", p: "40" },
  { c: "16813", n: "Xã Mường Xén", p: "40" },
  { c: "16816", n: "Xã Mỹ Lý", p: "40" },
  { c: "16834", n: "Xã Na Loi", p: "40" },
  { c: "16870", n: "Xã Na Ngoi", p: "40" },
  { c: "17935", n: "Xã Nam Đàn", p: "40" },
  { c: "16837", n: "Xã Nậm Cắn", p: "40" },
  { c: "16903", n: "Xã Nga My", p: "40" },
  { c: "17827", n: "Xã Nghi Lộc", p: "40" },
  { c: "16941", n: "Xã Nghĩa Đàn", p: "40" },
  { c: "17284", n: "Xã Nghĩa Đồng", p: "40" },
  { c: "17326", n: "Xã Nghĩa Hành", p: "40" },
  { c: "16972", n: "Xã Nghĩa Hưng", p: "40" },
  { c: "17032", n: "Xã Nghĩa Khánh", p: "40" },
  { c: "16951", n: "Xã Nghĩa Lâm", p: "40" },
  { c: "17029", n: "Xã Nghĩa Lộc", p: "40" },
  { c: "16975", n: "Xã Nghĩa Mai", p: "40" },
  { c: "16969", n: "Xã Nghĩa Thọ", p: "40" },
  { c: "17344", n: "Xã Nhân Hoà", p: "40" },
  { c: "16882", n: "Xã Nhôn Mai", p: "40" },
  { c: "17857", n: "Xã Phúc Lộc", p: "40" },
  { c: "17569", n: "Xã Quan Thành", p: "40" },
  { c: "17443", n: "Xã Quảng Châu", p: "40" },
  { c: "17521", n: "Xã Quang Đồng", p: "40" },
  { c: "16738", n: "Xã Quế Phong", p: "40" },
  { c: "16777", n: "Xã Quỳ Châu", p: "40" },
  { c: "17035", n: "Xã Quỳ Hợp", p: "40" },
  { c: "17176", n: "Xã Quỳnh Anh", p: "40" },
  { c: "17179", n: "Xã Quỳnh Lưu", p: "40" },
  { c: "17212", n: "Xã Quỳnh Phú", p: "40" },
  { c: "17170", n: "Xã Quỳnh Sơn", p: "40" },
  { c: "17149", n: "Xã Quỳnh Tam", p: "40" },
  { c: "17224", n: "Xã Quỳnh Thắng", p: "40" },
  { c: "17143", n: "Xã Quỳnh Văn", p: "40" },
  { c: "17759", n: "Xã Sơn Lâm", p: "40" },
  { c: "17743", n: "Xã Tam Đồng", p: "40" },
  { c: "17059", n: "Xã Tam Hợp", p: "40" },
  { c: "16933", n: "Xã Tam Quang", p: "40" },
  { c: "16936", n: "Xã Tam Thái", p: "40" },
  { c: "17305", n: "Xã Tân An", p: "40" },
  { c: "17488", n: "Xã Tân Châu", p: "40" },
  { c: "17266", n: "Xã Tân Kỳ", p: "40" },
  { c: "17272", n: "Xã Tân Phú", p: "40" },
  { c: "17335", n: "Xã Thành Bình Thọ", p: "40" },
  { c: "17842", n: "Xã Thần Lĩnh", p: "40" },
  { c: "17989", n: "Xã Thiên Nhẫn", p: "40" },
  { c: "16744", n: "Xã Thông Thụ", p: "40" },
  { c: "17689", n: "Xã Thuần Trung", p: "40" },
  { c: "17287", n: "Xã Tiên Đồng", p: "40" },
  { c: "16750", n: "Xã Tiền Phong", p: "40" },
  { c: "16756", n: "Xã Tri Lễ", p: "40" },
  { c: "17866", n: "Xã Trung Lộc", p: "40" },
  { c: "16876", n: "Xã Tương Dương", p: "40" },
  { c: "17950", n: "Xã Vạn An", p: "40" },
  { c: "17677", n: "Xã Văn Hiến", p: "40" },
  { c: "17854", n: "Xã Văn Kiều", p: "40" },
  { c: "17560", n: "Xã Vân Du", p: "40" },
  { c: "17611", n: "Xã Vân Tụ", p: "40" },
  { c: "17357", n: "Xã Vĩnh Tường", p: "40" },
  { c: "17779", n: "Xã Xuân Lâm", p: "40" },
  { c: "16909", n: "Xã Yên Hoà", p: "40" },
  { c: "16912", n: "Xã Yên Na", p: "40" },
  { c: "17506", n: "Xã Yên Thành", p: "40" },
  { c: "18007", n: "Xã Yên Trung", p: "40" },
  { c: "17380", n: "Xã Yên Xuân", p: "40" },
  { c: "18115", n: "Phường Bắc Hồng Lĩnh", p: "42" },
  { c: "18652", n: "Phường Hà Huy Tập", p: "42" },
  { c: "18781", n: "Phường Hải Ninh", p: "42" },
  { c: "18832", n: "Phường Hoành Sơn", p: "42" },
  { c: "18118", n: "Phường Nam Hồng Lĩnh", p: "42" },
  { c: "18754", n: "Phường Sông Trí", p: "42" },
  { c: "18073", n: "Phường Thành Sen", p: "42" },
  { c: "18100", n: "Phường Trần Phú", p: "42" },
  { c: "18823", n: "Phường Vũng Áng", p: "42" },
  { c: "18406", n: "Xã Can Lộc", p: "42" },
  { c: "18685", n: "Xã Cẩm Bình", p: "42" },
  { c: "18739", n: "Xã Cẩm Duệ", p: "42" },
  { c: "18736", n: "Xã Cẩm Hưng", p: "42" },
  { c: "18748", n: "Xã Cẩm Lạc", p: "42" },
  { c: "18742", n: "Xã Cẩm Trung", p: "42" },
  { c: "18673", n: "Xã Cẩm Xuyên", p: "42" },
  { c: "18394", n: "Xã Cổ Đạm", p: "42" },
  { c: "18364", n: "Xã Đan Hải", p: "42" },
  { c: "18586", n: "Xã Đông Kinh", p: "42" },
  { c: "18484", n: "Xã Đồng Lộc", p: "42" },
  { c: "18619", n: "Xã Đồng Tiến", p: "42" },
  { c: "18304", n: "Xã Đức Đồng", p: "42" },
  { c: "18244", n: "Xã Đức Minh", p: "42" },
  { c: "18262", n: "Xã Đức Quang", p: "42" },
  { c: "18277", n: "Xã Đức Thịnh", p: "42" },
  { c: "18229", n: "Xã Đức Thọ", p: "42" },
  { c: "18466", n: "Xã Gia Hanh", p: "42" },
  { c: "18502", n: "Xã Hà Linh", p: "42" },
  { c: "18409", n: "Xã Hồng Lộc", p: "42" },
  { c: "18523", n: "Xã Hương Bình", p: "42" },
  { c: "18550", n: "Xã Hương Đô", p: "42" },
  { c: "18496", n: "Xã Hương Khê", p: "42" },
  { c: "18532", n: "Xã Hương Phố", p: "42" },
  { c: "18133", n: "Xã Hương Sơn", p: "42" },
  { c: "18544", n: "Xã Hương Xuân", p: "42" },
  { c: "18223", n: "Xã Kim Hoa", p: "42" },
  { c: "18775", n: "Xã Kỳ Anh", p: "42" },
  { c: "18814", n: "Xã Kỳ Hoa", p: "42" },
  { c: "18790", n: "Xã Kỳ Khang", p: "42" },
  { c: "18838", n: "Xã Kỳ Lạc", p: "42" },
  { c: "18844", n: "Xã Kỳ Thượng", p: "42" },
  { c: "18787", n: "Xã Kỳ Văn", p: "42" },
  { c: "18766", n: "Xã Kỳ Xuân", p: "42" },
  { c: "18568", n: "Xã Lộc Hà", p: "42" },
  { c: "18322", n: "Xã Mai Hoa", p: "42" },
  { c: "18583", n: "Xã Mai Phụ", p: "42" },
  { c: "18352", n: "Xã Nghi Xuân", p: "42" },
  { c: "18547", n: "Xã Phúc Trạch", p: "42" },
  { c: "18184", n: "Xã Sơn Giang", p: "42" },
  { c: "18160", n: "Xã Sơn Hồng", p: "42" },
  { c: "18196", n: "Xã Sơn Kim 1", p: "42" },
  { c: "18199", n: "Xã Sơn Kim 2", p: "42" },
  { c: "18172", n: "Xã Sơn Tây", p: "42" },
  { c: "18163", n: "Xã Sơn Tiến", p: "42" },
  { c: "18562", n: "Xã Thạch Hà", p: "42" },
  { c: "18604", n: "Xã Thạch Khê", p: "42" },
  { c: "18628", n: "Xã Thạch Lạc", p: "42" },
  { c: "18667", n: "Xã Thạch Xuân", p: "42" },
  { c: "18676", n: "Xã Thiên Cầm", p: "42" },
  { c: "18328", n: "Xã Thượng Đức", p: "42" },
  { c: "18373", n: "Xã Tiên Điền", p: "42" },
  { c: "18634", n: "Xã Toàn Lưu", p: "42" },
  { c: "18436", n: "Xã Trường Lưu", p: "42" },
  { c: "18418", n: "Xã Tùng Lộc", p: "42" },
  { c: "18202", n: "Xã Tứ Mỹ", p: "42" },
  { c: "18601", n: "Xã Việt Xuyên", p: "42" },
  { c: "18313", n: "Xã Vũ Quang", p: "42" },
  { c: "18481", n: "Xã Xuân Lộc", p: "42" },
  { c: "18682", n: "Xã Yên Hoà", p: "42" },
  { c: "19742", n: "Đặc khu Cồn Cỏ", p: "44" },
  { c: "19009", n: "Phường Ba Đồn", p: "44" },
  { c: "19066", n: "Phường Bắc Gianh", p: "44" },
  { c: "19333", n: "Phường Đông Hà", p: "44" },
  { c: "18880", n: "Phường Đồng Hới", p: "44" },
  { c: "18871", n: "Phường Đồng Sơn", p: "44" },
  { c: "18859", n: "Phường Đồng Thuận", p: "44" },
  { c: "19351", n: "Phường Nam Đông Hà", p: "44" },
  { c: "19360", n: "Phường Quảng Trị", p: "44" },
  { c: "19483", n: "Xã A Dơi", p: "44" },
  { c: "19669", n: "Xã Ái Tử", p: "44" },
  { c: "19567", n: "Xã Ba Lòng", p: "44" },
  { c: "19126", n: "Xã Bắc Trạch", p: "44" },
  { c: "19501", n: "Xã Bến Hải", p: "44" },
  { c: "19366", n: "Xã Bến Quan", p: "44" },
  { c: "19141", n: "Xã Bố Trạch", p: "44" },
  { c: "19255", n: "Xã Cam Hồng", p: "44" },
  { c: "19597", n: "Xã Cam Lộ", p: "44" },
  { c: "19537", n: "Xã Cồn Tiên", p: "44" },
  { c: "19414", n: "Xã Cửa Tùng", p: "44" },
  { c: "19496", n: "Xã Cửa Việt", p: "44" },
  { c: "18904", n: "Xã Dân Hoá", p: "44" },
  { c: "19681", n: "Xã Diên Sanh", p: "44" },
  { c: "19564", n: "Xã Đakrông", p: "44" },
  { c: "18949", n: "Xã Đồng Lê", p: "44" },
  { c: "19159", n: "Xã Đông Trạch", p: "44" },
  { c: "19495", n: "Xã Gio Linh", p: "44" },
  { c: "19702", n: "Xã Hải Lăng", p: "44" },
  { c: "19603", n: "Xã Hiếu Giang", p: "44" },
  { c: "19033", n: "Xã Hoà Trạch", p: "44" },
  { c: "19111", n: "Xã Hoàn Lão", p: "44" },
  { c: "19555", n: "Xã Hướng Hiệp", p: "44" },
  { c: "19435", n: "Xã Hướng Lập", p: "44" },
  { c: "19441", n: "Xã Hướng Phùng", p: "44" },
  { c: "19429", n: "Xã Khe Sanh", p: "44" },
  { c: "18922", n: "Xã Kim Điền", p: "44" },
  { c: "19318", n: "Xã Kim Ngân", p: "44" },
  { c: "18943", n: "Xã Kim Phú", p: "44" },
  { c: "19594", n: "Xã La Lay", p: "44" },
  { c: "19432", n: "Xã Lao Bảo", p: "44" },
  { c: "19246", n: "Xã Lệ Ninh", p: "44" },
  { c: "19249", n: "Xã Lệ Thuỷ", p: "44" },
  { c: "19489", n: "Xã Lìa", p: "44" },
  { c: "18901", n: "Xã Minh Hoá", p: "44" },
  { c: "19741", n: "Xã Mỹ Thuỷ", p: "44" },
  { c: "19075", n: "Xã Nam Ba Đồn", p: "44" },
  { c: "19639", n: "Xã Nam Cửa Việt", p: "44" },
  { c: "19093", n: "Xã Nam Gianh", p: "44" },
  { c: "19735", n: "Xã Nam Hải Lăng", p: "44" },
  { c: "19198", n: "Xã Nam Trạch", p: "44" },
  { c: "19225", n: "Xã Ninh Châu", p: "44" },
  { c: "19138", n: "Xã Phong Nha", p: "44" },
  { c: "19021", n: "Xã Phú Trạch", p: "44" },
  { c: "19207", n: "Xã Quảng Ninh", p: "44" },
  { c: "19057", n: "Xã Quảng Trạch", p: "44" },
  { c: "19288", n: "Xã Sen Ngư", p: "44" },
  { c: "19588", n: "Xã Tà Rụt", p: "44" },
  { c: "19051", n: "Xã Tân Gianh", p: "44" },
  { c: "19462", n: "Xã Tân Lập", p: "44" },
  { c: "19291", n: "Xã Tân Mỹ", p: "44" },
  { c: "18919", n: "Xã Tân Thành", p: "44" },
  { c: "19147", n: "Xã Thượng Trạch", p: "44" },
  { c: "19645", n: "Xã Triệu Bình", p: "44" },
  { c: "19654", n: "Xã Triệu Cơ", p: "44" },
  { c: "19624", n: "Xã Triệu Phong", p: "44" },
  { c: "19030", n: "Xã Trung Thuần", p: "44" },
  { c: "19237", n: "Xã Trường Ninh", p: "44" },
  { c: "19309", n: "Xã Trường Phú", p: "44" },
  { c: "19204", n: "Xã Trường Sơn", p: "44" },
  { c: "18991", n: "Xã Tuyên Bình", p: "44" },
  { c: "18997", n: "Xã Tuyên Hoá", p: "44" },
  { c: "18958", n: "Xã Tuyên Lâm", p: "44" },
  { c: "18985", n: "Xã Tuyên Phú", p: "44" },
  { c: "18952", n: "Xã Tuyên Sơn", p: "44" },
  { c: "19699", n: "Xã Vĩnh Định", p: "44" },
  { c: "19372", n: "Xã Vĩnh Hoàng", p: "44" },
  { c: "19363", n: "Xã Vĩnh Linh", p: "44" },
  { c: "19405", n: "Xã Vĩnh Thuỷ", p: "44" },
  { c: "19815", n: "Phường An Cựu", p: "46" },
  { c: "19909", n: "Phường Dương Nỗ", p: "46" },
  { c: "20014", n: "Phường Hoá Châu", p: "46" },
  { c: "19804", n: "Phường Hương An", p: "46" },
  { c: "19975", n: "Phường Hương Thuỷ", p: "46" },
  { c: "19996", n: "Phường Hương Trà", p: "46" },
  { c: "19774", n: "Phường Kim Long", p: "46" },
  { c: "20017", n: "Phường Kim Trà", p: "46" },
  { c: "19930", n: "Phường Mỹ Thượng", p: "46" },
  { c: "19831", n: "Phường Phong Dinh", p: "46" },
  { c: "19819", n: "Phường Phong Điền", p: "46" },
  { c: "19828", n: "Phường Phong Phú", p: "46" },
  { c: "19873", n: "Phường Phong Quảng", p: "46" },
  { c: "19858", n: "Phường Phong Thái", p: "46" },
  { c: "19960", n: "Phường Phú Bài", p: "46" },
  { c: "19753", n: "Phường Phú Xuân", p: "46" },
  { c: "19969", n: "Phường Thanh Thuỷ", p: "46" },
  { c: "19900", n: "Phường Thuận An", p: "46" },
  { c: "19789", n: "Phường Thuận Hoá", p: "46" },
  { c: "19813", n: "Phường Thuỷ Xuân", p: "46" },
  { c: "19777", n: "Phường Vỹ Dạ", p: "46" },
  { c: "20056", n: "Xã A Lưới 1", p: "46" },
  { c: "20044", n: "Xã A Lưới 2", p: "46" },
  { c: "20071", n: "Xã A Lưới 3", p: "46" },
  { c: "20101", n: "Xã A Lưới 4", p: "46" },
  { c: "20050", n: "Xã A Lưới 5", p: "46" },
  { c: "20035", n: "Xã Bình Điền", p: "46" },
  { c: "20137", n: "Xã Chân Mây - Lăng Cô", p: "46" },
  { c: "19885", n: "Xã Đan Điền", p: "46" },
  { c: "20131", n: "Xã Hưng Lộc", p: "46" },
  { c: "20161", n: "Xã Khe Tre", p: "46" },
  { c: "20182", n: "Xã Long Quảng", p: "46" },
  { c: "20140", n: "Xã Lộc An", p: "46" },
  { c: "20179", n: "Xã Nam Đông", p: "46" },
  { c: "19918", n: "Xã Phú Hồ", p: "46" },
  { c: "20107", n: "Xã Phú Lộc", p: "46" },
  { c: "19942", n: "Xã Phú Vang", p: "46" },
  { c: "19945", n: "Xã Phú Vinh", p: "46" },
  { c: "19867", n: "Xã Quảng Điền", p: "46" },
  { c: "20122", n: "Xã Vinh Lộc", p: "46" },
  { c: "20333", n: "Đặc khu Hoàng Sa", p: "48" },
  { c: "20275", n: "Phường An Hải", p: "48" },
  { c: "20305", n: "Phường An Khê", p: "48" },
  { c: "20575", n: "Phường An Thắng", p: "48" },
  { c: "20335", n: "Phường Bàn Thạch", p: "48" },
  { c: "20260", n: "Phường Cẩm Lệ", p: "48" },
  { c: "20551", n: "Phường Điện Bàn", p: "48" },
  { c: "20557", n: "Phường Điện Bàn Bắc", p: "48" },
  { c: "20579", n: "Phường Điện Bàn Đông", p: "48" },
  { c: "20242", n: "Phường Hải Châu", p: "48" },
  { c: "20194", n: "Phường Hải Vân", p: "48" },
  { c: "20257", n: "Phường Hoà Cường", p: "48" },
  { c: "20200", n: "Phường Hoà Khánh", p: "48" },
  { c: "20314", n: "Phường Hoà Xuân", p: "48" },
  { c: "20410", n: "Phường Hội An", p: "48" },
  { c: "20413", n: "Phường Hội An Đông", p: "48" },
  { c: "20401", n: "Phường Hội An Tây", p: "48" },
  { c: "20350", n: "Phường Hương Trà", p: "48" },
  { c: "20197", n: "Phường Liên Chiểu", p: "48" },
  { c: "20285", n: "Phường Ngũ Hành Sơn", p: "48" },
  { c: "20356", n: "Phường Quảng Phú", p: "48" },
  { c: "20263", n: "Phường Sơn Trà", p: "48" },
  { c: "20341", n: "Phường Tam Kỳ", p: "48" },
  { c: "20209", n: "Phường Thanh Khê", p: "48" },
  { c: "20458", n: "Xã Avương", p: "48" },
  { c: "20308", n: "Xã Bà Nà", p: "48" },
  { c: "20710", n: "Xã Bến Giằng", p: "48" },
  { c: "20494", n: "Xã Bến Hiên", p: "48" },
  { c: "20364", n: "Xã Chiên Đàn", p: "48" },
  { c: "20635", n: "Xã Duy Nghĩa", p: "48" },
  { c: "20623", n: "Xã Duy Xuyên", p: "48" },
  { c: "20500", n: "Xã Đại Lộc", p: "48" },
  { c: "20716", n: "Xã Đắc Pring", p: "48" },
  { c: "20569", n: "Xã Điện Bàn Tây", p: "48" },
  { c: "20818", n: "Xã Đồng Dương", p: "48" },
  { c: "20467", n: "Xã Đông Giang", p: "48" },
  { c: "20977", n: "Xã Đức Phú", p: "48" },
  { c: "20587", n: "Xã Gò Nổi", p: "48" },
  { c: "20515", n: "Xã Hà Nha", p: "48" },
  { c: "20779", n: "Xã Hiệp Đức", p: "48" },
  { c: "20332", n: "Xã Hoà Tiến", p: "48" },
  { c: "20320", n: "Xã Hoà Vang", p: "48" },
  { c: "20443", n: "Xã Hùng Sơn", p: "48" },
  { c: "20722", n: "Xã Khâm Đức", p: "48" },
  { c: "20704", n: "Xã La Dêê", p: "48" },
  { c: "20698", n: "Xã La Êê", p: "48" },
  { c: "20875", n: "Xã Lãnh Ngọc", p: "48" },
  { c: "20707", n: "Xã Nam Giang", p: "48" },
  { c: "20599", n: "Xã Nam Phước", p: "48" },
  { c: "20944", n: "Xã Nam Trà My", p: "48" },
  { c: "20656", n: "Xã Nông Sơn", p: "48" },
  { c: "20965", n: "Xã Núi Thành", p: "48" },
  { c: "20392", n: "Xã Phú Ninh", p: "48" },
  { c: "20542", n: "Xã Phú Thuận", p: "48" },
  { c: "20740", n: "Xã Phước Chánh", p: "48" },
  { c: "20728", n: "Xã Phước Hiệp", p: "48" },
  { c: "20734", n: "Xã Phước Năng", p: "48" },
  { c: "20752", n: "Xã Phước Thành", p: "48" },
  { c: "20770", n: "Xã Phước Trà", p: "48" },
  { c: "20669", n: "Xã Quế Phước", p: "48" },
  { c: "20641", n: "Xã Quế Sơn", p: "48" },
  { c: "20662", n: "Xã Quế Sơn Trung", p: "48" },
  { c: "20476", n: "Xã Sông Kôn", p: "48" },
  { c: "20485", n: "Xã Sông Vàng", p: "48" },
  { c: "20857", n: "Xã Sơn Cẩm Hà", p: "48" },
  { c: "20984", n: "Xã Tam Anh", p: "48" },
  { c: "20992", n: "Xã Tam Hải", p: "48" },
  { c: "21004", n: "Xã Tam Mỹ", p: "48" },
  { c: "20971", n: "Xã Tam Xuân", p: "48" },
  { c: "20434", n: "Xã Tân Hiệp", p: "48" },
  { c: "20455", n: "Xã Tây Giang", p: "48" },
  { c: "20380", n: "Xã Tây Hồ", p: "48" },
  { c: "20878", n: "Xã Thạnh Bình", p: "48" },
  { c: "20695", n: "Xã Thạnh Mỹ", p: "48" },
  { c: "20794", n: "Xã Thăng An", p: "48" },
  { c: "20791", n: "Xã Thăng Bình", p: "48" },
  { c: "20848", n: "Xã Thăng Điền", p: "48" },
  { c: "20827", n: "Xã Thăng Phú", p: "48" },
  { c: "20836", n: "Xã Thăng Trường", p: "48" },
  { c: "20611", n: "Xã Thu Bồn", p: "48" },
  { c: "20506", n: "Xã Thượng Đức", p: "48" },
  { c: "20854", n: "Xã Tiên Phước", p: "48" },
  { c: "20920", n: "Xã Trà Đốc", p: "48" },
  { c: "20929", n: "Xã Trà Giáp", p: "48" },
  { c: "20938", n: "Xã Trà Leng", p: "48" },
  { c: "20908", n: "Xã Trà Liên", p: "48" },
  { c: "20950", n: "Xã Trà Linh", p: "48" },
  { c: "20900", n: "Xã Trà My", p: "48" },
  { c: "20923", n: "Xã Trà Tân", p: "48" },
  { c: "20941", n: "Xã Trà Tập", p: "48" },
  { c: "20959", n: "Xã Trà Vân", p: "48" },
  { c: "20767", n: "Xã Việt An", p: "48" },
  { c: "20539", n: "Xã Vu Gia", p: "48" },
  { c: "20650", n: "Xã Xuân Phú", p: "48" },
  { c: "21548", n: "Đặc khu Lý Sơn", p: "51" },
  { c: "21025", n: "Phường Cẩm Thành", p: "51" },
  { c: "23302", n: "Phường Đăk Bla", p: "51" },
  { c: "23284", n: "Phường Đăk Cấm", p: "51" },
  { c: "21439", n: "Phường Đức Phổ", p: "51" },
  { c: "23293", n: "Phường Kon Tum", p: "51" },
  { c: "21028", n: "Phường Nghĩa Lộ", p: "51" },
  { c: "21478", n: "Phường Sa Huỳnh", p: "51" },
  { c: "21451", n: "Phường Trà Câu", p: "51" },
  { c: "21172", n: "Phường Trương Quang Trọng", p: "51" },
  { c: "21034", n: "Xã An Phú", p: "51" },
  { c: "21499", n: "Xã Ba Dinh", p: "51" },
  { c: "21496", n: "Xã Ba Động", p: "51" },
  { c: "21205", n: "Xã Ba Gia", p: "51" },
  { c: "21523", n: "Xã Ba Tô", p: "51" },
  { c: "21484", n: "Xã Ba Tơ", p: "51" },
  { c: "21529", n: "Xã Ba Vì", p: "51" },
  { c: "21490", n: "Xã Ba Vinh", p: "51" },
  { c: "21538", n: "Xã Ba Xa", p: "51" },
  { c: "21100", n: "Xã Bình Chương", p: "51" },
  { c: "21085", n: "Xã Bình Minh", p: "51" },
  { c: "21040", n: "Xã Bình Sơn", p: "51" },
  { c: "23377", n: "Xã Bờ Y", p: "51" },
  { c: "21136", n: "Xã Cà Đam", p: "51" },
  { c: "23383", n: "Xã Dục Nông", p: "51" },
  { c: "23500", n: "Xã Đăk Hà", p: "51" },
  { c: "23485", n: "Xã Đăk Kôi", p: "51" },
  { c: "23368", n: "Xã Đăk Long", p: "51" },
  { c: "23512", n: "Xã Đăk Mar", p: "51" },
  { c: "23374", n: "Xã Đăk Môn", p: "51" },
  { c: "23341", n: "Xã Đăk Pék", p: "51" },
  { c: "23344", n: "Xã Đăk Plô", p: "51" },
  { c: "23504", n: "Xã Đăk Pxi", p: "51" },
  { c: "23332", n: "Xã Đăk Rơ Wa", p: "51" },
  { c: "23479", n: "Xã Đăk Rve", p: "51" },
  { c: "23416", n: "Xã Đăk Sao", p: "51" },
  { c: "23401", n: "Xã Đăk Tô", p: "51" },
  { c: "23419", n: "Xã Đăk Tờ Kan", p: "51" },
  { c: "23510", n: "Xã Đăk Ui", p: "51" },
  { c: "21520", n: "Xã Đặng Thuỳ Trâm", p: "51" },
  { c: "21385", n: "Xã Đình Cương", p: "51" },
  { c: "21109", n: "Xã Đông Sơn", p: "51" },
  { c: "21127", n: "Xã Đông Trà Bồng", p: "51" },
  { c: "23326", n: "Xã Ia Chim", p: "51" },
  { c: "23535", n: "Xã Ia Đal", p: "51" },
  { c: "23538", n: "Xã Ia Tơi", p: "51" },
  { c: "21472", n: "Xã Khánh Cường", p: "51" },
  { c: "23497", n: "Xã Kon Braih", p: "51" },
  { c: "23430", n: "Xã Kon Đào", p: "51" },
  { c: "23476", n: "Xã Kon Plông", p: "51" },
  { c: "21433", n: "Xã Lân Phong", p: "51" },
  { c: "21409", n: "Xã Long Phụng", p: "51" },
  { c: "23455", n: "Xã Măng Bút", p: "51" },
  { c: "23473", n: "Xã Măng Đen", p: "51" },
  { c: "23446", n: "Xã Măng Ri", p: "51" },
  { c: "21361", n: "Xã Minh Long", p: "51" },
  { c: "21421", n: "Xã Mỏ Cày", p: "51" },
  { c: "21400", n: "Xã Mộ Đức", p: "51" },
  { c: "23536", n: "Xã Mô Rai", p: "51" },
  { c: "21250", n: "Xã Nghĩa Giang", p: "51" },
  { c: "21364", n: "Xã Nghĩa Hành", p: "51" },
  { c: "23365", n: "Xã Ngọc Linh", p: "51" },
  { c: "23317", n: "Xã Ngọk Bay", p: "51" },
  { c: "23515", n: "Xã Ngọk Réo", p: "51" },
  { c: "23428", n: "Xã Ngọk Tụ", p: "51" },
  { c: "21457", n: "Xã Nguyễn Nghiêm", p: "51" },
  { c: "21370", n: "Xã Phước Giang", p: "51" },
  { c: "23530", n: "Xã Rờ Kơi", p: "51" },
  { c: "23534", n: "Xã Sa Bình", p: "51" },
  { c: "23392", n: "Xã Sa Loong", p: "51" },
  { c: "23527", n: "Xã Sa Thầy", p: "51" },
  { c: "21289", n: "Xã Sơn Hà", p: "51" },
  { c: "21292", n: "Xã Sơn Hạ", p: "51" },
  { c: "21325", n: "Xã Sơn Kỳ", p: "51" },
  { c: "21307", n: "Xã Sơn Linh", p: "51" },
  { c: "21349", n: "Xã Sơn Mai", p: "51" },
  { c: "21340", n: "Xã Sơn Tây", p: "51" },
  { c: "21343", n: "Xã Sơn Tây Hạ", p: "51" },
  { c: "21334", n: "Xã Sơn Tây Thượng", p: "51" },
  { c: "21319", n: "Xã Sơn Thuỷ", p: "51" },
  { c: "21220", n: "Xã Sơn Tịnh", p: "51" },
  { c: "21154", n: "Xã Tây Trà", p: "51" },
  { c: "21157", n: "Xã Tây Trà Bồng", p: "51" },
  { c: "21124", n: "Xã Thanh Bồng", p: "51" },
  { c: "21388", n: "Xã Thiện Tín", p: "51" },
  { c: "21181", n: "Xã Thọ Phong", p: "51" },
  { c: "21211", n: "Xã Tịnh Khê", p: "51" },
  { c: "21115", n: "Xã Trà Bồng", p: "51" },
  { c: "21244", n: "Xã Trà Giang", p: "51" },
  { c: "21196", n: "Xã Trường Giang", p: "51" },
  { c: "23425", n: "Xã Tu Mơ Rông", p: "51" },
  { c: "21235", n: "Xã Tư Nghĩa", p: "51" },
  { c: "21061", n: "Xã Vạn Tường", p: "51" },
  { c: "21238", n: "Xã Vệ Giang", p: "51" },
  { c: "23356", n: "Xã Xốp", p: "51" },
  { c: "23548", n: "Xã Ya Ly", p: "51" },
  { c: "23614", n: "Phường An Bình", p: "52" },
  { c: "23617", n: "Phường An Khê", p: "52" },
  { c: "21910", n: "Phường An Nhơn", p: "52" },
  { c: "21925", n: "Phường An Nhơn Bắc", p: "52" },
  { c: "21934", n: "Phường An Nhơn Đông", p: "52" },
  { c: "21943", n: "Phường An Nhơn Nam", p: "52" },
  { c: "23602", n: "Phường An Phú", p: "52" },
  { c: "24044", n: "Phường Ayun Pa", p: "52" },
  { c: "21907", n: "Phường Bình Định", p: "52" },
  { c: "21640", n: "Phường Bồng Sơn", p: "52" },
  { c: "23563", n: "Phường Diên Hồng", p: "52" },
  { c: "21664", n: "Phường Hoài Nhơn", p: "52" },
  { c: "21655", n: "Phường Hoài Nhơn Bắc", p: "52" },
  { c: "21670", n: "Phường Hoài Nhơn Đông", p: "52" },
  { c: "21673", n: "Phường Hoài Nhơn Nam", p: "52" },
  { c: "21661", n: "Phường Hoài Nhơn Tây", p: "52" },
  { c: "23586", n: "Phường Hội Phú", p: "52" },
  { c: "23575", n: "Phường Pleiku", p: "52" },
  { c: "21583", n: "Phường Quy Nhơn", p: "52" },
  { c: "21553", n: "Phường Quy Nhơn Bắc", p: "52" },
  { c: "21601", n: "Phường Quy Nhơn Đông", p: "52" },
  { c: "21592", n: "Phường Quy Nhơn Nam", p: "52" },
  { c: "21589", n: "Phường Quy Nhơn Tây", p: "52" },
  { c: "21637", n: "Phường Tam Quan", p: "52" },
  { c: "23584", n: "Phường Thống Nhất", p: "52" },
  { c: "23954", n: "Xã Al Bá", p: "52" },
  { c: "21628", n: "Xã An Hoà", p: "52" },
  { c: "21609", n: "Xã An Lão", p: "52" },
  { c: "21769", n: "Xã An Lương", p: "52" },
  { c: "21940", n: "Xã An Nhơn Tây", p: "52" },
  { c: "21622", n: "Xã An Toàn", p: "52" },
  { c: "21616", n: "Xã An Vinh", p: "52" },
  { c: "23798", n: "Xã Ayun", p: "52" },
  { c: "21697", n: "Xã Ân Hảo", p: "52" },
  { c: "21715", n: "Xã Ân Tường", p: "52" },
  { c: "23896", n: "Xã Bàu Cạn", p: "52" },
  { c: "23590", n: "Xã Biển Hồ", p: "52" },
  { c: "21829", n: "Xã Bình An", p: "52" },
  { c: "21733", n: "Xã Bình Dương", p: "52" },
  { c: "21817", n: "Xã Bình Hiệp", p: "52" },
  { c: "21820", n: "Xã Bình Khê", p: "52" },
  { c: "21835", n: "Xã Bình Phú", p: "52" },
  { c: "23947", n: "Xã Bờ Ngoong", p: "52" },
  { c: "21997", n: "Xã Canh Liên", p: "52" },
  { c: "22006", n: "Xã Canh Vinh", p: "52" },
  { c: "21880", n: "Xã Cát Tiến", p: "52" },
  { c: "23851", n: "Xã Chơ Long", p: "52" },
  { c: "24049", n: "Xã Chư A Thai", p: "52" },
  { c: "23830", n: "Xã Chư Krey", p: "52" },
  { c: "23722", n: "Xã Chư Păh", p: "52" },
  { c: "23887", n: "Xã Chư Prông", p: "52" },
  { c: "23942", n: "Xã Chư Pưh", p: "52" },
  { c: "23941", n: "Xã Chư Sê", p: "52" },
  { c: "23629", n: "Xã Cửu An", p: "52" },
  { c: "23677", n: "Xã Đak Đoa", p: "52" },
  { c: "23995", n: "Xã Đak Pơ", p: "52" },
  { c: "23644", n: "Xã Đak Rong", p: "52" },
  { c: "23683", n: "Xã Đak Sơmei", p: "52" },
  { c: "23842", n: "Xã Đăk Song", p: "52" },
  { c: "21859", n: "Xã Đề Gi", p: "52" },
  { c: "23857", n: "Xã Đức Cơ", p: "52" },
  { c: "23611", n: "Xã Gào", p: "52" },
  { c: "21871", n: "Xã Hoà Hội", p: "52" },
  { c: "21688", n: "Xã Hoài Ân", p: "52" },
  { c: "21868", n: "Xã Hội Sơn", p: "52" },
  { c: "23799", n: "Xã Hra", p: "52" },
  { c: "23710", n: "Xã Ia Băng", p: "52" },
  { c: "23911", n: "Xã Ia Boòng", p: "52" },
  { c: "23788", n: "Xã Ia Chia", p: "52" },
  { c: "23872", n: "Xã Ia Dom", p: "52" },
  { c: "23869", n: "Xã Ia Dơk", p: "52" },
  { c: "24100", n: "Xã Ia Dreh", p: "52" },
  { c: "23764", n: "Xã Ia Grai", p: "52" },
  { c: "24061", n: "Xã Ia Hiao", p: "52" },
  { c: "23971", n: "Xã Ia Hrú", p: "52" },
  { c: "23767", n: "Xã Ia Hrung", p: "52" },
  { c: "23728", n: "Xã Ia Khươl", p: "52" },
  { c: "23977", n: "Xã Ia Ko", p: "52" },
  { c: "23776", n: "Xã Ia Krái", p: "52" },
  { c: "23866", n: "Xã Ia Krêl", p: "52" },
  { c: "23935", n: "Xã Ia Lâu", p: "52" },
  { c: "23986", n: "Xã Ia Le", p: "52" },
  { c: "23734", n: "Xã Ia Ly", p: "52" },
  { c: "23938", n: "Xã Ia Mơ", p: "52" },
  { c: "23884", n: "Xã Ia Nan", p: "52" },
  { c: "23782", n: "Xã Ia O", p: "52" },
  { c: "24022", n: "Xã Ia Pa", p: "52" },
  { c: "23749", n: "Xã Ia Phí", p: "52" },
  { c: "23926", n: "Xã Ia Pia", p: "52" },
  { c: "23881", n: "Xã Ia Pnôn", p: "52" },
  { c: "23917", n: "Xã Ia Púch", p: "52" },
  { c: "24065", n: "Xã Ia Rbol", p: "52" },
  { c: "24112", n: "Xã Ia Rsai", p: "52" },
  { c: "24073", n: "Xã Ia Sao", p: "52" },
  { c: "23908", n: "Xã Ia Tôr", p: "52" },
  { c: "24028", n: "Xã Ia Tul", p: "52" },
  { c: "23638", n: "Xã Kbang", p: "52" },
  { c: "23714", n: "Xã KDang", p: "52" },
  { c: "21727", n: "Xã Kim Sơn", p: "52" },
  { c: "23818", n: "Xã Kon Chiêng", p: "52" },
  { c: "23701", n: "Xã Kon Gang", p: "52" },
  { c: "23674", n: "Xã Kông Bơ La", p: "52" },
  { c: "23824", n: "Xã Kông Chro", p: "52" },
  { c: "23650", n: "Xã Krong", p: "52" },
  { c: "23812", n: "Xã Lơ Pang", p: "52" },
  { c: "23794", n: "Xã Mang Yang", p: "52" },
  { c: "21901", n: "Xã Ngô Mây", p: "52" },
  { c: "21607", n: "Xã Nhơn Châu", p: "52" },
  { c: "21853", n: "Xã Phù Cát", p: "52" },
  { c: "21730", n: "Xã Phù Mỹ", p: "52" },
  { c: "21739", n: "Xã Phù Mỹ Bắc", p: "52" },
  { c: "21751", n: "Xã Phù Mỹ Đông", p: "52" },
  { c: "21775", n: "Xã Phù Mỹ Nam", p: "52" },
  { c: "21757", n: "Xã Phù Mỹ Tây", p: "52" },
  { c: "24043", n: "Xã Phú Thiện", p: "52" },
  { c: "24076", n: "Xã Phú Túc", p: "52" },
  { c: "24013", n: "Xã Pờ Tó", p: "52" },
  { c: "23647", n: "Xã Sơn Lang", p: "52" },
  { c: "23839", n: "Xã SRó", p: "52" },
  { c: "21808", n: "Xã Tây Sơn", p: "52" },
  { c: "23668", n: "Xã Tơ Tung", p: "52" },
  { c: "21952", n: "Xã Tuy Phước", p: "52" },
  { c: "21964", n: "Xã Tuy Phước Bắc", p: "52" },
  { c: "21970", n: "Xã Tuy Phước Đông", p: "52" },
  { c: "21985", n: "Xã Tuy Phước Tây", p: "52" },
  { c: "24109", n: "Xã Uar", p: "52" },
  { c: "21703", n: "Xã Vạn Đức", p: "52" },
  { c: "21994", n: "Xã Vân Canh", p: "52" },
  { c: "21805", n: "Xã Vĩnh Quang", p: "52" },
  { c: "21787", n: "Xã Vĩnh Sơn", p: "52" },
  { c: "21786", n: "Xã Vĩnh Thạnh", p: "52" },
  { c: "21796", n: "Xã Vĩnh Thịnh", p: "52" },
  { c: "21892", n: "Xã Xuân An", p: "52" },
  { c: "24007", n: "Xã Ya Hội", p: "52" },
  { c: "23833", n: "Xã Ya Ma", p: "52" },
  { c: "22736", n: "Đặc khu Trường Sa", p: "56" },
  { c: "22423", n: "Phường Ba Ngòi", p: "56" },
  { c: "22741", n: "Phường Bảo An", p: "56" },
  { c: "22411", n: "Phường Bắc Cam Ranh", p: "56" },
  { c: "22333", n: "Phường Bắc Nha Trang", p: "56" },
  { c: "22432", n: "Phường Cam Linh", p: "56" },
  { c: "22420", n: "Phường Cam Ranh", p: "56" },
  { c: "22738", n: "Phường Đô Vinh", p: "56" },
  { c: "22780", n: "Phường Đông Hải", p: "56" },
  { c: "22561", n: "Phường Đông Ninh Hoà", p: "56" },
  { c: "22591", n: "Phường Hoà Thắng", p: "56" },
  { c: "22402", n: "Phường Nam Nha Trang", p: "56" },
  { c: "22366", n: "Phường Nha Trang", p: "56" },
  { c: "22834", n: "Phường Ninh Chử", p: "56" },
  { c: "22528", n: "Phường Ninh Hoà", p: "56" },
  { c: "22759", n: "Phường Phan Rang", p: "56" },
  { c: "22390", n: "Phường Tây Nha Trang", p: "56" },
  { c: "22828", n: "Xã Anh Dũng", p: "56" },
  { c: "22795", n: "Xã Bác Ái", p: "56" },
  { c: "22801", n: "Xã Bác Ái Đông", p: "56" },
  { c: "22786", n: "Xã Bác Ái Tây", p: "56" },
  { c: "22615", n: "Xã Bắc Khánh Vĩnh", p: "56" },
  { c: "22546", n: "Xã Bắc Ninh Hoà", p: "56" },
  { c: "22909", n: "Xã Cà Ná", p: "56" },
  { c: "22465", n: "Xã Cam An", p: "56" },
  { c: "22435", n: "Xã Cam Hiệp", p: "56" },
  { c: "22453", n: "Xã Cam Lâm", p: "56" },
  { c: "22840", n: "Xã Công Hải", p: "56" },
  { c: "22657", n: "Xã Diên Điền", p: "56" },
  { c: "22651", n: "Xã Diên Khánh", p: "56" },
  { c: "22678", n: "Xã Diên Lạc", p: "56" },
  { c: "22660", n: "Xã Diên Lâm", p: "56" },
  { c: "22672", n: "Xã Diên Thọ", p: "56" },
  { c: "22504", n: "Xã Đại Lãnh", p: "56" },
  { c: "22732", n: "Xã Đông Khánh Sơn", p: "56" },
  { c: "22558", n: "Xã Hoà Trí", p: "56" },
  { c: "22714", n: "Xã Khánh Sơn", p: "56" },
  { c: "22609", n: "Xã Khánh Vĩnh", p: "56" },
  { c: "22813", n: "Xã Lâm Sơn", p: "56" },
  { c: "22822", n: "Xã Mỹ Sơn", p: "56" },
  { c: "22480", n: "Xã Nam Cam Ranh", p: "56" },
  { c: "22648", n: "Xã Nam Khánh Vĩnh", p: "56" },
  { c: "22597", n: "Xã Nam Ninh Hoà", p: "56" },
  { c: "22852", n: "Xã Ninh Hải", p: "56" },
  { c: "22870", n: "Xã Ninh Phước", p: "56" },
  { c: "22810", n: "Xã Ninh Sơn", p: "56" },
  { c: "22888", n: "Xã Phước Dinh", p: "56" },
  { c: "22900", n: "Xã Phước Hà", p: "56" },
  { c: "22873", n: "Xã Phước Hậu", p: "56" },
  { c: "22891", n: "Xã Phước Hữu", p: "56" },
  { c: "22708", n: "Xã Suối Dầu", p: "56" },
  { c: "22702", n: "Xã Suối Hiệp", p: "56" },
  { c: "22576", n: "Xã Tân Định", p: "56" },
  { c: "22720", n: "Xã Tây Khánh Sơn", p: "56" },
  { c: "22624", n: "Xã Tây Khánh Vĩnh", p: "56" },
  { c: "22552", n: "Xã Tây Ninh Hoà", p: "56" },
  { c: "22849", n: "Xã Thuận Bắc", p: "56" },
  { c: "22897", n: "Xã Thuận Nam", p: "56" },
  { c: "22612", n: "Xã Trung Khánh Vĩnh", p: "56" },
  { c: "22498", n: "Xã Tu Bông", p: "56" },
  { c: "22525", n: "Xã Vạn Hưng", p: "56" },
  { c: "22489", n: "Xã Vạn Ninh", p: "56" },
  { c: "22516", n: "Xã Vạn Thắng", p: "56" },
  { c: "22846", n: "Xã Vĩnh Hải", p: "56" },
  { c: "22861", n: "Xã Xuân Hải", p: "56" },
  { c: "22045", n: "Phường Bình Kiến", p: "66" },
  { c: "24305", n: "Phường Buôn Hồ", p: "66" },
  { c: "24133", n: "Phường Buôn Ma Thuột", p: "66" },
  { c: "24340", n: "Phường Cư Bao", p: "66" },
  { c: "22258", n: "Phường Đông Hoà", p: "66" },
  { c: "24169", n: "Phường Ea Kao", p: "66" },
  { c: "22261", n: "Phường Hoà Hiệp", p: "66" },
  { c: "22240", n: "Phường Phú Yên", p: "66" },
  { c: "22051", n: "Phường Sông Cầu", p: "66" },
  { c: "24163", n: "Phường Tân An", p: "66" },
  { c: "24121", n: "Phường Tân Lập", p: "66" },
  { c: "24154", n: "Phường Thành Nhất", p: "66" },
  { c: "22015", n: "Phường Tuy Hoà", p: "66" },
  { c: "22076", n: "Phường Xuân Đài", p: "66" },
  { c: "24235", n: "Xã Buôn Đôn", p: "66" },
  { c: "24301", n: "Xã Cuôr Đăng", p: "66" },
  { c: "24280", n: "Xã Cư M'gar", p: "66" },
  { c: "24436", n: "Xã Cư M'ta", p: "66" },
  { c: "24313", n: "Xã Cư Pơng", p: "66" },
  { c: "24415", n: "Xã Cư Prao", p: "66" },
  { c: "24478", n: "Xã Cư Pui", p: "66" },
  { c: "24406", n: "Xã Cư Yang", p: "66" },
  { c: "24454", n: "Xã Dang Kang", p: "66" },
  { c: "24346", n: "Xã Dliê Ya", p: "66" },
  { c: "24561", n: "Xã Dray Bhăng", p: "66" },
  { c: "24568", n: "Xã Dur Kmăl", p: "66" },
  { c: "24595", n: "Xã Đắk Liêng", p: "66" },
  { c: "24598", n: "Xã Đắk Phơi", p: "66" },
  { c: "22081", n: "Xã Đồng Xuân", p: "66" },
  { c: "22222", n: "Xã Đức Bình", p: "66" },
  { c: "22225", n: "Xã Ea Bá", p: "66" },
  { c: "24229", n: "Xã Ea Bung", p: "66" },
  { c: "24181", n: "Xã Ea Drăng", p: "66" },
  { c: "24328", n: "Xã Ea Drông", p: "66" },
  { c: "24184", n: "Xã Ea H'Leo", p: "66" },
  { c: "24187", n: "Xã Ea Hiao", p: "66" },
  { c: "24373", n: "Xã Ea Kar", p: "66" },
  { c: "24208", n: "Xã Ea Khăl", p: "66" },
  { c: "24265", n: "Xã Ea Kiết", p: "66" },
  { c: "24496", n: "Xã Ea Kly", p: "66" },
  { c: "24376", n: "Xã Ea Knốp", p: "66" },
  { c: "24505", n: "Xã Ea Knuếc", p: "66" },
  { c: "24544", n: "Xã Ea Ktur", p: "66" },
  { c: "22237", n: "Xã Ea Ly", p: "66" },
  { c: "24286", n: "Xã Ea M'Droh", p: "66" },
  { c: "24559", n: "Xã Ea Na", p: "66" },
  { c: "24540", n: "Xã Ea Ning", p: "66" },
  { c: "24250", n: "Xã Ea Nuôl", p: "66" },
  { c: "24403", n: "Xã Ea Ô", p: "66" },
  { c: "24400", n: "Xã Ea Păl", p: "66" },
  { c: "24502", n: "Xã Ea Phê", p: "66" },
  { c: "24433", n: "Xã Ea Riêng", p: "66" },
  { c: "24217", n: "Xã Ea Rốk", p: "66" },
  { c: "24211", n: "Xã Ea Súp", p: "66" },
  { c: "24445", n: "Xã Ea Trang", p: "66" },
  { c: "24277", n: "Xã Ea Tul", p: "66" },
  { c: "24241", n: "Xã Ea Wer", p: "66" },
  { c: "24193", n: "Xã Ea Wy", p: "66" },
  { c: "22285", n: "Xã Hoà Mỹ", p: "66" },
  { c: "24175", n: "Xã Hoà Phú", p: "66" },
  { c: "24472", n: "Xã Hoà Sơn", p: "66" },
  { c: "22276", n: "Xã Hoà Thịnh", p: "66" },
  { c: "22291", n: "Xã Hoà Xuân", p: "66" },
  { c: "24214", n: "Xã Ia Lốp", p: "66" },
  { c: "24221", n: "Xã Ia Rvê", p: "66" },
  { c: "24444", n: "Xã Krông Á", p: "66" },
  { c: "24538", n: "Xã Krông Ana", p: "66" },
  { c: "24448", n: "Xã Krông Bông", p: "66" },
  { c: "24310", n: "Xã Krông Búk", p: "66" },
  { c: "24343", n: "Xã Krông Năng", p: "66" },
  { c: "24604", n: "Xã Krông Nô", p: "66" },
  { c: "24490", n: "Xã Krông Pắc", p: "66" },
  { c: "24580", n: "Xã Liên Sơn Lắk", p: "66" },
  { c: "24412", n: "Xã M'Drắk", p: "66" },
  { c: "24607", n: "Xã Nam Ka", p: "66" },
  { c: "22147", n: "Xã Ô Loan", p: "66" },
  { c: "22319", n: "Xã Phú Hoà 1", p: "66" },
  { c: "22303", n: "Xã Phú Hoà 2", p: "66" },
  { c: "22096", n: "Xã Phú Mỡ", p: "66" },
  { c: "24364", n: "Xã Phú Xuân", p: "66" },
  { c: "24316", n: "Xã Pơng Drang", p: "66" },
  { c: "24259", n: "Xã Quảng Phú", p: "66" },
  { c: "22207", n: "Xã Sông Hinh", p: "66" },
  { c: "22165", n: "Xã Sơn Hoà", p: "66" },
  { c: "22250", n: "Xã Sơn Thành", p: "66" },
  { c: "22192", n: "Xã Suối Trai", p: "66" },
  { c: "24352", n: "Xã Tam Giang", p: "66" },
  { c: "24526", n: "Xã Tân Tiến", p: "66" },
  { c: "22255", n: "Xã Tây Hoà", p: "66" },
  { c: "22171", n: "Xã Tây Sơn", p: "66" },
  { c: "22114", n: "Xã Tuy An Bắc", p: "66" },
  { c: "22120", n: "Xã Tuy An Đông", p: "66" },
  { c: "22153", n: "Xã Tuy An Nam", p: "66" },
  { c: "22132", n: "Xã Tuy An Tây", p: "66" },
  { c: "22177", n: "Xã Vân Hoà", p: "66" },
  { c: "24529", n: "Xã Vụ Bổn", p: "66" },
  { c: "22060", n: "Xã Xuân Cảnh", p: "66" },
  { c: "22090", n: "Xã Xuân Lãnh", p: "66" },
  { c: "22057", n: "Xã Xuân Lộc", p: "66" },
  { c: "22111", n: "Xã Xuân Phước", p: "66" },
  { c: "22075", n: "Xã Xuân Thọ", p: "66" },
  { c: "24484", n: "Xã Yang Mao", p: "66" },
  { c: "23272", n: "Đặc khu Phú Quý", p: "68" },
  { c: "24823", n: "Phường 1 Bảo Lộc", p: "68" },
  { c: "24820", n: "Phường 2 Bảo Lộc", p: "68" },
  { c: "24841", n: "Phường 3 Bảo Lộc", p: "68" },
  { c: "24829", n: "Phường B'Lao", p: "68" },
  { c: "24611", n: "Phường Bắc Gia Nghĩa", p: "68" },
  { c: "22960", n: "Phường Bình Thuận", p: "68" },
  { c: "24787", n: "Phường Cam Ly - Đà Lạt", p: "68" },
  { c: "24617", n: "Phường Đông Gia Nghĩa", p: "68" },
  { c: "22933", n: "Phường Hàm Thắng", p: "68" },
  { c: "23235", n: "Phường La Gi", p: "68" },
  { c: "24846", n: "Phường Lang Biang - Đà Lạt", p: "68" },
  { c: "24778", n: "Phường Lâm Viên - Đà Lạt", p: "68" },
  { c: "22918", n: "Phường Mũi Né", p: "68" },
  { c: "24615", n: "Phường Nam Gia Nghĩa", p: "68" },
  { c: "22945", n: "Phường Phan Thiết", p: "68" },
  { c: "22924", n: "Phường Phú Thuỷ", p: "68" },
  { c: "23231", n: "Phường Phước Hội", p: "68" },
  { c: "22954", n: "Phường Tiến Thành", p: "68" },
  { c: "24781", n: "Phường Xuân Hương - Đà Lạt", p: "68" },
  { c: "24805", n: "Phường Xuân Trường - Đà Lạt", p: "68" },
  { c: "25054", n: "Xã Bảo Lâm 1", p: "68" },
  { c: "25084", n: "Xã Bảo Lâm 2", p: "68" },
  { c: "25093", n: "Xã Bảo Lâm 3", p: "68" },
  { c: "25063", n: "Xã Bảo Lâm 4", p: "68" },
  { c: "25057", n: "Xã Bảo Lâm 5", p: "68" },
  { c: "25018", n: "Xã Bảo Thuận", p: "68" },
  { c: "23005", n: "Xã Bắc Bình", p: "68" },
  { c: "23152", n: "Xã Bắc Ruộng", p: "68" },
  { c: "25159", n: "Xã Cát Tiên", p: "68" },
  { c: "25180", n: "Xã Cát Tiên 2", p: "68" },
  { c: "25162", n: "Xã Cát Tiên 3", p: "68" },
  { c: "24640", n: "Xã Cư Jút", p: "68" },
  { c: "24934", n: "Xã D'Ran", p: "68" },
  { c: "25000", n: "Xã Di Linh", p: "68" },
  { c: "25099", n: "Xã Đạ Huoai", p: "68" },
  { c: "25105", n: "Xã Đạ Huoai 2", p: "68" },
  { c: "25114", n: "Xã Đạ Huoai 3", p: "68" },
  { c: "25126", n: "Xã Đạ Tẻh", p: "68" },
  { c: "25138", n: "Xã Đạ Tẻh 2", p: "68" },
  { c: "25135", n: "Xã Đạ Tẻh 3", p: "68" },
  { c: "24886", n: "Xã Đam Rông 1", p: "68" },
  { c: "24877", n: "Xã Đam Rông 2", p: "68" },
  { c: "24875", n: "Xã Đam Rông 3", p: "68" },
  { c: "24853", n: "Xã Đam Rông 4", p: "68" },
  { c: "24670", n: "Xã Đắk Mil", p: "68" },
  { c: "24678", n: "Xã Đắk Sắk", p: "68" },
  { c: "24718", n: "Xã Đắk Song", p: "68" },
  { c: "24646", n: "Xã Đắk Wil", p: "68" },
  { c: "25007", n: "Xã Đinh Trang Thượng", p: "68" },
  { c: "24871", n: "Xã Đinh Văn Lâm Hà", p: "68" },
  { c: "23074", n: "Xã Đông Giang", p: "68" },
  { c: "23173", n: "Xã Đồng Kho", p: "68" },
  { c: "24931", n: "Xã Đơn Dương", p: "68" },
  { c: "24717", n: "Xã Đức An", p: "68" },
  { c: "24664", n: "Xã Đức Lập", p: "68" },
  { c: "23191", n: "Xã Đức Linh", p: "68" },
  { c: "24958", n: "Xã Đức Trọng", p: "68" },
  { c: "25015", n: "Xã Gia Hiệp", p: "68" },
  { c: "23020", n: "Xã Hải Ninh", p: "68" },
  { c: "23128", n: "Xã Hàm Kiệm", p: "68" },
  { c: "23095", n: "Xã Hàm Liêm", p: "68" },
  { c: "23236", n: "Xã Hàm Tân", p: "68" },
  { c: "23122", n: "Xã Hàm Thạnh", p: "68" },
  { c: "23059", n: "Xã Hàm Thuận", p: "68" },
  { c: "23089", n: "Xã Hàm Thuận Bắc", p: "68" },
  { c: "23110", n: "Xã Hàm Thuận Nam", p: "68" },
  { c: "24967", n: "Xã Hiệp Thạnh", p: "68" },
  { c: "25042", n: "Xã Hoà Bắc", p: "68" },
  { c: "25036", n: "Xã Hoà Ninh", p: "68" },
  { c: "23053", n: "Xã Hoà Thắng", p: "68" },
  { c: "23194", n: "Xã Hoài Đức", p: "68" },
  { c: "23086", n: "Xã Hồng Sơn", p: "68" },
  { c: "23041", n: "Xã Hồng Thái", p: "68" },
  { c: "24943", n: "Xã Ka Đô", p: "68" },
  { c: "24733", n: "Xã Kiến Đức", p: "68" },
  { c: "24688", n: "Xã Krông Nô", p: "68" },
  { c: "23065", n: "Xã La Dạ", p: "68" },
  { c: "24848", n: "Xã Lạc Dương", p: "68" },
  { c: "22969", n: "Xã Liên Hương", p: "68" },
  { c: "23032", n: "Xã Lương Sơn", p: "68" },
  { c: "24868", n: "Xã Nam Ban Lâm Hà", p: "68" },
  { c: "24649", n: "Xã Nam Dong", p: "68" },
  { c: "24697", n: "Xã Nam Đà", p: "68" },
  { c: "24883", n: "Xã Nam Hà Lâm Hà", p: "68" },
  { c: "23200", n: "Xã Nam Thành", p: "68" },
  { c: "24703", n: "Xã Nâm Nung", p: "68" },
  { c: "23158", n: "Xã Nghị Đức", p: "68" },
  { c: "24751", n: "Xã Nhân Cơ", p: "68" },
  { c: "24985", n: "Xã Ninh Gia", p: "68" },
  { c: "22972", n: "Xã Phan Rí Cửa", p: "68" },
  { c: "23008", n: "Xã Phan Sơn", p: "68" },
  { c: "24895", n: "Xã Phú Sơn Lâm Hà", p: "68" },
  { c: "24907", n: "Xã Phúc Thọ Lâm Hà", p: "68" },
  { c: "24620", n: "Xã Quảng Hoà", p: "68" },
  { c: "24631", n: "Xã Quảng Khê", p: "68" },
  { c: "24955", n: "Xã Quảng Lập", p: "68" },
  { c: "24712", n: "Xã Quảng Phú", p: "68" },
  { c: "24616", n: "Xã Quảng Sơn", p: "68" },
  { c: "24748", n: "Xã Quảng Tân", p: "68" },
  { c: "24760", n: "Xã Quảng Tín", p: "68" },
  { c: "24736", n: "Xã Quảng Trực", p: "68" },
  { c: "23023", n: "Xã Sông Luỹ", p: "68" },
  { c: "25051", n: "Xã Sơn Điền", p: "68" },
  { c: "23266", n: "Xã Sơn Mỹ", p: "68" },
  { c: "23188", n: "Xã Suối Kiết", p: "68" },
  { c: "24637", n: "Xã Tà Đùng", p: "68" },
  { c: "24991", n: "Xã Tà Hine", p: "68" },
  { c: "24988", n: "Xã Tà Năng", p: "68" },
  { c: "23149", n: "Xã Tánh Linh", p: "68" },
  { c: "24916", n: "Xã Tân Hà Lâm Hà", p: "68" },
  { c: "23246", n: "Xã Tân Hải", p: "68" },
  { c: "24976", n: "Xã Tân Hội", p: "68" },
  { c: "23134", n: "Xã Tân Lập", p: "68" },
  { c: "23230", n: "Xã Tân Minh", p: "68" },
  { c: "23143", n: "Xã Tân Thành", p: "68" },
  { c: "24682", n: "Xã Thuận An", p: "68" },
  { c: "24722", n: "Xã Thuận Hạnh", p: "68" },
  { c: "23227", n: "Xã Trà Tân", p: "68" },
  { c: "24730", n: "Xã Trường Xuân", p: "68" },
  { c: "24739", n: "Xã Tuy Đức", p: "68" },
  { c: "22978", n: "Xã Tuy Phong", p: "68" },
  { c: "22963", n: "Xã Tuyên Quang", p: "68" },
  { c: "22981", n: "Xã Vĩnh Hảo", p: "68" },
  { c: "25333", n: "Phường An Lộc", p: "75" },
  { c: "26098", n: "Phường Bảo Vinh", p: "75" },
  { c: "26068", n: "Phường Biên Hoà", p: "75" },
  { c: "25326", n: "Phường Bình Long", p: "75" },
  { c: "26089", n: "Phường Bình Lộc", p: "75" },
  { c: "25195", n: "Phường Bình Phước", p: "75" },
  { c: "25432", n: "Phường Chơn Thành", p: "75" },
  { c: "26326", n: "Phường Dầu Giây", p: "75" },
  { c: "25363", n: "Phường Đồng Phú", p: "75" },
  { c: "25210", n: "Phường Đồng Xoài", p: "75" },
  { c: "26113", n: "Phường Hàng Gòn", p: "75" },
  { c: "26005", n: "Phường Hố Nai", p: "75" },
  { c: "26020", n: "Phường Long Bình", p: "75" },
  { c: "26380", n: "Phường Long Hưng", p: "75" },
  { c: "26080", n: "Phường Long Khánh", p: "75" },
  { c: "26368", n: "Phường Long Thành", p: "75" },
  { c: "25270", n: "Phường Lộc Ninh", p: "75" },
  { c: "25441", n: "Phường Minh Hưng", p: "75" },
  { c: "26485", n: "Phường Nhơn Trạch", p: "75" },
  { c: "25220", n: "Phường Phước Bình", p: "75" },
  { c: "25217", n: "Phường Phước Long", p: "75" },
  { c: "26377", n: "Phường Phước Tân", p: "75" },
  { c: "26017", n: "Phường Tam Hiệp", p: "75" },
  { c: "26374", n: "Phường Tam Phước", p: "75" },
  { c: "25357", n: "Phường Tân Khai", p: "75" },
  { c: "26116", n: "Phường Tân Phú", p: "75" },
  { c: "26188", n: "Phường Tân Triều", p: "75" },
  { c: "26248", n: "Phường Trảng Bom", p: "75" },
  { c: "25993", n: "Phường Trảng Dài", p: "75" },
  { c: "26041", n: "Phường Trấn Biên", p: "75" },
  { c: "26170", n: "Phường Trị An", p: "75" },
  { c: "26104", n: "Phường Xuân Lập", p: "75" },
  { c: "26425", n: "Phường Xuân Lộc", p: "75" },
  { c: "26383", n: "Xã An Phước", p: "75" },
  { c: "26296", n: "Xã An Viễn", p: "75" },
  { c: "26254", n: "Xã Bàu Hàm", p: "75" },
  { c: "26389", n: "Xã Bình An", p: "75" },
  { c: "26278", n: "Xã Bình Minh", p: "75" },
  { c: "25246", n: "Xã Bình Tân", p: "75" },
  { c: "25405", n: "Xã Bom Bo", p: "75" },
  { c: "25396", n: "Xã Bù Đăng", p: "75" },
  { c: "25222", n: "Xã Bù Gia Mập", p: "75" },
  { c: "26341", n: "Xã Cẩm Mỹ", p: "75" },
  { c: "25231", n: "Xã Đa Kia", p: "75" },
  { c: "26491", n: "Xã Đại Phước", p: "75" },
  { c: "26119", n: "Xã Đak Lua", p: "75" },
  { c: "25399", n: "Xã Đak Nhau", p: "75" },
  { c: "25225", n: "Xã Đăk Ơ", p: "75" },
  { c: "26206", n: "Xã Định Quán", p: "75" },
  { c: "25390", n: "Xã Đồng Tâm", p: "75" },
  { c: "26311", n: "Xã Gia Kiệm", p: "75" },
  { c: "25309", n: "Xã Hưng Phước", p: "75" },
  { c: "26281", n: "Xã Hưng Thịnh", p: "75" },
  { c: "26227", n: "Xã La Ngà", p: "75" },
  { c: "25255", n: "Xã Long Hà", p: "75" },
  { c: "26413", n: "Xã Long Phước", p: "75" },
  { c: "25303", n: "Xã Lộc Hưng", p: "75" },
  { c: "25292", n: "Xã Lộc Quang", p: "75" },
  { c: "25279", n: "Xã Lộc Tấn", p: "75" },
  { c: "25294", n: "Xã Lộc Thành", p: "75" },
  { c: "25280", n: "Xã Lộc Thạnh", p: "75" },
  { c: "25349", n: "Xã Minh Đức", p: "75" },
  { c: "26122", n: "Xã Nam Cát Tiên", p: "75" },
  { c: "25417", n: "Xã Nghĩa Trung", p: "75" },
  { c: "25450", n: "Xã Nha Bích", p: "75" },
  { c: "26221", n: "Xã Phú Hoà", p: "75" },
  { c: "26158", n: "Xã Phú Lâm", p: "75" },
  { c: "26173", n: "Xã Phú Lý", p: "75" },
  { c: "25267", n: "Xã Phú Nghĩa", p: "75" },
  { c: "25252", n: "Xã Phú Riềng", p: "75" },
  { c: "25261", n: "Xã Phú Trung", p: "75" },
  { c: "26215", n: "Xã Phú Vinh", p: "75" },
  { c: "26503", n: "Xã Phước An", p: "75" },
  { c: "25420", n: "Xã Phước Sơn", p: "75" },
  { c: "26422", n: "Xã Phước Thái", p: "75" },
  { c: "26362", n: "Xã Sông Ray", p: "75" },
  { c: "26134", n: "Xã Tà Lài", p: "75" },
  { c: "26179", n: "Xã Tân An", p: "75" },
  { c: "25345", n: "Xã Tân Hưng", p: "75" },
  { c: "25378", n: "Xã Tân Lợi", p: "75" },
  { c: "25351", n: "Xã Tân Quan", p: "75" },
  { c: "25318", n: "Xã Tân Tiến", p: "75" },
  { c: "26209", n: "Xã Thanh Sơn", p: "75" },
  { c: "25308", n: "Xã Thiện Hưng", p: "75" },
  { c: "25402", n: "Xã Thọ Sơn", p: "75" },
  { c: "26299", n: "Xã Thống Nhất", p: "75" },
  { c: "25387", n: "Xã Thuận Lợi", p: "75" },
  { c: "26428", n: "Xã Xuân Bắc", p: "75" },
  { c: "26461", n: "Xã Xuân Định", p: "75" },
  { c: "26359", n: "Xã Xuân Đông", p: "75" },
  { c: "26347", n: "Xã Xuân Đường", p: "75" },
  { c: "26446", n: "Xã Xuân Hoà", p: "75" },
  { c: "26458", n: "Xã Xuân Phú", p: "75" },
  { c: "26332", n: "Xã Xuân Quế", p: "75" },
  { c: "26434", n: "Xã Xuân Thành", p: "75" },
  { c: "26732", n: "Đặc khu Côn Đảo", p: "79" },
  { c: "27316", n: "Phường An Đông", p: "79" },
  { c: "26878", n: "Phường An Hội Đông", p: "79" },
  { c: "26882", n: "Phường An Hội Tây", p: "79" },
  { c: "27094", n: "Phường An Khánh", p: "79" },
  { c: "27460", n: "Phường An Lạc", p: "79" },
  { c: "26876", n: "Phường An Nhơn", p: "79" },
  { c: "25975", n: "Phường An Phú", p: "79" },
  { c: "26767", n: "Phường An Phú Đông", p: "79" },
  { c: "26560", n: "Phường Bà Rịa", p: "79" },
  { c: "27154", n: "Phường Bàn Cờ", p: "79" },
  { c: "26983", n: "Phường Bảy Hiền", p: "79" },
  { c: "25813", n: "Phường Bến Cát", p: "79" },
  { c: "26743", n: "Phường Bến Thành", p: "79" },
  { c: "25915", n: "Phường Bình Cơ", p: "79" },
  { c: "25760", n: "Phường Bình Dương", p: "79" },
  { c: "27424", n: "Phường Bình Đông", p: "79" },
  { c: "25987", n: "Phường Bình Hoà", p: "79" },
  { c: "27439", n: "Phường Bình Hưng Hoà", p: "79" },
  { c: "26905", n: "Phường Bình Lợi Trung", p: "79" },
  { c: "27364", n: "Phường Bình Phú", p: "79" },
  { c: "26911", n: "Phường Bình Quới", p: "79" },
  { c: "27442", n: "Phường Bình Tân", p: "79" },
  { c: "27367", n: "Phường Bình Tây", p: "79" },
  { c: "26929", n: "Phường Bình Thạnh", p: "79" },
  { c: "27232", n: "Phường Bình Thới", p: "79" },
  { c: "27373", n: "Phường Bình Tiên", p: "79" },
  { c: "27448", n: "Phường Bình Trị Đông", p: "79" },
  { c: "27097", n: "Phường Bình Trưng", p: "79" },
  { c: "27112", n: "Phường Cát Lái", p: "79" },
  { c: "27058", n: "Phường Cầu Kiệu", p: "79" },
  { c: "26758", n: "Phường Cầu Ông Lãnh", p: "79" },
  { c: "25771", n: "Phường Chánh Hiệp", p: "79" },
  { c: "27418", n: "Phường Chánh Hưng", p: "79" },
  { c: "25837", n: "Phường Chánh Phú Hoà", p: "79" },
  { c: "27343", n: "Phường Chợ Lớn", p: "79" },
  { c: "27301", n: "Phường Chợ Quán", p: "79" },
  { c: "25942", n: "Phường Dĩ An", p: "79" },
  { c: "27169", n: "Phường Diên Hồng", p: "79" },
  { c: "25951", n: "Phường Đông Hoà", p: "79" },
  { c: "26791", n: "Phường Đông Hưng Thuận", p: "79" },
  { c: "27043", n: "Phường Đức Nhuận", p: "79" },
  { c: "26944", n: "Phường Gia Định", p: "79" },
  { c: "26884", n: "Phường Gò Vấp", p: "79" },
  { c: "26890", n: "Phường Hạnh Thông", p: "79" },
  { c: "26809", n: "Phường Hiệp Bình", p: "79" },
  { c: "27211", n: "Phường Hoà Bình", p: "79" },
  { c: "27163", n: "Phường Hoà Hưng", p: "79" },
  { c: "25849", n: "Phường Hoà Lợi", p: "79" },
  { c: "27265", n: "Phường Khánh Hội", p: "79" },
  { c: "25966", n: "Phường Lái Thiêu", p: "79" },
  { c: "26800", n: "Phường Linh Xuân", p: "79" },
  { c: "26833", n: "Phường Long Bình", p: "79" },
  { c: "26566", n: "Phường Long Hương", p: "79" },
  { c: "25840", n: "Phường Long Nguyên", p: "79" },
  { c: "26857", n: "Phường Long Phước", p: "79" },
  { c: "26860", n: "Phường Long Trường", p: "79" },
  { c: "27238", n: "Phường Minh Phụng", p: "79" },
  { c: "27142", n: "Phường Nhiêu Lộc", p: "79" },
  { c: "25768", n: "Phường Phú An", p: "79" },
  { c: "27427", n: "Phường Phú Định", p: "79" },
  { c: "27349", n: "Phường Phú Lâm", p: "79" },
  { c: "25750", n: "Phường Phú Lợi", p: "79" },
  { c: "26704", n: "Phường Phú Mỹ", p: "79" },
  { c: "27073", n: "Phường Phú Nhuận", p: "79" },
  { c: "27028", n: "Phường Phú Thạnh", p: "79" },
  { c: "27226", n: "Phường Phú Thọ", p: "79" },
  { c: "27022", n: "Phường Phú Thọ Hoà", p: "79" },
  { c: "27484", n: "Phường Phú Thuận", p: "79" },
  { c: "26848", n: "Phường Phước Long", p: "79" },
  { c: "26542", n: "Phường Phước Thắng", p: "79" },
  { c: "26536", n: "Phường Rạch Dừa", p: "79" },
  { c: "26740", n: "Phường Sài Gòn", p: "79" },
  { c: "26803", n: "Phường Tam Bình", p: "79" },
  { c: "26572", n: "Phường Tam Long", p: "79" },
  { c: "26526", n: "Phường Tam Thắng", p: "79" },
  { c: "26842", n: "Phường Tăng Nhơn Phú", p: "79" },
  { c: "27004", n: "Phường Tân Bình", p: "79" },
  { c: "26737", n: "Phường Tân Định", p: "79" },
  { c: "25945", n: "Phường Tân Đông Hiệp", p: "79" },
  { c: "26710", n: "Phường Tân Hải", p: "79" },
  { c: "25920", n: "Phường Tân Hiệp", p: "79" },
  { c: "26995", n: "Phường Tân Hoà", p: "79" },
  { c: "27475", n: "Phường Tân Hưng", p: "79" },
  { c: "25891", n: "Phường Tân Khánh", p: "79" },
  { c: "27487", n: "Phường Tân Mỹ", p: "79" },
  { c: "27031", n: "Phường Tân Phú", p: "79" },
  { c: "26713", n: "Phường Tân Phước", p: "79" },
  { c: "27007", n: "Phường Tân Sơn", p: "79" },
  { c: "26977", n: "Phường Tân Sơn Hoà", p: "79" },
  { c: "26968", n: "Phường Tân Sơn Nhất", p: "79" },
  { c: "27019", n: "Phường Tân Sơn Nhì", p: "79" },
  { c: "27457", n: "Phường Tân Tạo", p: "79" },
  { c: "26725", n: "Phường Tân Thành", p: "79" },
  { c: "26782", n: "Phường Tân Thới Hiệp", p: "79" },
  { c: "27478", n: "Phường Tân Thuận", p: "79" },
  { c: "25888", n: "Phường Tân Uyên", p: "79" },
  { c: "25843", n: "Phường Tây Nam", p: "79" },
  { c: "27013", n: "Phường Tây Thạnh", p: "79" },
  { c: "26956", n: "Phường Thạnh Mỹ Tây", p: "79" },
  { c: "26898", n: "Phường Thông Tây Hội", p: "79" },
  { c: "26773", n: "Phường Thới An", p: "79" },
  { c: "25846", n: "Phường Thới Hoà", p: "79" },
  { c: "25747", n: "Phường Thủ Dầu Một", p: "79" },
  { c: "26824", n: "Phường Thủ Đức", p: "79" },
  { c: "25978", n: "Phường Thuận An", p: "79" },
  { c: "25969", n: "Phường Thuận Giao", p: "79" },
  { c: "26785", n: "Phường Trung Mỹ Tây", p: "79" },
  { c: "27286", n: "Phường Vĩnh Hội", p: "79" },
  { c: "25912", n: "Phường Vĩnh Tân", p: "79" },
  { c: "26506", n: "Phường Vũng Tàu", p: "79" },
  { c: "27190", n: "Phường Vườn Lài", p: "79" },
  { c: "27259", n: "Phường Xóm Chiếu", p: "79" },
  { c: "27139", n: "Phường Xuân Hoà", p: "79" },
  { c: "25867", n: "Xã An Long", p: "79" },
  { c: "27508", n: "Xã An Nhơn Tây", p: "79" },
  { c: "27673", n: "Xã An Thới Đông", p: "79" },
  { c: "27592", n: "Xã Bà Điểm", p: "79" },
  { c: "25822", n: "Xã Bàu Bàng", p: "79" },
  { c: "26638", n: "Xã Bàu Lâm", p: "79" },
  { c: "25906", n: "Xã Bắc Tân Uyên", p: "79" },
  { c: "27637", n: "Xã Bình Chánh", p: "79" },
  { c: "26656", n: "Xã Bình Châu", p: "79" },
  { c: "26590", n: "Xã Bình Giã", p: "79" },
  { c: "27619", n: "Xã Bình Hưng", p: "79" },
  { c: "27667", n: "Xã Bình Khánh", p: "79" },
  { c: "27610", n: "Xã Bình Lợi", p: "79" },
  { c: "27544", n: "Xã Bình Mỹ", p: "79" },
  { c: "27664", n: "Xã Cần Giờ", p: "79" },
  { c: "26596", n: "Xã Châu Đức", p: "79" },
  { c: "26728", n: "Xã Châu Pha", p: "79" },
  { c: "27553", n: "Xã Củ Chi", p: "79" },
  { c: "25777", n: "Xã Dầu Tiếng", p: "79" },
  { c: "26680", n: "Xã Đất Đỏ", p: "79" },
  { c: "27568", n: "Xã Đông Thạnh", p: "79" },
  { c: "27658", n: "Xã Hiệp Phước", p: "79" },
  { c: "26647", n: "Xã Hoà Hiệp", p: "79" },
  { c: "26641", n: "Xã Hoà Hội", p: "79" },
  { c: "27559", n: "Xã Hóc Môn", p: "79" },
  { c: "26620", n: "Xã Hồ Tràm", p: "79" },
  { c: "27628", n: "Xã Hưng Long", p: "79" },
  { c: "26608", n: "Xã Kim Long", p: "79" },
  { c: "26659", n: "Xã Long Điền", p: "79" },
  { c: "26662", n: "Xã Long Hải", p: "79" },
  { c: "25792", n: "Xã Long Hoà", p: "79" },
  { c: "26545", n: "Xã Long Sơn", p: "79" },
  { c: "25780", n: "Xã Minh Thạnh", p: "79" },
  { c: "26575", n: "Xã Ngãi Giao", p: "79" },
  { c: "26617", n: "Xã Nghĩa Thành", p: "79" },
  { c: "27655", n: "Xã Nhà Bè", p: "79" },
  { c: "27511", n: "Xã Nhuận Đức", p: "79" },
  { c: "25858", n: "Xã Phú Giáo", p: "79" },
  { c: "27541", n: "Xã Phú Hoà Đông", p: "79" },
  { c: "26686", n: "Xã Phước Hải", p: "79" },
  { c: "25882", n: "Xã Phước Hoà", p: "79" },
  { c: "25864", n: "Xã Phước Thành", p: "79" },
  { c: "27496", n: "Xã Tân An Hội", p: "79" },
  { c: "27595", n: "Xã Tân Nhựt", p: "79" },
  { c: "27604", n: "Xã Tân Vĩnh Lộc", p: "79" },
  { c: "27526", n: "Xã Thái Mỹ", p: "79" },
  { c: "25807", n: "Xã Thanh An", p: "79" },
  { c: "27676", n: "Xã Thạnh An", p: "79" },
  { c: "25909", n: "Xã Thường Tân", p: "79" },
  { c: "25819", n: "Xã Trừ Văn Thố", p: "79" },
  { c: "27601", n: "Xã Vĩnh Lộc", p: "79" },
  { c: "26584", n: "Xã Xuân Sơn", p: "79" },
  { c: "27577", n: "Xã Xuân Thới Sơn", p: "79" },
  { c: "26632", n: "Xã Xuyên Mộc", p: "79" },
  { c: "25732", n: "Phường An Tịnh", p: "80" },
  { c: "25480", n: "Phường Bình Minh", p: "80" },
  { c: "25672", n: "Phường Gia Lộc", p: "80" },
  { c: "25654", n: "Phường Gò Dầu", p: "80" },
  { c: "25645", n: "Phường Hoà Thành", p: "80" },
  { c: "27715", n: "Phường Khánh Hậu", p: "80" },
  { c: "27787", n: "Phường Kiến Tường", p: "80" },
  { c: "27694", n: "Phường Long An", p: "80" },
  { c: "25630", n: "Phường Long Hoa", p: "80" },
  { c: "25567", n: "Phường Ninh Thạnh", p: "80" },
  { c: "27712", n: "Phường Tân An", p: "80" },
  { c: "25459", n: "Phường Tân Ninh", p: "80" },
  { c: "25633", n: "Phường Thanh Điền", p: "80" },
  { c: "25708", n: "Phường Trảng Bàng", p: "80" },
  { c: "28243", n: "Xã An Lục Long", p: "80" },
  { c: "27943", n: "Xã An Ninh", p: "80" },
  { c: "25681", n: "Xã Bến Cầu", p: "80" },
  { c: "27991", n: "Xã Bến Lức", p: "80" },
  { c: "28015", n: "Xã Bình Đức", p: "80" },
  { c: "27793", n: "Xã Bình Hiệp", p: "80" },
  { c: "27811", n: "Xã Bình Hoà", p: "80" },
  { c: "27868", n: "Xã Bình Thành", p: "80" },
  { c: "28108", n: "Xã Cần Đước", p: "80" },
  { c: "28159", n: "Xã Cần Giuộc", p: "80" },
  { c: "25573", n: "Xã Cầu Khởi", p: "80" },
  { c: "25585", n: "Xã Châu Thành", p: "80" },
  { c: "25552", n: "Xã Dương Minh Châu", p: "80" },
  { c: "27898", n: "Xã Đông Thành", p: "80" },
  { c: "27937", n: "Xã Đức Hoà", p: "80" },
  { c: "27925", n: "Xã Đức Huệ", p: "80" },
  { c: "27964", n: "Xã Đức Lập", p: "80" },
  { c: "25588", n: "Xã Hảo Đước", p: "80" },
  { c: "27931", n: "Xã Hậu Nghĩa", p: "80" },
  { c: "27841", n: "Xã Hậu Thạnh", p: "80" },
  { c: "27952", n: "Xã Hiệp Hoà", p: "80" },
  { c: "25606", n: "Xã Hoà Hội", p: "80" },
  { c: "27979", n: "Xã Hoà Khánh", p: "80" },
  { c: "27727", n: "Xã Hưng Điền", p: "80" },
  { c: "25711", n: "Xã Hưng Thuận", p: "80" },
  { c: "27763", n: "Xã Khánh Hưng", p: "80" },
  { c: "28126", n: "Xã Long Cang", p: "80" },
  { c: "25684", n: "Xã Long Chữ", p: "80" },
  { c: "28144", n: "Xã Long Hựu", p: "80" },
  { c: "25702", n: "Xã Long Thuận", p: "80" },
  { c: "25579", n: "Xã Lộc Ninh", p: "80" },
  { c: "28003", n: "Xã Lương Hoà", p: "80" },
  { c: "27823", n: "Xã Mộc Hoá", p: "80" },
  { c: "28066", n: "Xã Mỹ An", p: "80" },
  { c: "27976", n: "Xã Mỹ Hạnh", p: "80" },
  { c: "28132", n: "Xã Mỹ Lệ", p: "80" },
  { c: "28177", n: "Xã Mỹ Lộc", p: "80" },
  { c: "27907", n: "Xã Mỹ Quý", p: "80" },
  { c: "28051", n: "Xã Mỹ Thạnh", p: "80" },
  { c: "28018", n: "Xã Mỹ Yên", p: "80" },
  { c: "27838", n: "Xã Nhơn Hoà Lập", p: "80" },
  { c: "27856", n: "Xã Nhơn Ninh", p: "80" },
  { c: "28087", n: "Xã Nhựt Tảo", p: "80" },
  { c: "25621", n: "Xã Ninh Điền", p: "80" },
  { c: "25729", n: "Xã Phước Chỉ", p: "80" },
  { c: "28165", n: "Xã Phước Lý", p: "80" },
  { c: "25663", n: "Xã Phước Thạnh", p: "80" },
  { c: "25591", n: "Xã Phước Vinh", p: "80" },
  { c: "28201", n: "Xã Phước Vĩnh Tây", p: "80" },
  { c: "28114", n: "Xã Rạch Kiến", p: "80" },
  { c: "28210", n: "Xã Tầm Vu", p: "80" },
  { c: "25486", n: "Xã Tân Biên", p: "80" },
  { c: "25516", n: "Xã Tân Châu", p: "80" },
  { c: "25522", n: "Xã Tân Đông", p: "80" },
  { c: "25531", n: "Xã Tân Hoà", p: "80" },
  { c: "25525", n: "Xã Tân Hội", p: "80" },
  { c: "27721", n: "Xã Tân Hưng", p: "80" },
  { c: "28138", n: "Xã Tân Lân", p: "80" },
  { c: "25489", n: "Xã Tân Lập", p: "80" },
  { c: "28072", n: "Xã Tân Long", p: "80" },
  { c: "25549", n: "Xã Tân Phú", p: "80" },
  { c: "28207", n: "Xã Tân Tập", p: "80" },
  { c: "27889", n: "Xã Tân Tây", p: "80" },
  { c: "25534", n: "Xã Tân Thành", p: "80" },
  { c: "27826", n: "Xã Tân Thạnh", p: "80" },
  { c: "28075", n: "Xã Tân Trụ", p: "80" },
  { c: "25498", n: "Xã Thạnh Bình", p: "80" },
  { c: "25657", n: "Xã Thạnh Đức", p: "80" },
  { c: "27865", n: "Xã Thạnh Hoá", p: "80" },
  { c: "27994", n: "Xã Thạnh Lợi", p: "80" },
  { c: "27877", n: "Xã Thạnh Phước", p: "80" },
  { c: "28036", n: "Xã Thủ Thừa", p: "80" },
  { c: "28225", n: "Xã Thuận Mỹ", p: "80" },
  { c: "25510", n: "Xã Trà Vong", p: "80" },
  { c: "25666", n: "Xã Truông Mít", p: "80" },
  { c: "27775", n: "Xã Tuyên Bình", p: "80" },
  { c: "27817", n: "Xã Tuyên Thạnh", p: "80" },
  { c: "28093", n: "Xã Vàm Cỏ", p: "80" },
  { c: "27748", n: "Xã Vĩnh Châu", p: "80" },
  { c: "28222", n: "Xã Vĩnh Công", p: "80" },
  { c: "27757", n: "Xã Vĩnh Hưng", p: "80" },
  { c: "27736", n: "Xã Vĩnh Thạnh", p: "80" },
  { c: "29954", n: "Phường An Bình", p: "82" },
  { c: "28315", n: "Phường Bình Xuân", p: "82" },
  { c: "28439", n: "Phường Cai Lậy", p: "82" },
  { c: "29869", n: "Phường Cao Lãnh", p: "82" },
  { c: "28249", n: "Phường Đạo Thạnh", p: "82" },
  { c: "28306", n: "Phường Gò Công", p: "82" },
  { c: "29955", n: "Phường Hồng Ngự", p: "82" },
  { c: "28297", n: "Phường Long Thuận", p: "82" },
  { c: "29884", n: "Phường Mỹ Ngãi", p: "82" },
  { c: "28273", n: "Phường Mỹ Phong", p: "82" },
  { c: "28435", n: "Phường Mỹ Phước Tây", p: "82" },
  { c: "28261", n: "Phường Mỹ Tho", p: "82" },
  { c: "29888", n: "Phường Mỹ Trà", p: "82" },
  { c: "28477", n: "Phường Nhị Quý", p: "82" },
  { c: "29905", n: "Phường Sa Đéc", p: "82" },
  { c: "28729", n: "Phường Sơn Qui", p: "82" },
  { c: "28436", n: "Phường Thanh Hoà", p: "82" },
  { c: "28270", n: "Phường Thới Sơn", p: "82" },
  { c: "29978", n: "Phường Thường Lạc", p: "82" },
  { c: "28285", n: "Phường Trung An", p: "82" },
  { c: "30019", n: "Xã An Hoà", p: "82" },
  { c: "28429", n: "Xã An Hữu", p: "82" },
  { c: "30028", n: "Xã An Long", p: "82" },
  { c: "29944", n: "Xã An Phước", p: "82" },
  { c: "28633", n: "Xã An Thạnh Thuỷ", p: "82" },
  { c: "30085", n: "Xã Ba Sao", p: "82" },
  { c: "30118", n: "Xã Bình Hàng Trung", p: "82" },
  { c: "28648", n: "Xã Bình Ninh", p: "82" },
  { c: "28471", n: "Xã Bình Phú", p: "82" },
  { c: "30163", n: "Xã Bình Thành", p: "82" },
  { c: "28564", n: "Xã Bình Trưng", p: "82" },
  { c: "28360", n: "Xã Cái Bè", p: "82" },
  { c: "28519", n: "Xã Châu Thành", p: "82" },
  { c: "28594", n: "Xã Chợ Gạo", p: "82" },
  { c: "30061", n: "Xã Đốc Binh Kiều", p: "82" },
  { c: "28660", n: "Xã Đồng Sơn", p: "82" },
  { c: "28720", n: "Xã Gia Thuận", p: "82" },
  { c: "28747", n: "Xã Gò Công Đông", p: "82" },
  { c: "28366", n: "Xã Hậu Mỹ", p: "82" },
  { c: "28501", n: "Xã Hiệp Đức", p: "82" },
  { c: "30208", n: "Xã Hoà Long", p: "82" },
  { c: "28393", n: "Xã Hội Cư", p: "82" },
  { c: "28336", n: "Xã Hưng Thạnh", p: "82" },
  { c: "28582", n: "Xã Kim Sơn", p: "82" },
  { c: "30226", n: "Xã Lai Vung", p: "82" },
  { c: "30169", n: "Xã Lấp Vò", p: "82" },
  { c: "28687", n: "Xã Long Bình", p: "82" },
  { c: "28543", n: "Xã Long Định", p: "82" },
  { c: "28537", n: "Xã Long Hưng", p: "82" },
  { c: "29983", n: "Xã Long Khánh", p: "82" },
  { c: "29992", n: "Xã Long Phú Thuận", p: "82" },
  { c: "28504", n: "Xã Long Tiên", p: "82" },
  { c: "28615", n: "Xã Lương Hoà Lạc", p: "82" },
  { c: "30178", n: "Xã Mỹ An Hưng", p: "82" },
  { c: "28405", n: "Xã Mỹ Đức Tây", p: "82" },
  { c: "30112", n: "Xã Mỹ Hiệp", p: "82" },
  { c: "28414", n: "Xã Mỹ Lợi", p: "82" },
  { c: "30055", n: "Xã Mỹ Quí", p: "82" },
  { c: "28456", n: "Xã Mỹ Thành", p: "82" },
  { c: "28378", n: "Xã Mỹ Thiện", p: "82" },
  { c: "30076", n: "Xã Mỹ Thọ", p: "82" },
  { c: "28603", n: "Xã Mỹ Tịnh An", p: "82" },
  { c: "28516", n: "Xã Ngũ Hiệp", p: "82" },
  { c: "30235", n: "Xã Phong Hoà", p: "82" },
  { c: "30088", n: "Xã Phong Mỹ", p: "82" },
  { c: "30025", n: "Xã Phú Cường", p: "82" },
  { c: "30244", n: "Xã Phú Hựu", p: "82" },
  { c: "28663", n: "Xã Phú Thành", p: "82" },
  { c: "30034", n: "Xã Phú Thọ", p: "82" },
  { c: "30043", n: "Xã Phương Thịnh", p: "82" },
  { c: "30010", n: "Xã Tam Nông", p: "82" },
  { c: "30214", n: "Xã Tân Dương", p: "82" },
  { c: "28738", n: "Xã Tân Điền", p: "82" },
  { c: "28723", n: "Xã Tân Đông", p: "82" },
  { c: "28702", n: "Xã Tân Hoà", p: "82" },
  { c: "29929", n: "Xã Tân Hộ Cơ", p: "82" },
  { c: "29926", n: "Xã Tân Hồng", p: "82" },
  { c: "28525", n: "Xã Tân Hương", p: "82" },
  { c: "30184", n: "Xã Tân Khánh Trung", p: "82" },
  { c: "30154", n: "Xã Tân Long", p: "82" },
  { c: "30253", n: "Xã Tân Nhuận Đông", p: "82" },
  { c: "28468", n: "Xã Tân Phú", p: "82" },
  { c: "28696", n: "Xã Tân Phú Đông", p: "82" },
  { c: "30259", n: "Xã Tân Phú Trung", p: "82" },
  { c: "28321", n: "Xã Tân Phước 1", p: "82" },
  { c: "28327", n: "Xã Tân Phước 2", p: "82" },
  { c: "28345", n: "Xã Tân Phước 3", p: "82" },
  { c: "29938", n: "Xã Tân Thành", p: "82" },
  { c: "30157", n: "Xã Tân Thạnh", p: "82" },
  { c: "28693", n: "Xã Tân Thới", p: "82" },
  { c: "28627", n: "Xã Tân Thuận Bình", p: "82" },
  { c: "30130", n: "Xã Thanh Bình", p: "82" },
  { c: "28426", n: "Xã Thanh Hưng", p: "82" },
  { c: "30073", n: "Xã Thanh Mỹ", p: "82" },
  { c: "28444", n: "Xã Thạnh Phú", p: "82" },
  { c: "30037", n: "Xã Tháp Mười", p: "82" },
  { c: "29971", n: "Xã Thường Phước", p: "82" },
  { c: "30001", n: "Xã Tràm Chim", p: "82" },
  { c: "30046", n: "Xã Trường Xuân", p: "82" },
  { c: "28651", n: "Xã Vĩnh Bình", p: "82" },
  { c: "28678", n: "Xã Vĩnh Hựu", p: "82" },
  { c: "28576", n: "Xã Vĩnh Kim", p: "82" },
  { c: "28777", n: "Phường An Hội", p: "86" },
  { c: "28789", n: "Phường Bến Tre", p: "86" },
  { c: "29771", n: "Phường Bình Minh", p: "86" },
  { c: "29770", n: "Phường Cái Vồn", p: "86" },
  { c: "29512", n: "Phường Duyên Hải", p: "86" },
  { c: "29812", n: "Phường Đông Thành", p: "86" },
  { c: "29398", n: "Phường Hoà Thuận", p: "86" },
  { c: "29551", n: "Phường Long Châu", p: "86" },
  { c: "29263", n: "Phường Long Đức", p: "86" },
  { c: "29254", n: "Phường Nguyệt Hoá", p: "86" },
  { c: "28756", n: "Phường Phú Khương", p: "86" },
  { c: "28858", n: "Phường Phú Tân", p: "86" },
  { c: "29557", n: "Phường Phước Hậu", p: "86" },
  { c: "28783", n: "Phường Sơn Đông", p: "86" },
  { c: "29593", n: "Phường Tân Hạnh", p: "86" },
  { c: "29566", n: "Phường Tân Ngãi", p: "86" },
  { c: "29590", n: "Phường Thanh Đức", p: "86" },
  { c: "29242", n: "Phường Trà Vinh", p: "86" },
  { c: "29516", n: "Phường Trường Long Hoà", p: "86" },
  { c: "29584", n: "Xã An Bình", p: "86" },
  { c: "28957", n: "Xã An Định", p: "86" },
  { c: "29158", n: "Xã An Hiệp", p: "86" },
  { c: "29143", n: "Xã An Ngãi Trung", p: "86" },
  { c: "29317", n: "Xã An Phú Tân", p: "86" },
  { c: "29224", n: "Xã An Qui", p: "86" },
  { c: "29275", n: "Xã An Trường", p: "86" },
  { c: "29110", n: "Xã Ba Tri", p: "86" },
  { c: "29125", n: "Xã Bảo Thạnh", p: "86" },
  { c: "29050", n: "Xã Bình Đại", p: "86" },
  { c: "29287", n: "Xã Bình Phú", p: "86" },
  { c: "29638", n: "Xã Bình Phước", p: "86" },
  { c: "29728", n: "Xã Cái Ngang", p: "86" },
  { c: "29641", n: "Xã Cái Nhum", p: "86" },
  { c: "29266", n: "Xã Càng Long", p: "86" },
  { c: "29308", n: "Xã Cầu Kè", p: "86" },
  { c: "29416", n: "Xã Cầu Ngang", p: "86" },
  { c: "28996", n: "Xã Châu Hoà", p: "86" },
  { c: "29083", n: "Xã Châu Hưng", p: "86" },
  { c: "29374", n: "Xã Châu Thành", p: "86" },
  { c: "28870", n: "Xã Chợ Lách", p: "86" },
  { c: "29491", n: "Xã Đại An", p: "86" },
  { c: "29194", n: "Xã Đại Điền", p: "86" },
  { c: "29497", n: "Xã Đôn Châu", p: "86" },
  { c: "29536", n: "Xã Đông Hải", p: "86" },
  { c: "28945", n: "Xã Đồng Khởi", p: "86" },
  { c: "28807", n: "Xã Giao Long", p: "86" },
  { c: "28984", n: "Xã Giồng Trôm", p: "86" },
  { c: "29489", n: "Xã Hàm Giang", p: "86" },
  { c: "29455", n: "Xã Hiệp Mỹ", p: "86" },
  { c: "29701", n: "Xã Hiếu Phụng", p: "86" },
  { c: "29713", n: "Xã Hiếu Thành", p: "86" },
  { c: "29830", n: "Xã Hoà Bình", p: "86" },
  { c: "29734", n: "Xã Hoà Hiệp", p: "86" },
  { c: "29410", n: "Xã Hoà Minh", p: "86" },
  { c: "29362", n: "Xã Hùng Hoà", p: "86" },
  { c: "28901", n: "Xã Hưng Khánh Trung", p: "86" },
  { c: "29407", n: "Xã Hưng Mỹ", p: "86" },
  { c: "29044", n: "Xã Hưng Nhượng", p: "86" },
  { c: "28981", n: "Xã Hương Mỹ", p: "86" },
  { c: "29506", n: "Xã Long Hiệp", p: "86" },
  { c: "29413", n: "Xã Long Hoà", p: "86" },
  { c: "29602", n: "Xã Long Hồ", p: "86" },
  { c: "29518", n: "Xã Long Hữu", p: "86" },
  { c: "29513", n: "Xã Long Thành", p: "86" },
  { c: "29533", n: "Xã Long Vĩnh", p: "86" },
  { c: "29077", n: "Xã Lộc Thuận", p: "86" },
  { c: "29857", n: "Xã Lục Sĩ Thành", p: "86" },
  { c: "28987", n: "Xã Lương Hoà", p: "86" },
  { c: "28993", n: "Xã Lương Phú", p: "86" },
  { c: "29476", n: "Xã Lưu Nghiệp Anh", p: "86" },
  { c: "28903", n: "Xã Mỏ Cày", p: "86" },
  { c: "29122", n: "Xã Mỹ Chánh Hoà", p: "86" },
  { c: "29419", n: "Xã Mỹ Long", p: "86" },
  { c: "29788", n: "Xã Mỹ Thuận", p: "86" },
  { c: "29767", n: "Xã Ngãi Tứ", p: "86" },
  { c: "29530", n: "Xã Ngũ Lạc", p: "86" },
  { c: "29302", n: "Xã Nhị Long", p: "86" },
  { c: "29446", n: "Xã Nhị Trường", p: "86" },
  { c: "29623", n: "Xã Nhơn Phú", p: "86" },
  { c: "28948", n: "Xã Nhuận Phú Tân", p: "86" },
  { c: "29329", n: "Xã Phong Thạnh", p: "86" },
  { c: "28879", n: "Xã Phú Phụng", p: "86" },
  { c: "29611", n: "Xã Phú Quới", p: "86" },
  { c: "29062", n: "Xã Phú Thuận", p: "86" },
  { c: "28810", n: "Xã Phú Túc", p: "86" },
  { c: "29020", n: "Xã Phước Long", p: "86" },
  { c: "28915", n: "Xã Phước Mỹ Trung", p: "86" },
  { c: "29668", n: "Xã Quới An", p: "86" },
  { c: "29191", n: "Xã Quới Điền", p: "86" },
  { c: "29677", n: "Xã Quới Thiện", p: "86" },
  { c: "29386", n: "Xã Song Lộc", p: "86" },
  { c: "29740", n: "Xã Song Phú", p: "86" },
  { c: "29719", n: "Xã Tam Bình", p: "86" },
  { c: "29335", n: "Xã Tam Ngãi", p: "86" },
  { c: "29278", n: "Xã Tân An", p: "86" },
  { c: "29029", n: "Xã Tân Hào", p: "86" },
  { c: "29371", n: "Xã Tân Hoà", p: "86" },
  { c: "29653", n: "Xã Tân Long Hội", p: "86" },
  { c: "29785", n: "Xã Tân Lược", p: "86" },
  { c: "28840", n: "Xã Tân Phú", p: "86" },
  { c: "29800", n: "Xã Tân Quới", p: "86" },
  { c: "28921", n: "Xã Tân Thành Bình", p: "86" },
  { c: "29167", n: "Xã Tân Thuỷ", p: "86" },
  { c: "29137", n: "Xã Tân Xuân", p: "86" },
  { c: "29365", n: "Xã Tập Ngãi", p: "86" },
  { c: "29467", n: "Xã Tập Sơn", p: "86" },
  { c: "29221", n: "Xã Thạnh Hải", p: "86" },
  { c: "29227", n: "Xã Thạnh Phong", p: "86" },
  { c: "29182", n: "Xã Thạnh Phú", p: "86" },
  { c: "29104", n: "Xã Thạnh Phước", p: "86" },
  { c: "28969", n: "Xã Thành Thới", p: "86" },
  { c: "29089", n: "Xã Thạnh Trị", p: "86" },
  { c: "29107", n: "Xã Thới Thuận", p: "86" },
  { c: "28861", n: "Xã Tiên Thuỷ", p: "86" },
  { c: "29341", n: "Xã Tiểu Cần", p: "86" },
  { c: "29836", n: "Xã Trà Côn", p: "86" },
  { c: "29461", n: "Xã Trà Cú", p: "86" },
  { c: "29821", n: "Xã Trà Ôn", p: "86" },
  { c: "29683", n: "Xã Trung Hiệp", p: "86" },
  { c: "29698", n: "Xã Trung Ngãi", p: "86" },
  { c: "29659", n: "Xã Trung Thành", p: "86" },
  { c: "29431", n: "Xã Vinh Kim", p: "86" },
  { c: "28894", n: "Xã Vĩnh Thành", p: "86" },
  { c: "29845", n: "Xã Vĩnh Xuân", p: "86" },
  { c: "31108", n: "Đặc khu Kiên Hải", p: "91" },
  { c: "31078", n: "Đặc khu Phú Quốc", p: "91" },
  { c: "31105", n: "Đặc khu Thổ Châu", p: "91" },
  { c: "30292", n: "Phường Bình Đức", p: "91" },
  { c: "30316", n: "Phường Châu Đốc", p: "91" },
  { c: "30505", n: "Phường Chi Lăng", p: "91" },
  { c: "30769", n: "Phường Hà Tiên", p: "91" },
  { c: "30377", n: "Phường Long Phú", p: "91" },
  { c: "30307", n: "Phường Long Xuyên", p: "91" },
  { c: "30301", n: "Phường Mỹ Thới", p: "91" },
  { c: "30742", n: "Phường Rạch Giá", p: "91" },
  { c: "30376", n: "Phường Tân Châu", p: "91" },
  { c: "30502", n: "Phường Thới Sơn", p: "91" },
  { c: "30520", n: "Phường Tịnh Biên", p: "91" },
  { c: "30766", n: "Phường Tô Châu", p: "91" },
  { c: "30325", n: "Phường Vĩnh Tế", p: "91" },
  { c: "30760", n: "Phường Vĩnh Thông", p: "91" },
  { c: "30985", n: "Xã An Biên", p: "91" },
  { c: "30589", n: "Xã An Châu", p: "91" },
  { c: "30526", n: "Xã An Cư", p: "91" },
  { c: "31018", n: "Xã An Minh", p: "91" },
  { c: "30337", n: "Xã An Phú", p: "91" },
  { c: "30547", n: "Xã Ba Chúc", p: "91" },
  { c: "30898", n: "Xã Bình An", p: "91" },
  { c: "30826", n: "Xã Bình Giang", p: "91" },
  { c: "30607", n: "Xã Bình Hoà", p: "91" },
  { c: "30487", n: "Xã Bình Mỹ", p: "91" },
  { c: "30823", n: "Xã Bình Sơn", p: "91" },
  { c: "30445", n: "Xã Bình Thạnh Đông", p: "91" },
  { c: "30595", n: "Xã Cần Đăng", p: "91" },
  { c: "30403", n: "Xã Châu Phong", p: "91" },
  { c: "30463", n: "Xã Châu Phú", p: "91" },
  { c: "30880", n: "Xã Châu Thành", p: "91" },
  { c: "30628", n: "Xã Chợ Mới", p: "91" },
  { c: "30409", n: "Xã Chợ Vàm", p: "91" },
  { c: "30580", n: "Xã Cô Tô", p: "91" },
  { c: "30643", n: "Xã Cù Lao Giêng", p: "91" },
  { c: "30958", n: "Xã Định Hoà", p: "91" },
  { c: "30709", n: "Xã Định Mỹ", p: "91" },
  { c: "31024", n: "Xã Đông Hoà", p: "91" },
  { c: "31036", n: "Xã Đông Hưng", p: "91" },
  { c: "31006", n: "Xã Đông Thái", p: "91" },
  { c: "30796", n: "Xã Giang Thành", p: "91" },
  { c: "30904", n: "Xã Giồng Riềng", p: "91" },
  { c: "30952", n: "Xã Gò Quao", p: "91" },
  { c: "30790", n: "Xã Hoà Điền", p: "91" },
  { c: "30934", n: "Xã Hoà Hưng", p: "91" },
  { c: "30430", n: "Xã Hoà Lạc", p: "91" },
  { c: "30949", n: "Xã Hoà Thuận", p: "91" },
  { c: "30817", n: "Xã Hòn Đất", p: "91" },
  { c: "30814", n: "Xã Hòn Nghệ", p: "91" },
  { c: "30673", n: "Xã Hội An", p: "91" },
  { c: "30341", n: "Xã Khánh Bình", p: "91" },
  { c: "30787", n: "Xã Kiên Lương", p: "91" },
  { c: "30631", n: "Xã Long Điền", p: "91" },
  { c: "30664", n: "Xã Long Kiến", p: "91" },
  { c: "30943", n: "Xã Long Thạnh", p: "91" },
  { c: "30469", n: "Xã Mỹ Đức", p: "91" },
  { c: "30313", n: "Xã Mỹ Hoà Hưng", p: "91" },
  { c: "30838", n: "Xã Mỹ Thuận", p: "91" },
  { c: "30928", n: "Xã Ngọc Chúc", p: "91" },
  { c: "30346", n: "Xã Nhơn Hội", p: "91" },
  { c: "30658", n: "Xã Nhơn Mỹ", p: "91" },
  { c: "30538", n: "Xã Núi Cấm", p: "91" },
  { c: "30688", n: "Xã Óc Eo", p: "91" },
  { c: "30577", n: "Xã Ô Lâm", p: "91" },
  { c: "30436", n: "Xã Phú An", p: "91" },
  { c: "30685", n: "Xã Phú Hoà", p: "91" },
  { c: "30352", n: "Xã Phú Hữu", p: "91" },
  { c: "30421", n: "Xã Phú Lâm", p: "91" },
  { c: "30406", n: "Xã Phú Tân", p: "91" },
  { c: "30811", n: "Xã Sơn Hải", p: "91" },
  { c: "30835", n: "Xã Sơn Kiên", p: "91" },
  { c: "30388", n: "Xã Tân An", p: "91" },
  { c: "30850", n: "Xã Tân Hiệp", p: "91" },
  { c: "30856", n: "Xã Tân Hội", p: "91" },
  { c: "31031", n: "Xã Tân Thạnh", p: "91" },
  { c: "30691", n: "Xã Tây Phú", p: "91" },
  { c: "30988", n: "Xã Tây Yên", p: "91" },
  { c: "30874", n: "Xã Thạnh Đông", p: "91" },
  { c: "30910", n: "Xã Thạnh Hưng", p: "91" },
  { c: "30886", n: "Xã Thạnh Lộc", p: "91" },
  { c: "30481", n: "Xã Thạnh Mỹ Tây", p: "91" },
  { c: "30682", n: "Xã Thoại Sơn", p: "91" },
  { c: "30781", n: "Xã Tiên Hải", p: "91" },
  { c: "30544", n: "Xã Tri Tôn", p: "91" },
  { c: "31027", n: "Xã U Minh Thượng", p: "91" },
  { c: "31042", n: "Xã Vân Khánh", p: "91" },
  { c: "30604", n: "Xã Vĩnh An", p: "91" },
  { c: "31064", n: "Xã Vĩnh Bình", p: "91" },
  { c: "30793", n: "Xã Vĩnh Điều", p: "91" },
  { c: "30568", n: "Xã Vĩnh Gia", p: "91" },
  { c: "30619", n: "Xã Vĩnh Hanh", p: "91" },
  { c: "30367", n: "Xã Vĩnh Hậu", p: "91" },
  { c: "31012", n: "Xã Vĩnh Hoà", p: "91" },
  { c: "30970", n: "Xã Vĩnh Hoà Hưng", p: "91" },
  { c: "31051", n: "Xã Vĩnh Phong", p: "91" },
  { c: "30478", n: "Xã Vĩnh Thạnh Trung", p: "91" },
  { c: "31069", n: "Xã Vĩnh Thuận", p: "91" },
  { c: "30697", n: "Xã Vĩnh Trạch", p: "91" },
  { c: "30982", n: "Xã Vĩnh Tuy", p: "91" },
  { c: "30385", n: "Xã Vĩnh Xương", p: "91" },
  { c: "31150", n: "Phường An Bình", p: "92" },
  { c: "31168", n: "Phường Bình Thuỷ", p: "92" },
  { c: "31120", n: "Phường Cái Khế", p: "92" },
  { c: "31186", n: "Phường Cái Răng", p: "92" },
  { c: "31411", n: "Phường Đại Thành", p: "92" },
  { c: "31201", n: "Phường Hưng Phú", p: "92" },
  { c: "31789", n: "Phường Khánh Hoà", p: "92" },
  { c: "31473", n: "Phường Long Bình", p: "92" },
  { c: "31471", n: "Phường Long Mỹ", p: "92" },
  { c: "31480", n: "Phường Long Phú 1", p: "92" },
  { c: "31183", n: "Phường Long Tuyền", p: "92" },
  { c: "31753", n: "Phường Mỹ Quới", p: "92" },
  { c: "31684", n: "Phường Mỹ Xuyên", p: "92" },
  { c: "31340", n: "Phường Ngã Bảy", p: "92" },
  { c: "31732", n: "Phường Ngã Năm", p: "92" },
  { c: "31135", n: "Phường Ninh Kiều", p: "92" },
  { c: "31153", n: "Phường Ô Môn", p: "92" },
  { c: "31510", n: "Phường Phú Lợi", p: "92" },
  { c: "31162", n: "Phường Phước Thới", p: "92" },
  { c: "31507", n: "Phường Sóc Trăng", p: "92" },
  { c: "31147", n: "Phường Tân An", p: "92" },
  { c: "31213", n: "Phường Tân Lộc", p: "92" },
  { c: "31207", n: "Phường Thốt Nốt", p: "92" },
  { c: "31174", n: "Phường Thới An Đông", p: "92" },
  { c: "31157", n: "Phường Thới Long", p: "92" },
  { c: "31228", n: "Phường Thuận Hưng", p: "92" },
  { c: "31217", n: "Phường Trung Nhứt", p: "92" },
  { c: "31333", n: "Phường Vị Tân", p: "92" },
  { c: "31321", n: "Phường Vị Thanh", p: "92" },
  { c: "31783", n: "Phường Vĩnh Châu", p: "92" },
  { c: "31804", n: "Phường Vĩnh Phước", p: "92" },
  { c: "31531", n: "Xã An Lạc Thôn", p: "92" },
  { c: "31594", n: "Xã An Ninh", p: "92" },
  { c: "31615", n: "Xã An Thạnh", p: "92" },
  { c: "31366", n: "Xã Châu Thành", p: "92" },
  { c: "31261", n: "Xã Cờ Đỏ", p: "92" },
  { c: "31633", n: "Xã Cù Lao Dung", p: "92" },
  { c: "31561", n: "Xã Đại Hải", p: "92" },
  { c: "31645", n: "Xã Đại Ngãi", p: "92" },
  { c: "31273", n: "Xã Đông Hiệp", p: "92" },
  { c: "31369", n: "Xã Đông Phước", p: "92" },
  { c: "31282", n: "Xã Đông Thuận", p: "92" },
  { c: "31726", n: "Xã Gia Hoà", p: "92" },
  { c: "31396", n: "Xã Hiệp Hưng", p: "92" },
  { c: "31393", n: "Xã Hoà An", p: "92" },
  { c: "31338", n: "Xã Hoả Lựu", p: "92" },
  { c: "31717", n: "Xã Hoà Tú", p: "92" },
  { c: "31570", n: "Xã Hồ Đắc Kiện", p: "92" },
  { c: "31528", n: "Xã Kế Sách", p: "92" },
  { c: "31810", n: "Xã Lai Hoà", p: "92" },
  { c: "31759", n: "Xã Lâm Tân", p: "92" },
  { c: "31679", n: "Xã Lịch Hội Thượng", p: "92" },
  { c: "31675", n: "Xã Liêu Tú", p: "92" },
  { c: "31579", n: "Xã Long Hưng", p: "92" },
  { c: "31639", n: "Xã Long Phú", p: "92" },
  { c: "31492", n: "Xã Lương Tâm", p: "92" },
  { c: "31591", n: "Xã Mỹ Hương", p: "92" },
  { c: "31603", n: "Xã Mỹ Phước", p: "92" },
  { c: "31567", n: "Xã Mỹ Tú", p: "92" },
  { c: "31723", n: "Xã Ngọc Tố", p: "92" },
  { c: "31315", n: "Xã Nhơn Ái", p: "92" },
  { c: "31552", n: "Xã Nhơn Mỹ", p: "92" },
  { c: "31708", n: "Xã Nhu Gia", p: "92" },
  { c: "31299", n: "Xã Phong Điền", p: "92" },
  { c: "31537", n: "Xã Phong Nẫm", p: "92" },
  { c: "31378", n: "Xã Phú Hữu", p: "92" },
  { c: "31756", n: "Xã Phú Lộc", p: "92" },
  { c: "31569", n: "Xã Phú Tâm", p: "92" },
  { c: "31420", n: "Xã Phụng Hiệp", p: "92" },
  { c: "31426", n: "Xã Phương Bình", p: "92" },
  { c: "31687", n: "Xã Tài Văn", p: "92" },
  { c: "31399", n: "Xã Tân Bình", p: "92" },
  { c: "31342", n: "Xã Tân Hoà", p: "92" },
  { c: "31741", n: "Xã Tân Long", p: "92" },
  { c: "31432", n: "Xã Tân Phước Hưng", p: "92" },
  { c: "31666", n: "Xã Tân Thạnh", p: "92" },
  { c: "31231", n: "Xã Thạnh An", p: "92" },
  { c: "31408", n: "Xã Thạnh Hoà", p: "92" },
  { c: "31249", n: "Xã Thạnh Phú", p: "92" },
  { c: "31246", n: "Xã Thạnh Quới", p: "92" },
  { c: "31699", n: "Xã Thạnh Thới An", p: "92" },
  { c: "31360", n: "Xã Thạnh Xuân", p: "92" },
  { c: "31540", n: "Xã Thới An Hội", p: "92" },
  { c: "31264", n: "Xã Thới Hưng", p: "92" },
  { c: "31258", n: "Xã Thới Lai", p: "92" },
  { c: "31582", n: "Xã Thuận Hoà", p: "92" },
  { c: "31673", n: "Xã Trần Đề", p: "92" },
  { c: "31255", n: "Xã Trung Hưng", p: "92" },
  { c: "31654", n: "Xã Trường Khánh", p: "92" },
  { c: "31309", n: "Xã Trường Long", p: "92" },
  { c: "31348", n: "Xã Trường Long Tây", p: "92" },
  { c: "31288", n: "Xã Trường Thành", p: "92" },
  { c: "31294", n: "Xã Trường Xuân", p: "92" },
  { c: "31465", n: "Xã Vị Thanh 1", p: "92" },
  { c: "31441", n: "Xã Vị Thuỷ", p: "92" },
  { c: "31795", n: "Xã Vĩnh Hải", p: "92" },
  { c: "31777", n: "Xã Vĩnh Lợi", p: "92" },
  { c: "31232", n: "Xã Vĩnh Thạnh", p: "92" },
  { c: "31453", n: "Xã Vĩnh Thuận Đông", p: "92" },
  { c: "31237", n: "Xã Vĩnh Trinh", p: "92" },
  { c: "31459", n: "Xã Vĩnh Tường", p: "92" },
  { c: "31489", n: "Xã Vĩnh Viễn", p: "92" },
  { c: "31495", n: "Xã Xà Phiên", p: "92" },
  { c: "32002", n: "Phường An Xuyên", p: "96" },
  { c: "31825", n: "Phường Bạc Liêu", p: "96" },
  { c: "31942", n: "Phường Giá Rai", p: "96" },
  { c: "31840", n: "Phường Hiệp Thành", p: "96" },
  { c: "32041", n: "Phường Hoà Thành", p: "96" },
  { c: "31951", n: "Phường Láng Tròn", p: "96" },
  { c: "32014", n: "Phường Lý Văn Lâm", p: "96" },
  { c: "32025", n: "Phường Tân Thành", p: "96" },
  { c: "31834", n: "Phường Vĩnh Trạch", p: "96" },
  { c: "31988", n: "Xã An Trạch", p: "96" },
  { c: "32069", n: "Xã Biển Bạch", p: "96" },
  { c: "32212", n: "Xã Cái Đôi Vàm", p: "96" },
  { c: "32128", n: "Xã Cái Nước", p: "96" },
  { c: "31894", n: "Xã Châu Thới", p: "96" },
  { c: "32104", n: "Xã Đá Bạc", p: "96" },
  { c: "32152", n: "Xã Đầm Dơi", p: "96" },
  { c: "32201", n: "Xã Đất Mới", p: "96" },
  { c: "32248", n: "Xã Đất Mũi", p: "96" },
  { c: "31993", n: "Xã Định Thành", p: "96" },
  { c: "31975", n: "Xã Đông Hải", p: "96" },
  { c: "31972", n: "Xã Gành Hào", p: "96" },
  { c: "31891", n: "Xã Hoà Bình", p: "96" },
  { c: "32092", n: "Xã Hồ Thị Kỷ", p: "96" },
  { c: "31843", n: "Xã Hồng Dân", p: "96" },
  { c: "31906", n: "Xã Hưng Hội", p: "96" },
  { c: "32140", n: "Xã Hưng Mỹ", p: "96" },
  { c: "32059", n: "Xã Khánh An", p: "96" },
  { c: "32110", n: "Xã Khánh Bình", p: "96" },
  { c: "32119", n: "Xã Khánh Hưng", p: "96" },
  { c: "32062", n: "Xã Khánh Lâm", p: "96" },
  { c: "31985", n: "Xã Long Điền", p: "96" },
  { c: "32134", n: "Xã Lương Thế Trân", p: "96" },
  { c: "32191", n: "Xã Năm Căn", p: "96" },
  { c: "32044", n: "Xã Nguyễn Phích", p: "96" },
  { c: "32227", n: "Xã Nguyễn Việt Khái", p: "96" },
  { c: "31849", n: "Xã Ninh Quới", p: "96" },
  { c: "31864", n: "Xã Ninh Thạnh Lợi", p: "96" },
  { c: "32244", n: "Xã Phan Ngọc Hiển", p: "96" },
  { c: "31885", n: "Xã Phong Hiệp", p: "96" },
  { c: "31957", n: "Xã Phong Thạnh", p: "96" },
  { c: "32214", n: "Xã Phú Mỹ", p: "96" },
  { c: "32218", n: "Xã Phú Tân", p: "96" },
  { c: "31867", n: "Xã Phước Long", p: "96" },
  { c: "32182", n: "Xã Quách Phẩm", p: "96" },
  { c: "32098", n: "Xã Sông Đốc", p: "96" },
  { c: "32155", n: "Xã Tạ An Khương", p: "96" },
  { c: "32206", n: "Xã Tam Giang", p: "96" },
  { c: "32236", n: "Xã Tân Ân", p: "96" },
  { c: "32137", n: "Xã Tân Hưng", p: "96" },
  { c: "32083", n: "Xã Tân Lộc", p: "96" },
  { c: "32167", n: "Xã Tân Thuận", p: "96" },
  { c: "32188", n: "Xã Tân Tiến", p: "96" },
  { c: "32185", n: "Xã Thanh Tùng", p: "96" },
  { c: "32065", n: "Xã Thới Bình", p: "96" },
  { c: "32161", n: "Xã Trần Phán", p: "96" },
  { c: "32095", n: "Xã Trần Văn Thời", p: "96" },
  { c: "32071", n: "Xã Trí Phải", p: "96" },
  { c: "32047", n: "Xã U Minh", p: "96" },
  { c: "31927", n: "Xã Vĩnh Hậu", p: "96" },
  { c: "31858", n: "Xã Vĩnh Lộc", p: "96" },
  { c: "31900", n: "Xã Vĩnh Lợi", p: "96" },
  { c: "31918", n: "Xã Vĩnh Mỹ", p: "96" },
  { c: "31876", n: "Xã Vĩnh Phước", p: "96" },
  { c: "31882", n: "Xã Vĩnh Thanh", p: "96" },
] as const;
